/* ============================================================
   sc-components.js
   Reusable render functions for every component listed in
   the design decisions document. Each function takes data
   and returns an HTML string. Pages compose these.

   Change a component once here, it changes on every page.
   ============================================================ */

window.SC = window.SC || {};
SC.components = SC.components || {};

/* ============================================================
   HEADER + NAV
   ============================================================ */
SC.components.topbar = function() {
  return '<div class="sc-topbar">Handmade in the UK · since 1995 · samples in your hands within a week</div>';
};

SC.components.header = function(opts) {
  opts = opts || {};
  var current = opts.current || '';
  var isCurrent = function(key) { return current === key ? ' style="color:var(--navy);font-weight:500;"' : ''; };

  return '' +
    '<header class="sc-header">' +
      '<div class="sc-header-inner">' +
        '<a href="index.html" class="sc-brand"><img src="assets/img/logo-horizontal-navy.png" alt="Sophie Conran" /></a>' +
        '<nav class="sc-nav" aria-label="Primary">' +
          '<ul class="sc-nav-list">' +
            '<li><a href="index.html" class="sc-nav-link"' + isCurrent('home') + '>Sofas</a></li>' +
            '<li><a href="/pages/gallery" class="sc-nav-link"' + isCurrent('gallery') + '>Gallery</a></li>' +
            '<li><a href="bed-linen.html" class="sc-nav-link"' + isCurrent('bed-linen') + '>Bed linen</a></li>' +
            '<li><a href="portmeirion.html" class="sc-nav-link"' + isCurrent('portmeirion') + '>Portmeirion</a></li>' +
            '<li><a href="sophies-world.html" class="sc-nav-link' + (opts.current === 'sophies-world' ? ' is-active' : '') + '">Sophie\'s world</a></li>' +
            '<li><a href="in-stock-now.html" class="sc-nav-link"' + isCurrent('stock') + '>In stock now</a></li>' +
            '<li><a href="will-it-fit.html" class="sc-nav-link sc-nav-link-tool"' + isCurrent('will-it-fit') + '>' + SC.components.tapeMeasureIcon(16) + '<span>Will it fit?</span></a></li>' +
            '<li><a href="trade.html" class="sc-nav-link is-trade">Trade</a></li>' +
          '</ul>' +
        '</nav>' +
        '<div class="sc-header-icons">' +
          '<a class="sc-header-account" data-sc-account-link href="#">Sign in</a>' +
          '<button class="sc-icon-btn" aria-label="Search"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><circle cx="10.5" cy="10.5" r="7"/><path d="M21 21l-5.2-5.2"/></svg></button>' +
          '<button class="sc-icon-btn sc-icon-btn-fav" aria-label="Wishlist"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21C12 21 3.5 15.5 2 10.5 0.5 5.5 4 3 7 3c1.8 0 3.5 1 5 3 1.5-2 3.2-3 5-3 3 0 6.5 2.5 5 7.5C20.5 15.5 12 21 12 21z"/></svg></button>' +
          '<button class="sc-icon-btn sc-icon-btn-cart" aria-label="Basket" data-sc-cart-open>' +
            '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
            '<span class="sc-cart-badge" data-sc-cart-badge style="display:none">0</span>' +
          '</button>' +
          '<button class="sc-icon-btn sc-hamburger" aria-label="Menu" data-sc-drawer-open><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"><path d="M3 7h18"/><path d="M3 12h18"/><path d="M3 17h18"/></svg></button>' +
        '</div>' +
      '</div>' +
    '</header>' +

    '<aside class="sc-drawer" id="sc-drawer" aria-hidden="true">' +
      '<div class="sc-drawer-header">' +
        '<a href="index.html" class="sc-brand"><img src="assets/img/logo-horizontal-navy.png" alt="Sophie Conran" /></a>' +
        '<button class="sc-icon-btn" aria-label="Close menu" data-sc-drawer-close>×</button>' +
      '</div>' +
      '<ul class="sc-drawer-list">' +
        '<li><a href="#" data-sc-account-link><span class="eyebrow">Saved builds</span>Sign in</a></li>' +
        '<li><a href="index.html"><span class="eyebrow">Furniture</span>Sofas</a></li>' +
        '<li><a href="/pages/gallery"><span class="eyebrow">Pin, save, download as PDF</span>Gallery</a></li>' +
        '<li><a href="bed-linen.html"><span class="eyebrow">The Scalloped range</span>Bed linen</a></li>' +
        '<li><a href="portmeirion.html"><span class="eyebrow">Twenty years of partnership</span>Portmeirion</a></li>' +
        '<li><a href="john-lewis.html"><span class="eyebrow">Cocobella & Felix</span>John Lewis</a></li>' +
        '<li><a href="#"><span class="eyebrow">Beds & Mattresses</span>Dreams</a></li>' +
        '<li><a href="sophies-world.html"><span class="eyebrow">Recipes, journal, brand</span>Sophie\'s world</a></li>' +
        '<li><a href="in-stock-now.html"><span class="eyebrow">Ready in 3 to 6 weeks</span>In stock now</a></li>' +
        '<li><a href="will-it-fit.html"><span class="eyebrow">Real dimensions, honest answer</span>Will it fit?</a></li>' +
        '<li><a href="trade.html"><span class="eyebrow">B2B portal</span>Trade</a></li>' +
      '</ul>' +
    '</aside>';
};

SC.components.headerTrade = function() {
  var account = SC.tradeAccount;
  return '' +
    '<header class="sc-header sc-header--trade">' +
      '<div class="sc-header-inner">' +
        '<a href="trade.html" class="sc-brand"><img src="assets/img/logo-horizontal-white.png" alt="Sophie Conran" /></a>' +
        '<nav class="sc-nav" aria-label="Trade">' +
          '<ul class="sc-nav-list">' +
            '<li><a href="#" class="sc-nav-link">Range</a></li>' +
            '<li><a href="#" class="sc-nav-link">Configurator</a></li>' +
            '<li><a href="#" class="sc-nav-link">Quote builder</a></li>' +
            '<li><a href="#" class="sc-nav-link">Resources</a></li>' +
            '<li><a href="#" class="sc-nav-link">Orders</a></li>' +
          '</ul>' +
        '</nav>' +
        '<div class="sc-header-icons">' +
          '<span class="sc-account-name">' + account.name + ' ▾</span>' +
        '</div>' +
      '</div>' +
    '</header>';
};

/* ============================================================
   HERO LIFESTYLE (home page)
   ============================================================ */

/* Hero lifestyle, partner variant (John Lewis page) */

/* Hero colour-led (bed linen) */

/* Hero trade (dashboard) */

/* ============================================================
   STOCK STRIP / STOCK CARD
   ============================================================ */

/* ============================================================
   URL RESOLVER
   ============================================================
   Maps (range, size) tuples to the right dedicated PDP file. Anything
   not in the map falls back to the legacy product-coco-2-5.html?range=X
   page, which still renders correctly via the test-mode banner. */
SC.urls = SC.urls || {};
SC.urls.pdpFor = function(range, size) {
  var key = (range || '') + '|' + (size || '');
  var map = {
    'coco|2-seater':       'product-coco-2.html',
    'coco|2.5-seater':     'product-coco-2-5.html',
    'coco|3-seater':       'product-coco-3.html',
    'coco|3.5-seater':     'product-coco-3-5.html',
    'coco|4-seater':       'product-coco-4.html',
    'coco|loveseat':       'product-coco-loveseat.html',
    'coco|1.5-seater':     'product-coco-loveseat.html',
    'coco|sofa-bed':       'product-coco-sofa-bed.html',
    'coco-bed-sofa|2.5-seater': 'product-coco-sofa-bed.html',
    'felix|3-seater':      'product-felix-3.html',
    'felix|4-seater':      'product-felix-4.html',
    'felix|armchair':      'product-felix-chair.html',
    'felix|chair':         'product-felix-chair.html'
  };
  if (map[key]) return map[key];
  /* Range-level fallback: send anyone clicking a Coco card without a known
     size to the 2.5-seater PDP; everyone else uses the test-mode shared
     page with ?range= so the configurator still picks the right rules. */
  if (range === 'coco') return 'product-coco-2-5.html';
  if (range && SC.configurationRules && SC.configurationRules[range]) {
    return 'product-coco-2-5.html?range=' + encodeURIComponent(range);
  }
  return 'product-coco-2-5.html';
};


/* Photo helper for sofas with fabric variation. Optional imageKey looks up SC.images.stock */

/* ============================================================
   COLLECTION GRID (range tiles)
   ============================================================ */


/* ============================================================
   TOP SELLERS STRIP
   ============================================================
   Data-driven strip of the UK top sellers (2025-26 units, analytics export
   2026-05-13). Each tile uses the first image from the dedicated product
   gallery in SC.images.product and links to the matching PDP. Anything we
   don't have a dedicated PDP for is excluded (Salthrop is John Lewis
   exclusive and never appears here). */
SC.topSellersUK = [
  /* rank by units 2025+2026, then by 2026-only tie-break */
  { rank: 1,  range: 'Coco',  size: '3-seater',   units: 20, productKey: 'coco_3',         href: 'product-coco-3.html',         fromPrice: 6420 },
  { rank: 2,  range: 'Coco',  size: '2.5-seater', units: 20, productKey: 'coco_2_5',       href: 'product-coco-2-5.html',       fromPrice: 5895 },
  { rank: 3,  range: 'Coco',  size: '3.5-seater', units: 17, productKey: 'coco_3_5',       href: 'product-coco-3-5.html',       fromPrice: 6950 },
  { rank: 4,  range: 'Coco',  size: 'Loveseat',   units: 11, productKey: 'coco_loveseat',  href: 'product-coco-loveseat.html',  fromPrice: 4895 },
  { rank: 5,  range: 'Felix', size: '3-seater',   units: 9,  productKey: 'felix_3',        href: 'product-felix-3.html',        fromPrice: 4430 },
  { rank: 6,  range: 'Coco',  size: 'Sofa Bed',   units: 6,  productKey: 'coco_sofa_bed',  href: 'product-coco-sofa-bed.html',  fromPrice: 4385 },
  { rank: 7,  range: 'Coco',  size: '4-seater',   units: 6,  productKey: 'coco_4',         href: 'product-coco-4.html',         fromPrice: 7420 },
  { rank: 8,  range: 'Coco',  size: '2-seater',   units: 6,  productKey: 'coco_2',         href: 'product-coco-2.html',         fromPrice: 5395 },
  { rank: 9,  range: 'Felix', size: '4-seater',   units: 4,  productKey: 'felix_4',        href: 'product-felix-4.html',        fromPrice: 4895 },
  { rank: 10, range: 'Felix', size: 'Armchair',   units: 6,  productKey: 'felix_chair',    href: 'product-felix-chair.html',    fromPrice: 2150 }
];



/* ============================================================
   SOPHIE'S WORLD CONTENT TILES
   ============================================================ */
/* Nadia introduction block: dark navy panel inviting a conversation.
   Sits between the "five things" section and the journal tiles on the home page.
   Click "Start the conversation" expands the inline panel below the hero in D2C mode. */

/* ============================================================
   SOPHIE'S WORLD — asymmetric scrapbook moodboard
   Mixed-media editorial section. Articles, Instagram tiles,
   and pull quotes share a single 6-column grid where each item
   declares its own span and a small tilt for the paper feel.
   ============================================================ */

function renderMoodboardItem(item, articles) {
  var spanStyle = 'grid-column: span ' + (item.cols || 2) + '; grid-row: span ' + (item.rows || 1) + ';';
  // Tilts removed by request: all cards sit parallel, asymmetry comes from spans only
  var fullStyle = spanStyle;

  if (item.type === 'article') {
    var a = articles[item.key];
    if (!a) return '';
    var horizontalCls = (item.rows === 1) ? ' sc-sw-card-article-horizontal' : '';
    return '' +
      '<a class="sc-sw-card sc-sw-card-article' + horizontalCls + '" href="' + a.url + '" target="_blank" rel="noopener" style="' + fullStyle + '">' +
        '<div class="sc-sw-card-image">' +
          '<img src="' + a.image + '" alt="' + a.title + '" loading="lazy" />' +
        '</div>' +
        '<div class="sc-sw-card-body">' +
          '<div class="sc-sw-card-eyebrow">' + (item.caption || a.eyebrow) + '</div>' +
          '<h3 class="sc-sw-card-title">' + a.title + '</h3>' +
        '</div>' +
      '</a>';
  }

  if (item.type === 'instagram') {
    var igHandle = item.handle || '@sophieconranofficial';
    var videoBadge = item.isVideo ? '<span class="sc-sw-ig-video">▶</span>' : '';
    return '' +
      '<a class="sc-sw-card sc-sw-card-instagram" href="' + item.permalink + '" target="_blank" rel="noopener" style="' + fullStyle + '">' +
        '<div class="sc-sw-card-image">' +
          '<img src="' + item.image + '" alt="Instagram post" loading="lazy" />' +
          videoBadge +
        '</div>' +
        '<div class="sc-sw-card-body">' +
          '<div class="sc-sw-ig-meta">' +
            '<span class="sc-sw-ig-icon" aria-hidden="true">' +
              '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4.5"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>' +
            '</span>' +
            '<span class="sc-sw-ig-handle">' + igHandle + '</span>' +
          '</div>' +
          '<p class="sc-sw-ig-caption">' + item.caption + '</p>' +
        '</div>' +
      '</a>';
  }

  if (item.type === 'quote') {
    var tone = item.tone || 'cream';
    return '' +
      '<div class="sc-sw-card sc-sw-card-quote sc-sw-card-quote--' + tone + '" style="' + fullStyle + '">' +
        '<div class="sc-sw-quote-mark" aria-hidden="true">&ldquo;</div>' +
        '<blockquote class="sc-sw-quote-text">' + item.quote + '</blockquote>' +
        (item.attribution ? '<cite class="sc-sw-quote-attribution">' + item.attribution + '</cite>' : '') +
      '</div>';
  }

  return '';
}


/* ============================================================
   CUSTOMER WALL (4 reviews)
   ============================================================ */


/* ============================================================
   CROSS-SELL ("Other ways to live")
   ============================================================ */
SC.components.crossSell = function(opts) {
  opts = opts || {};
  var X = (SC.images && SC.images.crossSell) || {};
  function withImg(url, fallbackInner, alt) {
    if (url) {
      return '<img class="sc-tile-photo" src="' + url + '" alt="' + (alt || '') + '" loading="lazy" />';
    }
    return fallbackInner;
  }
  // Three options keyed by id
  var library = {
    'portmeirion': {
      href: 'portmeirion.html',
      title: 'Tableware at Portmeirion',
      desc: '20 years of collaboration · in stores worldwide',
      image: withImg(X.portmeirion, '<div class="sc-photo sc-photo-plate" style="--plate-colour:#A8C0BC;--plate-accent:#7A9590;" data-caption="Floret"></div>', 'Portmeirion tableware')
    },
    'john-lewis': {
      href: 'john-lewis.html',
      title: 'Cocobella at John Lewis',
      desc: 'Sister to the Coco · 0% finance',
      image: withImg(X.johnLewis, '<div class="sc-photo sc-photo-jl sc-photo-sofa" style="--sofa-colour:#A8B5C9;--sofa-accent:#3F5777;--cushion-colour:#3F5777;" data-caption="Cocobella"><div class="sc-photo-sofa-cushions"><span></span><span style="background:#3F5777;"></span></div></div>', 'Cocobella sofa at John Lewis')
    },
    'dreams': {
      href: '#',
      title: 'Beds at Dreams',
      desc: 'Mattresses & bed frames',
      image: withImg(X.dreams, '<div class="sc-photo sc-photo-bedroom" style="--linen-colour:#7A8B6F;" data-caption="Sophie Conran for Dreams"></div>', 'Sophie Conran beds at Dreams')
    },
    'glassware': {
      href: '#',
      title: 'Glassware on this site',
      desc: 'The Vintage List collaboration · hand-cut, etched',
      image: withImg(X.glassware, '<div class="sc-photo sc-photo-room-3" data-caption="Vintage List glassware"></div>', 'Vintage List glassware')
    },
    'coco-direct': {
      href: 'product-coco-2-5.html',
      title: 'Shop the Coco direct',
      desc: 'Full bespoke and all-natural materials',
      image: withImg(X.cocoDirect, '<div class="sc-photo sc-photo-room-1 sc-photo-sofa" style="--sofa-colour:#E8DDC9;--cushion-colour:#A8C0BC;" data-caption="Coco in Cool Coconut"><div class="sc-photo-sofa-cushions"><span></span><span style="background:#A8C0BC;"></span></div></div>', 'Coco 2.5-seater in Sea Salt')
    },
    'bed-linen': {
      href: 'bed-linen.html',
      title: 'Bed linen on this site',
      desc: 'The Scalloped collection · eight colours',
      image: withImg(X.bedLinen, '<div class="sc-photo sc-photo-bedroom" style="--linen-colour:#1B2D4A;" data-caption="Navy Scalloped"></div>', 'Green Scalloped bed linen')
    }
  };

  var keys = opts.keys || ['portmeirion', 'john-lewis', 'dreams'];
  var title = opts.title || 'Other ways to live with Sophie';
  var sub = opts.sub || 'Beyond our own range, Sophie\'s designs are available through trusted partners.';

  var items = keys.map(function(k) {
    var it = library[k];
    return '' +
      '<a class="sc-cross-sell-item" href="' + it.href + '">' +
        '<div class="sc-cross-sell-image">' + it.image + '</div>' +
        '<h4>' + it.title + '</h4>' +
        '<p>' + it.desc + '</p>' +
      '</a>';
  }).join('');

  return '' +
    '<section class="sc-section sc-section-paper-warm">' +
      '<div class="sc-container-wide">' +
        '<div class="sc-section-head">' +
          '<div class="sc-eyebrow">' + (opts.eyebrow || 'Sophie Conran, beyond the sofa') + '</div>' +
          '<h2 class="sc-display-2">' + title + '</h2>' +
          '<p>' + sub + '</p>' +
        '</div>' +
        '<div class="sc-cross-sell-grid">' + items + '</div>' +
      '</div>' +
    '</section>';
};

/* ============================================================
   BEYOND THE SOFA — editorial double feature
   Two large editorial cards, one for Bed linen, one for
   Portmeirion. Each card carries a big lifestyle image, a
   small four-up strip of secondary imagery, an eyebrow,
   heading, a few lines of words, and a clear CTA.
   Lives on the homepage, between Sophie's World and the
   customer wall, to give the non-sofa worlds a proper
   editorial moment instead of only the small cross-sell row.
   ============================================================ */

/* ============================================================
   FIT CHECKER — shared helpers
   Tape measure icon used across the site, a homepage promo band,
   and the PDP button. Centralised so the CTA looks consistent
   wherever it appears.
   ============================================================ */
SC.components.tapeMeasureIcon = function(size) {
  size = size || 20;
  return '' +
    '<svg class="sc-fc-tape" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      /* Tape measure body */
      '<rect x="2.5" y="6.5" width="14" height="11" rx="2"/>' +
      /* Wound tape inside (circle indicator) */
      '<circle cx="9.5" cy="12" r="2.5"/>' +
      /* Tape extending out, ending in metal hook tab */
      '<path d="M16.5 12h3.5"/>' +
      '<path d="M20 10.5v3"/>' +
      /* Measurement tick marks below body */
      '<path d="M5 17.5v1.5M8 17.5v1"/>' +
    '</svg>';
};

SC.components.fitCheckerPromoBand = function() {
  return '' +
    '<section class="sc-fc-promo-band">' +
      '<div class="sc-container">' +
        '<div class="sc-fc-promo-inner">' +
          '<div class="sc-fc-promo-icon">' + SC.components.tapeMeasureIcon(40) + '</div>' +
          '<div class="sc-fc-promo-text">' +
            '<div class="sc-eyebrow sc-eyebrow-navy">A small but important question</div>' +
            '<h3 class="sc-fc-promo-h">Will it <em>fit</em>?</h3>' +
            '<p class="sc-fc-promo-sub">A quick guide to find out what will fit into your home.</p>' +
          '</div>' +
          '<div class="sc-fc-promo-action">' +
            '<a class="sc-btn sc-btn-primary" href="will-it-fit.html">' + SC.components.tapeMeasureIcon(16) + '<span>Open the fit checker</span></a>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</section>';
};

SC.components.fitCheckerPdpButton = function(rangeName) {
  rangeName = rangeName || 'sofa';
  return '' +
    '<div class="sc-fc-pdp-cta">' +
      '<div class="sc-fc-pdp-cta-icon">' + SC.components.tapeMeasureIcon(36) + '</div>' +
      '<div class="sc-fc-pdp-cta-text">' +
        '<div class="sc-fc-pdp-cta-title">Will your ' + rangeName + ' fit through the front door?</div>' +
        '<div class="sc-fc-pdp-cta-sub">Check your route in 30 seconds. Honest answer with real dimensions.</div>' +
      '</div>' +
      '<a class="sc-btn sc-btn-primary sc-fc-pdp-cta-btn" href="will-it-fit.html">' + SC.components.tapeMeasureIcon(16) + '<span>Open the fit checker</span></a>' +
    '</div>';
};

/* ============================================================
   ROOM QUIZ + FABRIC PICKER PROMO BANDS
   Two homepage entry points to lead-capture tools.
   Visually distinct from the Fit Checker band so they read as
   separate invitations rather than three near-identical strips.
   ============================================================ */
SC.components.roomQuizIcon = function(size) {
  size = size || 20;
  return '' +
    '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      /* House outline */
      '<path d="M3 11.5 12 4l9 7.5"/>' +
      '<path d="M5 10.5V20h14v-9.5"/>' +
      /* Sofa silhouette inside */
      '<path d="M8 16.5h8"/>' +
      '<path d="M8 16.5v-1.5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1.5"/>' +
    '</svg>';
};

SC.components.fabricSwatchIcon = function(size) {
  size = size || 20;
  return '' +
    '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      /* Stacked fabric swatches */
      '<rect x="4" y="8" width="13" height="13" rx="1"/>' +
      '<path d="M7 5h13v13"/>' +
      /* Stitch detail */
      '<path d="M7.5 11.5h6M7.5 14h6M7.5 16.5h4"/>' +
    '</svg>';
};

SC.components.roomQuizPromoBand = function() {
  return '' +
    '<section class="sc-rq-promo-band">' +
      '<div class="sc-container">' +
        '<div class="sc-rq-promo-inner">' +
          '<div class="sc-rq-promo-icon">' + SC.components.roomQuizIcon(44) + '</div>' +
          '<div class="sc-rq-promo-text">' +
            '<div class="sc-eyebrow sc-eyebrow-gold">Not sure where to start?</div>' +
            '<h3 class="sc-rq-promo-h">Find the sofa your <em>room</em> is asking for.</h3>' +
            '<p class="sc-rq-promo-sub">Five small questions, an honest recommendation from Sophie, around two minutes. No need to know your Coco from your Henrietta.</p>' +
          '</div>' +
          '<div class="sc-rq-promo-action">' +
            '<a class="sc-btn sc-btn-gold" href="room-quiz.html"><span>Take the room quiz</span></a>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</section>';
};

SC.components.fabricPickerPromoBand = function() {
  return '' +
    '<section class="sc-fp-promo-band">' +
      '<div class="sc-container">' +
        '<div class="sc-fp-promo-inner">' +
          '<div class="sc-fp-promo-icon">' + SC.components.fabricSwatchIcon(44) + '</div>' +
          '<div class="sc-fp-promo-text">' +
            '<div class="sc-eyebrow sc-eyebrow-navy">Always the best way to choose</div>' +
            '<h3 class="sc-fp-promo-h">Five fabric samples, <em>in the post</em>, free.</h3>' +
            '<p class="sc-fp-promo-sub">Choose any five fabrics from across our collection. We pop them in the post, you live with them for a few days, see them in your light. The right way to do it.</p>' +
          '</div>' +
          '<div class="sc-fp-promo-action">' +
            '<a class="sc-btn sc-btn-primary" href="fabric-picker.html"><span>Order your samples</span></a>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</section>';
};

/* ============================================================
   GALLERY TEASER
   A working slice of the gallery on the homepage. Six carefully
   chosen pins drawn straight from SC.gallery.items, rendered
   with the real .sc-pin card so the save heart works exactly as
   it does on the gallery page. A soft right-edge fade and a
   "+ more rooms" cue hint at the full set behind.

   The six pins are curated for VARIETY: different sofa shape,
   different fabric story (stripe, floral, plain, bold colour),
   different colour temperature. This is the shop window.

   This component depends on sc-gallery.js being loaded (so it
   can read SC.gallery.items and rely on the site-wide save
   heart click handler). The homepage already loads it.

   The actual mount-time wiring (counter sync, etc.) is done in
   index.html after the innerHTML write, so this function stays
   a pure renderer.
   ============================================================ */
SC.components.galleryTeaser = function() {
  /* Defensive: need the live gallery data. If sc-gallery.js / the data
     file has not loaded, render nothing rather than a broken band. */
  if (!SC.gallery || !SC.gallery.items || SC.gallery.items.length === 0) return '';

  var items = SC.gallery.items;
  var byId = {};
  items.forEach(function(it){ byId[it.id] = it; });

  /* Optional curation: if specific pin IDs are provided on the page
     (window.SC_GALLERY_TEASER_IDS), use those, in order. Otherwise pick
     six automatically. This keeps the teaser working even when the
     gallery data is regenerated (IDs change), instead of depending on
     hard-coded IDs that go stale. */
  /* CMS-supplied CDN images take priority over everything: the section
     can hand the teaser explicit image URLs (window.SC_GT_CUSTOM). */
  var custom = (typeof window !== 'undefined') && window.SC_GT_CUSTOM;
  if (custom && custom.length) {
    var customCards = custom.map(function(c) {
      return '' +
        '<a class="sc-gt-card" href="/pages/gallery' + (c.url ? '#image-' + encodeURIComponent(c.url) : '') + '" aria-label="' + (c.label || 'View gallery') + '">' +
          '<div class="sc-gt-card-img-wrap">' +
            '<img class="sc-gt-card-img" src="' + c.url + '" alt="' + (c.label || '') + '" loading="lazy" decoding="async" ' +
                 'onerror="var p=this.closest(\'.sc-gt-card\'); if(p) p.style.display=\'none\';" />' +
          '</div>' +
          (c.label ? '<div class="sc-gt-card-name">' + c.label + '</div>' : '') +
        '</a>';
    }).join('');
    return renderTeaserShell(customCards, SC.gallery.items.length);
  }

  var pins = [];
  var curated = (typeof window !== 'undefined') && window.SC_GALLERY_TEASER_IDS;
  if (curated && curated.length) {
    pins = curated.map(function(id){ return byId[id]; }).filter(Boolean);
  }

  /* Auto-select: one pin per range for variety (a spread across the
     ranges), preferring non-lifestyle-only cards, then top up to six
     from whatever remains. */
  if (pins.length < 6) {
    var seenRange = {};
    var chosen = {};
    pins.forEach(function(p){ if (p) { chosen[p.id] = true; if (p.range) seenRange[p.range] = true; } });

    // First pass: first unused pin of each not-yet-seen range
    for (var i = 0; i < items.length && pins.length < 6; i++) {
      var it = items[i];
      if (chosen[it.id]) continue;
      if (it.lifestyleOnly) continue;
      var r = it.range || ('_' + i);
      if (seenRange[r]) continue;
      seenRange[r] = true; chosen[it.id] = true; pins.push(it);
    }
    // Second pass: top up to six with any remaining (incl. lifestyle)
    for (var j = 0; j < items.length && pins.length < 6; j++) {
      var it2 = items[j];
      if (chosen[it2.id]) continue;
      chosen[it2.id] = true; pins.push(it2);
    }
  }

  pins = pins.slice(0, 6);
  if (pins.length === 0) return '';

  /* Total available — used in the "+ N more rooms" hint. We subtract
     the ones on show. */
  var moreCount = SC.gallery.items.length - pins.length;

  /* Lightweight preview card: portrait image + the model name only.
     Deliberately NOT the full SC.gallery.card() (no fabric, swatch, price,
     lead line or save heart) — the teaser is a clean visual taster that
     links through to the gallery. The gallery PAGE still uses the full card. */
  var cards = pins.map(function(it){
    var iw = it.w || it.width, ih = it.h || it.height;
    var dimsAttr = (iw && ih) ? 'width="' + iw + '" height="' + ih + '" ' : '';
    return '' +
      '<a class="sc-gt-card" href="/pages/gallery#image-' + it.id + '" aria-label="' + (it.range || 'View gallery') + '">' +
        '<div class="sc-gt-card-img-wrap">' +
          '<img class="sc-gt-card-img" src="' + it.image + '" alt="' + (it.alt || it.range || '') + '" ' +
               'loading="lazy" decoding="async" ' + dimsAttr +
               'onerror="var p=this.closest(\'.sc-gt-card\'); if(p) p.style.display=\'none\';" />' +
        '</div>' +
        '<div class="sc-gt-card-name">' + (it.range || '') + '</div>' +
      '</a>';
  }).join('');

  return renderTeaserShell(cards, moreCount);
};

/* Shared teaser shell: placeholder inspiration heading (copy TBC), the
   full-gallery button lives in the head on the right, and the old foot
   line ("Six on show...") is gone along with its whitespace. */
function renderTeaserShell(cards, moreCount) {
  return '' +
    '<section class="sc-gt">' +
      '<div class="sc-container">' +
        '<div class="sc-gt-head">' +
          '<div class="sc-gt-head-text">' +
            '<div class="sc-eyebrow sc-eyebrow-gold">Real rooms, real fabrics</div>' +
            '<h2 class="sc-gt-h">Find <em>your inspiration</em></h2>' +
            '<p class="sc-gt-sub">Come and browse our sofa gallery, there\'s lots of gorgeous images that you can save and send yourself a PDF of your favourite ones.</p>' +
          '</div>' +
          '<a class="sc-btn sc-btn-primary sc-gt-cta" href="/pages/gallery">' +
            '<span>See the full gallery</span>' +
            '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">' +
              '<path d="M5 12h14M13 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</a>' +
        '</div>' +
      '</div>' +
      '<div class="sc-gt-strip">' +
        '<div class="sc-gt-strip-inner">' +
          cards +
        '</div>' +
        '<div class="sc-gt-fade" aria-hidden="true">' +
          '<a class="sc-gt-more-pill" href="/pages/gallery">' +
            '<span class="sc-gt-more-n">+' + moreCount + '</span>' +
            '<span class="sc-gt-more-lbl">more rooms</span>' +
            '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">' +
              '<path d="M5 12h14M13 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</a>' +
        '</div>' +
      '</div>' +
    '</section>';
}

/* ============================================================
   FOOTER
   ============================================================ */
SC.components.footer = function() {
  return '' +
    '<footer class="sc-footer">' +
      '<div class="sc-footer-grid">' +
        '<div class="brand-block">' +
          '<a href="index.html" class="sc-brand sc-brand-footer"><img src="assets/img/logo-horizontal-white.png" alt="Sophie Conran" /></a>' +
          '<p>Handmade sofas and home pieces, designed in London and built in the United Kingdom. Working with Portmeirion, John Lewis, Dreams and The Vintage List for thirty years and counting.</p>' +
          '<p style="font-style:italic;font-family:var(--font-display);">Talk to Nadia, any time.</p>' +
        '</div>' +
        '<div>' +
          '<h5>The worlds</h5>' +
          '<ul>' +
            '<li><a href="index.html">Sofas</a></li>' +
            '<li><a href="bed-linen.html">Bed linen</a></li>' +
            '<li><a href="portmeirion.html">Portmeirion</a></li>' +
            '<li><a href="john-lewis.html">John Lewis</a></li>' +
            '<li><a href="#">Dreams</a></li>' +
            '<li><a href="#">Garden &amp; Outdoor</a></li>' +
            '<li><a href="#">Glassware</a></li>' +
            '<li><a href="in-stock-now.html">In stock now</a></li>' +
          '</ul>' +
        '</div>' +
        '<div>' +
          '<h5>Customer service</h5>' +
          '<ul>' +
            '<li><a href="#">My account</a></li>' +
            '<li><a href="/pages/gallery">Gallery</a></li>' +
            '<li><a href="/pages/gallery#favourites" data-sc-fav-open-link>Your favourites</a></li>' +
            '<li><a href="#">Order tracking</a></li>' +
            '<li><a href="fabric-picker.html">Free fabric samples</a></li>' +
            '<li><a href="will-it-fit.html">Will it fit?</a></li>' +
            '<li><a href="#">Care guides</a></li>' +
            '<li><a href="#">Returns &amp; warranty</a></li>' +
            '<li><a href="#">Contact us</a></li>' +
            '<li><a href="trade.html">Trade portal</a></li>' +
          '</ul>' +
        '</div>' +
        '<div>' +
          '<h5>Sophie\'s letter</h5>' +
          '<p style="font-size:13.5px;">Recipes, new fabrics, gentle thoughts on living well with what you have. About one a fortnight, written by Sophie.</p>' +
          '<form style="display:flex;gap:8px;margin-top:14px;flex-wrap:wrap;">' +
            '<input type="email" placeholder="your email" style="flex:1;min-width:160px;padding:10px 12px;background:rgba(255,255,255,0.06);border:1px solid rgba(245,239,227,0.2);color:var(--paper);font-family:var(--font-body);font-size:13px;">' +
            '<button type="button" class="sc-btn sc-btn-gold" style="padding:10px 20px;">Sign up</button>' +
          '</form>' +
        '</div>' +
      '</div>' +
      '<div class="sc-footer-bottom">' +
        '<span>© 2026 SC Group Trading Ltd. Sophie Conran is a registered trade mark.</span>' +
        '<span>Privacy · Cookies · Terms · Accessibility</span>' +
      '</div>' +
    '</footer>';
};

/* ============================================================
   NADIA SURFACES
   ============================================================ */
SC.components.nadiaWidget = function() {
  // Floating widget , bubble + FAB, hidden until controller decides
  return '' +
    '<button class="sc-nadia-fab" id="sc-nadia-fab" aria-label="Open chat with Nadia">N</button>' +
    '<div class="sc-nadia-bubble" id="sc-nadia-bubble" role="dialog" aria-label="Chat with Nadia">' +
      '<div class="sc-nadia-bubble-header">' +
        '<span class="name">Nadia, here</span>' +
        '<button class="sc-nadia-close" id="sc-nadia-close" aria-label="Close chat">×</button>' +
      '</div>' +
      '<div class="sc-nadia-messages" id="sc-nadia-messages"></div>' +
      '<div class="sc-nadia-typing" id="sc-nadia-typing">Nadia is typing</div>' +
      '<div class="sc-nadia-input-row">' +
        '<input type="text" class="sc-nadia-input" id="sc-nadia-input" placeholder="Type your message" autocomplete="off">' +
        '<button class="sc-nadia-send" id="sc-nadia-send">Send</button>' +
      '</div>' +
    '</div>';
};



/* ============================================================
   PRODUCT PAGE , gallery, configurator, lead time, cross-sell,
   customer photos, inline reviews. Built around Coco 2.5 but
   structurally reusable for any product.
   ============================================================ */

/* Jump navigation: a quiet vertical list of links that lets the customer
   skip down the page to the sections below the configurator. Lives in
   the blank space below the gallery thumbs on the left column. */
SC.components.productJumpNav = function() {
  var items = [
    { href: '#jump-dimensions', label: 'Dimensions',     hint: 'Sizes, depths, heights' },
    { href: '#jump-materials',  label: 'Materials',      hint: 'Frame, springs, fills' },
    { href: '#jump-fabrics',    label: 'Fabrics and finishes', hint: 'Free samples, care, COM' },
    { href: '#jump-care',       label: 'How to look after it', hint: 'Cleaning, wear, repairs' },
    { href: '#jump-leadtime',   label: 'Lead time and delivery', hint: 'Around 8 weeks, often sooner' },
    { href: '#jump-guarantee',  label: 'What is covered', hint: '25 year frame, 5 on everything else' }
  ];
  var links = items.map(function(it) {
    return '' +
      '<a class="sc-jump-link" href="' + it.href + '">' +
        '<span class="sc-jump-link-main">' + it.label + '</span>' +
        '<span class="sc-jump-link-hint">' + it.hint + '</span>' +
        '<span class="sc-jump-link-arrow" aria-hidden="true">&darr;</span>' +
      '</a>';
  }).join('');
  return '' +
    '<nav class="sc-jump-nav" aria-label="Jump to section">' +
      '<div class="sc-eyebrow">Jump to</div>' +
      '<div class="sc-jump-list">' + links + '</div>' +
    '</nav>';
};

/* Hero gallery: main image + thumbnail strip below.
   Initial main is gallery[0]; clicking a thumb swaps it. */
SC.components.productGallery = function(productKey) {
  var product = (SC.images && SC.images.product && SC.images.product[productKey]) || null;
  if (!product || !product.gallery || !product.gallery.length) {
    return '<div class="sc-product-gallery sc-product-gallery-empty"></div>';
  }
  var main = product.gallery[0];
  /* Save heart sits in the top-right of the hero image. Click captures
     the current configurator state (range + fabric + size + price) and
     stores it in the gallery favourites store — so customers can build a
     personal moodboard from PDP as well as from the Pinterest gallery. */
  var heartSVG = '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">' +
    '<path d="M12 21s-7.5-4.5-9.5-9.5C1 7 4 4 7.5 4c2 0 3.5 1 4.5 2.5C13 5 14.5 4 16.5 4 20 4 23 7 21.5 11.5 19.5 16.5 12 21 12 21z" ' +
    'fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '</svg>';
  var mainHtml =
    '<div class="sc-product-gallery-main">' +
      '<img class="sc-product-gallery-img" id="sc-gallery-main" src="' + main.src + '" alt="' + main.alt + '" />' +
      '<button class="sc-pdp-save" type="button" ' +
              'data-sc-pdp-save="' + productKey + '" ' +
              'aria-label="Save this build to your favourites" ' +
              'aria-pressed="false">' +
        heartSVG +
        '<span class="sc-pdp-save-label">Save</span>' +
      '</button>' +
    '</div>';
  var thumbs = product.gallery.map(function(g, i) {
    return '<button class="sc-product-gallery-thumb' + (i === 0 ? ' is-active' : '') + '" data-sc-gallery-pick="' + g.src + '" data-sc-gallery-alt="' + g.alt + '" type="button">' +
      '<img src="' + g.src + '" alt="' + g.alt + '" loading="lazy" />' +
    '</button>';
  }).join('');
  return '' +
    '<div class="sc-product-gallery">' +
      mainHtml +
      '<div class="sc-product-gallery-thumbs">' + thumbs + '</div>' +
    '</div>';
};

/* Lead time strip , sits just under price. Live tone, honest. */

/* Configurator: 3 controls, each a row of pills. The fabric direction
   row is wired to swap the gallery hero (productConfigurator owns this). */

/* ============================================================
   CONFIGURATOR — model-driven, per-range
   ============================================================
   Reads SC.configurationRules[rangeKey] and renders option groups.
   The state machine in SC.configurator manages selections, evaluates
   rules to disable invalid options, updates summary and price, and
   swaps the gallery hero image when fabric changes.

   For the demo, prices come from basePriceBySize in the rules object.
   At production time, this is replaced by a fetch() to the Vercel
   pricing calculator that returns a payload of identical shape. */
SC.components.productConfigurator = function(rangeKey) {
  /* ── Retailer handoff ──
     Cocobella, Salthrop and Felix (JLP) are made for John Lewis and cannot
     be bought here. Setting a retailer URL in the theme editor turns the
     page into a showcase: options, imagery and the build summary all keep
     working, but Add to basket becomes a link out and the price is
     suppressed, because the retailer sets it and our calculator has no
     data for these ranges. */
  var _cfgSettings = document.getElementById('sc-section-settings');
  function _setting(name, fallback) {
    if (!_cfgSettings) return fallback;
    var v = _cfgSettings.getAttribute('data-' + name);
    return (v === null || v === '') ? fallback : v;
  }
  var retailer = {
    url:   _setting('retailer-url', ''),
    name:  _setting('retailer-name', 'John Lewis'),
    label: _setting('retailer-cta-label', 'See it at John Lewis'),
    note:  _setting('retailer-note', '')
  };
  /* Belt-and-braces rangeKey resolution. The caller passes a key, but if
     none is passed (or 'coco' is passed despite ?range= being set in the
     URL), check the URL too so the configurator never silently falls back
     to Coco when a range was actually requested. */
  if ((!rangeKey || rangeKey === 'coco') && typeof window !== 'undefined' && window.location) {
    try {
      var urlRange = new URLSearchParams(window.location.search).get('range');
      if (urlRange && SC.configurationRules && SC.configurationRules[urlRange]) {
        rangeKey = urlRange;
      }
    } catch (e) { /* URLSearchParams unavailable in older browsers */ }
  }
  rangeKey = rangeKey || 'coco';
  var rules = (SC.configurationRules && SC.configurationRules[rangeKey]) || null;
  if (rules && SC.pricingApi && SC.pricingApi.applyVisibility) rules = SC.pricingApi.applyVisibility(rules);
  if (!rules) return '<div class="sc-configurator sc-configurator-empty">No configurator available for this range.</div>';

  /* Determine market from the page's explicit data-sc-market attribute.
     Defaults to UK. We do NOT infer US from window.Shopify.country: the US
     market is not live, and browser/account country must not flip the
     configurator into the US option set. To enable US, the section sets
     data-sc-market explicitly (via its market setting). */
  var market = 'UK';
  if (typeof window !== 'undefined') {
    var marketEl = document.querySelector('[data-sc-market]');
    var rawMarket = marketEl ? marketEl.getAttribute('data-sc-market') : null;
    /* Only an explicit, supported 'US' flips the market; anything else is UK. */
    if (rawMarket === 'US') market = 'US';
  }
  var sym = (market === 'US') ? '$' : '\u00a3';

  var rowsHtml = '';
  var extraRowsHtml = '';

  /* CMS visibility toggles (set on the section, read into SC._sectionSettings).
     Default to shown when unset. These let the team hide a whole option group
     from customers, e.g. piping when render imagery is not ready. */
  var cms = (SC._sectionSettings) || {};
  var showPiping = cms.showPiping !== false;
  var showFrame = cms.showFrame !== false;
  var showBespokeOptions = cms.showBespokeOptions !== false;

  rules.groups.forEach(function(group) {
    /* CMS toggle: hide entire groups the team has switched off. */
    if (group.key === 'piping' && !showPiping) return;
    if (group.key === 'frame' && !showFrame) return;

    /* Filter options by market */
    var filteredOptions = group.options.filter(function(opt) {
      if (!opt.markets) return true;
      return opt.markets.indexOf(market) !== -1;
    });

    /* CMS toggle: optionally strip bespoke options (e.g. box-pleat, ruffle,
       COM) from any group when switched off. */
    if (!showBespokeOptions) {
      filteredOptions = filteredOptions.filter(function(opt) { return !opt.bespoke; });
    }

    /* Auto-hide groups with only one option after market filtering */
    if (group.autoHideIfSingle && filteredOptions.length <= 1) {
      return; /* Skip rendering this group entirely */
    }

    /* Create a copy of the group with filtered options for rendering */
    var filteredGroup = {};
    for (var k in group) filteredGroup[k] = group[k];
    filteredGroup.options = filteredOptions;

    var html = renderConfigGroup(filteredGroup, rangeKey);
    if (group.key === 'size' || group.key === 'fabric') {
      rowsHtml += html;
    } else {
      extraRowsHtml += html;
    }
  });
  /* Wrap extra options in a collapsible container for mobile */
  if (extraRowsHtml) {
    rowsHtml +=
      '<button type="button" class="sc-config-expand-toggle" data-sc-config-expand>' +
        '<span>More options</span>' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg>' +
      '</button>' +
      '<div class="sc-config-extra-options" data-sc-config-extra>' +
        extraRowsHtml +
      '</div>';
  }

  /* Summary panel: shows the current selection as it builds up.
     This is the data structure that would eventually post to the
     Vercel pricing calculator on Configure & Price. */
  var summaryHtml =
    '<div class="sc-config-summary" data-sc-config-summary>' +
      '<div class="sc-config-summary-head">' +
        '<div class="sc-eyebrow">Your build</div>' +
        (retailer.url || !rules.basePriceBySize ? '' :
          '<div class="sc-config-summary-price" data-sc-config-price>From ' + sym + rules.basePriceBySize[rules.defaultSize].toLocaleString() + '</div>') +
      '</div>' +
      '<ul class="sc-config-summary-list" data-sc-config-summary-list></ul>' +
      '<div class="sc-config-summary-note" data-sc-config-summary-note hidden></div>' +
      '<div class="sc-config-summary-actions">' +
        (retailer.url || !rules.basePriceBySize
          ? '<a class="sc-btn sc-btn-primary sc-config-action-retailer" href="' + retailer.url + '" target="_blank" rel="noopener">' + retailer.label + '</a>'
          : '<button type="button" class="sc-btn sc-btn-primary sc-config-action-quote" data-sc-config-action="quote">Add to basket — <span data-sc-config-btn-price>' + sym + rules.basePriceBySize[rules.defaultSize].toLocaleString() + '</span></button>') +
        '<button type="button" class="sc-btn sc-btn-secondary sc-config-action-save" data-sc-config-action="save">Save &amp; share</button>' +
      '</div>' +
      (retailer.url && retailer.note
        ? '<p class="sc-config-retailer-note">' + retailer.note + '</p>'
        : '') +
      '<div class="sc-config-save-confirm" data-sc-config-save-confirm hidden></div>' +
    '</div>';

  /* Pinned row: title, live price and Add to basket, stuck to the top of
     the configurator column on desktop so the price stays on screen while
     the customer works down the options. It reuses the same
     [data-sc-config-price] hook the calculator already writes to, and
     renderPrice() updates every matching node, so this and the "Your
     build" summary panel stay in step with no extra plumbing.
     Hidden on mobile, where the always-on sticky bar carries the price. */
  var pinnedHtml =
    '<div class="sc-config-pinned" data-sc-config-pinned>' +
      '<span class="sc-config-pinned-title">' + (rules.rangeName || 'Sofa') + '</span>' +
      (retailer.url || !rules.basePriceBySize ? '' :
        '<span class="sc-config-pinned-price" data-sc-config-price>From ' + sym + rules.basePriceBySize[rules.defaultSize].toLocaleString() + '</span>') +
      (retailer.url
        ? '<a class="sc-btn sc-btn-primary sc-config-pinned-cta sc-config-action-retailer" href="' + retailer.url + '" target="_blank" rel="noopener">' + retailer.label + '</a>'
        : '<button type="button" class="sc-btn sc-btn-primary sc-config-pinned-cta" data-sc-config-action="quote">Add to basket</button>') +
    '</div>';

  return '' +
    '<div class="sc-configurator" data-sc-configurator data-sc-range="' + rangeKey + '">' +
      pinnedHtml +
      rowsHtml +
      summaryHtml +
    '</div>';
};

/* Render one option group. Each option is a pill button. Bespoke options
   get a 'bespoke' marker; options that depend on other groups carry a
   data-sc-requires attribute that the runtime reads when re-validating. */
function renderConfigGroup(group, rangeKey) {
  var pills = group.options.map(function(opt, i) {
    var classes = 'sc-config-pill';
    if (opt.bespoke) classes += ' sc-config-pill--bespoke';
    var requiresAttr = '';
    if (opt.requires) {
      requiresAttr = ' data-sc-requires=\'' + JSON.stringify(opt.requires).replace(/'/g, '&apos;') + '\'';
    }
    return '<button class="' + classes + '" type="button" ' +
      'data-sc-config-group="' + group.key + '" ' +
      'data-sc-config-value="' + opt.value + '" ' +
      'data-sc-config-label="' + opt.label + '"' +
      (opt.bespoke ? ' data-sc-bespoke="true"' : '') +
      requiresAttr +
      '>' +
      /* Fabric tabs must fit one line on a phone and one label
         ("COM (your own fabric)") is far longer than the rest, so emit
         both a full and a short form and let CSS pick. Inlined rather
         than a helper: this file is a series of separate top-level
         functions, so a helper defined elsewhere is not in scope here. */
      ((group.key === 'fabric' && opt.label.indexOf(' (') > -1)
        ? '<span class="sc-config-pill-full">' + opt.label + '</span>' +
          '<span class="sc-config-pill-short">' + opt.label.split(' (')[0] + '</span>'
        : opt.label) +
      (opt.bespoke ? ' <span class="sc-config-bespoke-tag">bespoke</span>' : '') + '</button>';
  }).join('');

  /* Fabric group gets the existing sub-selector for category drill-in */
  var subSelector = '';
  if (group.key === 'fabric') {
    subSelector = renderFabricSubSelector(rangeKey);
  }

  var helpHtml = group.help
    ? '<div class="sc-config-help-text" data-sc-config-help="' + group.key + '">' + group.help + '</div>'
    : '';

  /* Legs and piping get a small preview image that swaps as the customer
     selects (and as the fabric changes). The src is filled in at runtime by
     updateLegPipingPreviews(); it starts empty and hidden. */
  var previewHtml = '';
  if (group.key === 'legStyle' || group.key === 'piping') {
    var previewGroup = group.key === 'legStyle' ? 'legs' : 'piping';
    previewHtml =
      '<div class="sc-config-preview" data-sc-config-preview="' + previewGroup + '" hidden>' +
        '<img class="sc-config-preview-img" data-sc-config-preview-img alt="" loading="lazy" />' +
      '</div>';
  }

  return '' +
    '<div class="sc-config-row" data-sc-config-row="' + group.key + '">' +
      '<div class="sc-config-label">' +
        '<span>' + group.label + '</span>' +
        '<span class="sc-config-label-value" data-sc-config-current="' + group.key + '"></span>' +
      '</div>' +
      '<div class="sc-config-options">' + pills + '</div>' +
      previewHtml +
      helpHtml +
      subSelector +
    '</div>';
}

/* Fabric sub-selector: category drill-in with a two-stage UI.

   Curated row: up to 8 swatches per category from SC.fabricCategories
   (the curated list maintained in sc-data.js). These show by default.

   View all: a link below the curated row, which on click reveals an
   expanded panel showing EVERY fabric in that category from the live
   Shopify catalogue (SC.images.allFabrics filtered by style). Swatches
   in the expanded panel are larger and carry the fabric name. */
function renderFabricSubSelector(rangeKey) {
  /* Build the catStyle map: how each tab category maps to a "style"
     value in SC.images.allFabrics. Velvet is a special case — Shopify
     categorises velvets as Plain (they're flat colour), so we use the
     isVelvet flag to filter for them instead. */
  var catStyleMap = {
    plain:   { style: 'Plain',   filter: function(f) { return f.style === 'Plain' && !f.isVelvet; } },
    striped: { style: 'Stripes', filter: function(f) { return f.style === 'Stripes'; } },
    floral:  { style: 'Floral',  filter: function(f) { return f.style === 'Floral'; } },
    velvet:  { style: 'Plain',   filter: function(f) { return f.isVelvet === true; } }
  };

  /* Helper: build the CSS for a swatch from a fabric handle. Falls back
     to painted gradient when no image is available. */
  function swatchStyle(handle, f) {
    /* 1. Try CDN swatch via manifest (code-based lookup) */
    if (SC.getSwatchUrl && SC.imageResolver && SC.imageResolver._resolveFabricCode) {
      var code = SC.imageResolver._resolveFabricCode(handle);
      if (code) {
        var cdnUrl = SC.getSwatchUrl(code);
        if (cdnUrl) {
          return 'background-image: url(' + cdnUrl + '); background-size: cover; background-position: center;';
        }
      }
    }
    /* 2. Try legacy image sources */
    var realImage = (SC.images && SC.images.fabricSwatches && SC.images.fabricSwatches[handle])
      || (SC.fabricImages && SC.fabricImages[handle])
      || null;
    if (realImage) {
      return 'background-image: url(' + realImage + '); background-size: cover; background-position: center;';
    }
    /* 3. CSS fallback */
    if (!f) return 'background: #ddd;';
    if (f.print === 'stripe') {
      return 'background: repeating-linear-gradient(90deg, ' + f.swatchColour + ' 0 6px, ' + f.swatchAccent + ' 6px 10px);';
    }
    if (f.print === 'floral') {
      return 'background: radial-gradient(circle at 30% 30%, ' + f.swatchAccent + ' 0 4px, transparent 5px), radial-gradient(circle at 70% 70%, ' + f.swatchAccent + ' 0 4px, transparent 5px), ' + f.swatchColour + ';';
    }
    return 'background: linear-gradient(135deg, ' + f.swatchColour + ' 0%, ' + f.swatchAccent + ' 100%);';
  }

  /* Which fabric library this range draws from. The John Lewis ranges
     stock a curated 24, not the full Sophie Conran library, so showing
     the standard categories put fabrics on the page that John Lewis does
     not sell and that have no render behind them. */
  var _r = (SC.configurationRules || {})[rangeKey];
  var fabricLib = (_r && _r.fabricSource === 'jlp')
    ? ((SC.jlpFabricsByRange && SC.jlpFabricsByRange[rangeKey]) || SC.jlpFabricCategories || {})
    : (SC.fabricCategories || {});
  /* Velvet is Sophie Conran only, so the row is dropped when the library
     has no entry for it rather than rendering an empty tab. */
  var catKeys = ['plain', 'striped', 'floral', 'velvet'].filter(function(c) {
    return (fabricLib[c] || []).length > 0;
  });

  /* Render one category row: curated swatches + View all link + expanded panel. */
  var rows = catKeys.map(function(cat) {
    var catMeta = catStyleMap[cat] || catStyleMap.plain;

    /* Curated swatches: cap at 8, source is SC.fabricCategories. */
    var curatedHandles = (fabricLib[cat] || []).slice(0, 8);
    var curatedSwatches = curatedHandles.map(function(handle, i) {
      var f = SC.fabrics[handle] || {};
      var displayName = f.name || handle.replace(/-/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
      return '<button type="button" class="sc-config-swatch' + (i === 0 ? ' is-selected' : '') + '" ' +
        'data-sc-fabric-handle="' + handle + '" ' +
        'data-sc-fabric-name="' + displayName + '" ' +
        'aria-label="' + displayName + '" ' +
        'title="' + displayName + '" ' +
        'style="' + swatchStyle(handle, f) + '"></button>';
    }).join('');

    /* Expanded panel: every fabric in this category from the live catalogue.
       Larger swatches plus fabric name underneath. */
    var allInCategory = ((SC.images && SC.images.allFabrics) || []).filter(catMeta.filter);
    /* Restrict the expanded panel to the same curated library as the row
       above it. Without this it filtered the entire Shopify fabric
       catalogue by style, so a John Lewis range offered Sophie Conran
       florals that John Lewis does not stock and that have no render. */
    if (fabricLib !== SC.fabricCategories) {
      var allowed = fabricLib[cat] || [];
      allInCategory = allInCategory.filter(function(f) {
        return allowed.indexOf(f.handle) > -1;
      });
    }
    var expandedSwatches = allInCategory.map(function(item) {
      var f = SC.fabrics[item.handle] || { name: item.name, print: cat === 'striped' ? 'stripe' : (cat === 'floral' ? 'floral' : 'plain') };
      var inCurated = curatedHandles.indexOf(item.handle) !== -1;
      return '<button type="button" class="sc-config-swatch-large' + (inCurated ? ' is-curated' : '') + '" ' +
        'data-sc-fabric-handle="' + item.handle + '" ' +
        'data-sc-fabric-name="' + item.name + '" ' +
        'aria-label="' + item.name + '" ' +
        'title="' + item.name + '">' +
        '<div class="sc-config-swatch-large-tile" style="' + swatchStyle(item.handle, f) + '"></div>' +
        '<div class="sc-config-swatch-large-name">' + item.name + '</div>' +
      '</button>';
    }).join('');
    var totalCount = allInCategory.length;
    var viewAllLink = totalCount > curatedHandles.length
      ? '<button type="button" class="sc-config-swatch-viewall" data-sc-fabric-viewall="' + cat + '">View all ' + totalCount + ' &rsaquo;</button>'
      : '';

    /* Default selected name for the inline label */
    var firstHandle = curatedHandles[0];
    var defaultName = firstHandle && SC.fabrics[firstHandle] ? SC.fabrics[firstHandle].name : '';

    return '<div class="sc-config-swatches" data-sc-fabric-cat="' + cat + '"' + (cat === 'plain' ? '' : ' hidden') + '>' +
        '<div class="sc-config-swatch-row">' +
          curatedSwatches +
        '</div>' +
        '<div class="sc-config-swatch-meta">' +
          '<span class="sc-config-swatch-name" data-sc-fabric-cat-name="' + cat + '">' + defaultName + '</span>' +
          viewAllLink +
        '</div>' +
        '<div class="sc-config-swatch-expanded" data-sc-fabric-expanded="' + cat + '" hidden>' +
          '<div class="sc-config-swatch-expanded-head">' +
            '<span class="sc-eyebrow">All ' + cat + ' fabrics</span>' +
            '<button type="button" class="sc-config-swatch-expanded-close" data-sc-fabric-viewall-close="' + cat + '" aria-label="Close">&times;</button>' +
          '</div>' +
          '<div class="sc-config-swatch-expanded-grid">' + expandedSwatches + '</div>' +
        '</div>' +
      '</div>';
  }).join('');
  return '<div class="sc-config-sub">' + rows + '</div>';
}

/* Sticky configuration bar.
   Pinned to the bottom of the viewport while the customer is scrolled past
   the full summary panel but hasn't reached the cross-sell / reviews. Carries
   the live price plus the two action buttons in compact form, so the build
   doesn't disappear while reading dimensions, materials, care, etc. */
SC.components.productConfigStickyBar = function() {
  return '' +
    '<div class="sc-config-sticky" data-sc-config-sticky hidden aria-hidden="true">' +
      '<div class="sc-container-wide sc-config-sticky-inner">' +
        '<button type="button" class="sc-config-sticky-save-sm" data-sc-config-sticky-action="save" aria-label="Save">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21C12 21 3.5 15.5 2 10.5 0.5 5.5 4 3 7 3c1.8 0 3.5 1 5 3 1.5-2 3.2-3 5-3 3 0 6.5 2.5 5 7.5C20.5 15.5 12 21 12 21z"/></svg>' +
        '</button>' +
        '<div class="sc-config-sticky-summary">' +
          '<div class="sc-config-sticky-title" data-sc-config-sticky-title>Coco 2.5-seater</div>' +
          '<div class="sc-config-sticky-meta" data-sc-config-sticky-meta>Cool Coconut, knife edge, loose</div>' +
        '</div>' +
        '<button type="button" class="sc-btn sc-btn-primary sc-config-sticky-quote" data-sc-config-sticky-action="quote">' +
          'Add to basket <span class="sc-config-sticky-btn-sep">&mdash;</span> <span data-sc-config-sticky-price></span>' +
        '</button>' +
      '</div>' +
    '</div>';
};

/* Three "if you are also looking at..." routes below the configurator */

/* "In real rooms" , strip of customer photos. Uses gallery for now;
   in production these are actual customer-submitted photos. */
SC.components.customerRooms = function(opts) {
  opts = opts || {};
  var product = (SC.images && SC.images.product && SC.images.product.coco_2_5) || null;
  var captions = opts.captions || [
    "Sara's living room, Yorkshire",
    "Lauren's reading corner, London",
    "Meredith's family room, Edinburgh",
    "Natalie's apartment, New York",
    "A reader's room, Cornwall"
  ];
  var sources = product ? product.gallery.concat([
    { src: 'assets/img/range-coco.jpg', alt: 'Coco in DG Varese Grass' },
    { src: 'assets/img/stock-coco-natural.jpg', alt: 'Coco in DG Brera Lino Chalk' }
  ]) : [];
  var photos = sources.slice(0, 5).map(function(s, i) {
    return '<figure class="sc-customer-room">' +
      '<img src="' + s.src + '" alt="' + s.alt + '" loading="lazy" />' +
      '<figcaption>' + (captions[i] || '') + '</figcaption>' +
    '</figure>';
  }).join('');
  return '' +
    '<section class="sc-section">' +
      '<div class="sc-container-wide">' +
        '<div class="sc-section-head">' +
          '<div class="sc-eyebrow">Lived with</div>' +
          '<h2 class="sc-display-2">In real rooms.</h2>' +
          '<p>From customers who chose the Coco 2.5 in the last twelve months.</p>' +
        '</div>' +
        '<div class="sc-customer-rooms">' + photos + '</div>' +
      '</div>' +
    '</section>';
};

/* Expandable dimensions section. Native <details> for keyboard accessibility.
   Diagram on the left, full sizing table on the right at desktop. Stacks at mobile. */
SC.components.productDimensions = function(productKey) {
  var d = (SC.dimensions || {})[productKey || 'coco'];
  if (!d) return '';
  var headerRow = '<tr><th class="sc-dims-meas">Measurement</th>' +
    d.sizes.map(function(s) { return '<th>' + s.name + '</th>'; }).join('') + '</tr>';
  var bodyRows = d.legend.map(function(leg) {
    var cells = d.sizes.map(function(s) {
      var v = s.values[leg.code];
      return '<td>' + (v != null ? v + ' cm' : '—') + '</td>';
    }).join('');
    return '<tr>' +
      '<th class="sc-dims-meas">' +
        '<span class="sc-dims-code">' + leg.code + '</span>' +
        '<span class="sc-dims-label">' + leg.label + '</span>' +
      '</th>' +
      cells +
    '</tr>';
  }).join('');
  /* Friendly range name for the CTA. Capitalise the productKey. */
  var rangeName = (productKey || 'coco');
  rangeName = rangeName.charAt(0).toUpperCase() + rangeName.slice(1);
  return '' +
    '<section class="sc-section sc-section-cream sc-dims-section" id="jump-dimensions">' +
      '<div class="sc-container-wide">' +
        SC.components.fitCheckerPdpButton(rangeName) +
        '<details class="sc-dims" open>' +
          '<summary class="sc-dims-summary">' +
            '<span class="sc-eyebrow">Dimensions</span>' +
            '<h2 class="sc-display-2">Every millimetre.</h2>' +
            '<span class="sc-dims-chev" aria-hidden="true"></span>' +
          '</summary>' +
          '<div class="sc-dims-body">' +
            '<div class="sc-dims-diagram">' +
              '<img src="' + d.diagram + '" alt="' + d.diagramAlt + '" loading="lazy" />' +
            '</div>' +
            '<div class="sc-dims-table-wrap">' +
              '<table class="sc-dims-table">' +
                '<thead>' + headerRow + '</thead>' +
                '<tbody>' + bodyRows + '</tbody>' +
              '</table>' +
            '</div>' +
          '</div>' +
        '</details>' +
      '</div>' +
    '</section>';
};

/* Editorial content slabs. Image and copy alternate sides for visual rhythm.
   These tell the collection-level story (materials, fabrics, care, lead time,
   guarantee, payment) that doesn't change between Coco 2-seater and 2.5-seater. */
SC.components.productEditorial = function(productKey) {
  var slabs = (SC.productContent || {})[productKey || 'coco'];
  if (!slabs || !slabs.length) return '';
  var slabsHtml = slabs.map(function(slab, i) {
    var reverseCls = (i % 2 === 1) ? ' sc-editorial-slab--reverse' : '';
    var bgCls = (i % 2 === 1) ? ' sc-section-paper-warm' : '';
    var linkHtml = slab.link
      ? '<a class="sc-editorial-link" href="' + slab.link.url + '"' +
          (slab.link.url.indexOf('http') === 0 ? ' target="_blank" rel="noopener"' : '') +
          '>' + slab.link.label + ' &rsaquo;</a>'
      : '';
    return '' +
      '<details class="sc-editorial-block' + bgCls + '" id="jump-' + slab.key + '" open>' +
        '<summary class="sc-editorial-block-summary">' +
          '<div class="sc-editorial-block-header">' +
            '<span class="sc-eyebrow">' + slab.eyebrow + '</span>' +
            '<h3 class="sc-editorial-slab-title">' + slab.title + '</h3>' +
          '</div>' +
          '<span class="sc-editorial-block-chev" aria-hidden="true">' +
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</span>' +
        '</summary>' +
        '<div class="sc-editorial-block-body">' +
          '<div class="sc-editorial-slab' + reverseCls + '">' +
            '<div class="sc-editorial-slab-media">' +
              '<img src="' + slab.image + '" alt="' + (slab.imageAlt || '') + '" loading="lazy" />' +
            '</div>' +
            '<div class="sc-editorial-slab-text">' +
              '<p>' + slab.body + '</p>' +
              linkHtml +
            '</div>' +
          '</div>' +
        '</div>' +
      '</details>';
  }).join('');
  return '' +
    '<section class="sc-section sc-editorial-section">' +
      slabsHtml +
    '</section>';
};

/* Inline reviews on product page (3 selected from data) */

/* Page-level interactive bindings for the configurator + gallery.
   Run AFTER the components are mounted. */
/* ── Product image lightbox ── */
function openLightbox(src, alt) {
  if (!src) return;

  var overlay = document.createElement('div');
  overlay.className = 'sc-lightbox';
  overlay.innerHTML =
    '<div class="sc-lightbox-backdrop"></div>' +
    '<div class="sc-lightbox-content">' +
      '<button type="button" class="sc-lightbox-close" aria-label="Close">' +
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<div class="sc-lightbox-img-wrap">' +
        '<img class="sc-lightbox-img" src="' + src + '" alt="' + (alt || '') + '" />' +
      '</div>' +
    '</div>';

  document.body.appendChild(overlay);
  document.body.classList.add('sc-lightbox-open');

  /* Animate in */
  requestAnimationFrame(function() {
    overlay.classList.add('is-open');
  });

  /* Pinch-to-zoom state */
  var img = overlay.querySelector('.sc-lightbox-img');
  var scale = 1;
  var translateX = 0;
  var translateY = 0;
  var startDist = 0;
  var startScale = 1;
  var isDragging = false;
  var dragStartX = 0;
  var dragStartY = 0;
  var startTransX = 0;
  var startTransY = 0;

  function applyTransform() {
    img.style.transform = 'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + scale + ')';
  }

  /* Mouse wheel zoom */
  overlay.addEventListener('wheel', function(e) {
    e.preventDefault();
    var delta = e.deltaY > 0 ? 0.9 : 1.1;
    scale = Math.min(5, Math.max(0.5, scale * delta));
    applyTransform();
  }, { passive: false });

  /* Touch pinch zoom */
  overlay.addEventListener('touchstart', function(e) {
    if (e.touches.length === 2) {
      startDist = Math.hypot(
        e.touches[1].clientX - e.touches[0].clientX,
        e.touches[1].clientY - e.touches[0].clientY
      );
      startScale = scale;
    } else if (e.touches.length === 1 && scale > 1) {
      isDragging = true;
      dragStartX = e.touches[0].clientX;
      dragStartY = e.touches[0].clientY;
      startTransX = translateX;
      startTransY = translateY;
    }
  }, { passive: true });

  overlay.addEventListener('touchmove', function(e) {
    if (e.touches.length === 2) {
      e.preventDefault();
      var dist = Math.hypot(
        e.touches[1].clientX - e.touches[0].clientX,
        e.touches[1].clientY - e.touches[0].clientY
      );
      scale = Math.min(5, Math.max(0.5, startScale * (dist / startDist)));
      applyTransform();
    } else if (isDragging && e.touches.length === 1) {
      translateX = startTransX + (e.touches[0].clientX - dragStartX);
      translateY = startTransY + (e.touches[0].clientY - dragStartY);
      applyTransform();
    }
  }, { passive: false });

  overlay.addEventListener('touchend', function() {
    isDragging = false;
    if (scale <= 1) { translateX = 0; translateY = 0; applyTransform(); }
  });

  /* Mouse drag when zoomed */
  img.addEventListener('mousedown', function(e) {
    if (scale > 1) {
      isDragging = true;
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      startTransX = translateX;
      startTransY = translateY;
      img.style.cursor = 'grabbing';
      e.preventDefault();
    }
  });
  overlay.addEventListener('mousemove', function(e) {
    if (isDragging) {
      translateX = startTransX + (e.clientX - dragStartX);
      translateY = startTransY + (e.clientY - dragStartY);
      applyTransform();
    }
  });
  overlay.addEventListener('mouseup', function() {
    isDragging = false;
    img.style.cursor = scale > 1 ? 'grab' : 'zoom-out';
  });

  /* Double-click to toggle zoom */
  img.addEventListener('dblclick', function() {
    if (scale > 1) {
      scale = 1; translateX = 0; translateY = 0;
      img.style.cursor = 'zoom-in';
    } else {
      scale = 2.5;
      img.style.cursor = 'grab';
    }
    applyTransform();
  });

  /* Close handlers */
  function close() {
    overlay.classList.remove('is-open');
    document.body.classList.remove('sc-lightbox-open');
    setTimeout(function() { overlay.remove(); }, 300);
  }

  overlay.querySelector('.sc-lightbox-close').addEventListener('click', close);
  overlay.querySelector('.sc-lightbox-backdrop').addEventListener('click', close);
  document.addEventListener('keydown', function escHandler(e) {
    if (e.key === 'Escape') { close(); document.removeEventListener('keydown', escHandler); }
  });
}

/* ── Mobile gallery: swipe + dots ──
   On mobile the thumbnail strip is hidden (it costs ~100px of the fold)
   and replaced by dots overlaid on the hero. Rather than duplicating the
   image list, the dots mirror the thumb row and delegate to it: each dot
   clicks its matching thumb, so selecting an image behaves exactly as
   tapping a thumbnail always has. The thumb row is rebuilt whenever the
   configuration changes (renders first, then lifestyle shots), so a
   MutationObserver keeps the dots in step rather than us hooking every
   rebuild site individually.

   Four product templates ship three different sets of class names for
   what is the same gallery, so the shapes are listed rather than
   hardcoded. Each section keeps its own thumb-click handler and this
   only delegates to it, so there is one place that swaps the image and
   one place that drives the mobile affordances. */
var SC_GALLERY_SHAPES = [
  /* sc-product-sofa, sc-product-hero, sc-product-default. All three wrap
     the gallery in .sc-product-left; only two of them also have an inner
     .sc-product-gallery, which is why the outer one is the root. */
  {
    root: '.sc-product-left',
    main: '#sc-gallery-main, .sc-product-gallery-img',
    thumbRow: '.sc-product-gallery-thumbs',
    thumb: '.sc-product-gallery-thumb'
  },
  /* sc-product-rich (bed linen, Portmeirion). This one keeps its thumb
     strip on mobile, so it gets the swipe but no dots: the thumbs already
     show which shot you are on, and two indicators for one thing is one
     too many. */
  {
    root: '[data-sc-pr-gallery]',
    main: '[data-sc-pr-main]',
    thumbRow: '.sc-pr-thumbs',
    thumb: '[data-sc-pr-thumb]',
    dots: false
  }
];

function bindMobileGalleryTo(gallery, shape) {
  if (!gallery) return;
  var main = gallery.querySelector(shape.main);
  var thumbRow = gallery.querySelector(shape.thumbRow);
  if (!main || !thumbRow) return;
  /* The claim is on the image, not the wrapper: two shapes can nest, and
     two calls can arrive from different sections, but a gallery is the
     same gallery if it ends at the same main image. */
  if (main.getAttribute('data-sc-mobile-gallery')) return;
  main.setAttribute('data-sc-mobile-gallery', '1');

  var dots = null;
  if (shape.dots !== false) {
    dots = document.createElement('div');
    dots.className = 'sc-gallery-dots';
    dots.setAttribute('data-sc-gallery-dots', '');
    (main.parentNode || gallery).appendChild(dots);
  }

  function thumbs() {
    return Array.prototype.slice.call(thumbRow.querySelectorAll(shape.thumb));
  }
  function activeIndex(list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].classList.contains('is-active')) return i;
    }
    return 0;
  }
  function syncDots() {
    if (!dots) return;
    var list = thumbs();
    if (list.length < 2) { dots.hidden = true; return; }
    dots.hidden = false;
    if (dots.children.length !== list.length) {
      dots.innerHTML = '';
      list.forEach(function(_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'sc-gallery-dot';
        d.setAttribute('aria-label', 'View image ' + (i + 1) + ' of ' + list.length);
        d.addEventListener('click', function() {
          var t = thumbs();
          if (t[i]) t[i].click();
        });
        dots.appendChild(d);
      });
    }
    var idx = activeIndex(list);
    Array.prototype.forEach.call(dots.children, function(d, i) {
      d.classList.toggle('is-active', i === idx);
      d.setAttribute('aria-current', i === idx ? 'true' : 'false');
    });
  }

  syncDots();
  if (dots && typeof MutationObserver !== 'undefined') {
    new MutationObserver(syncDots).observe(thumbRow, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['class']
    });
  }

  /* Horizontal swipe moves one image. Vertical-dominant gestures are
     ignored so the page still scrolls normally under the finger. The
     listener sits on the gallery rather than the image itself, so a
     swipe that starts on the letterboxed area either side of a
     portrait photo still counts. */
  var swipeArea = main.parentNode || gallery;
  var x0 = null, y0 = null;
  swipeArea.addEventListener('touchstart', function(e) {
    if (e.touches.length !== 1) { x0 = null; return; }
    x0 = e.touches[0].clientX;
    y0 = e.touches[0].clientY;
  }, { passive: true });

  swipeArea.addEventListener('touchend', function(e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    var dy = e.changedTouches[0].clientY - y0;
    x0 = null;
    if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
    var list = thumbs();
    if (list.length < 2) return;
    var next = activeIndex(list) + (dx < 0 ? 1 : -1);
    if (next < 0 || next >= list.length) return;
    main.setAttribute('data-sc-swiping', '1');
    list[next].click();
    setTimeout(function() { main.removeAttribute('data-sc-swiping'); }, 350);
  }, { passive: true });
}

/* Wires every product gallery on the page. Safe to call more than once
   and from more than one section: a gallery is claimed by the first call
   that reaches it and skipped by the rest. */
SC.bindMobileGallery = function(scope) {
  var ctx = scope || document;
  SC_GALLERY_SHAPES.forEach(function(shape) {
    Array.prototype.forEach.call(ctx.querySelectorAll(shape.root), function(gallery) {
      bindMobileGalleryTo(gallery, shape);
    });
  });
};

/* ── Render note: read more ──
   The note is worth keeping in full, but at ~80px on a phone it pushes
   the size options below the fold. Mobile clamps it to one line with a
   toggle; desktop shows it whole and the toggle stays hidden via CSS.
   The wording itself is untouched and stays CMS-editable. */
function setupRenderNoteToggle() {
  var note = document.querySelector('[data-sc-render-note]');
  if (!note) return;
  var btn = note.querySelector('[data-sc-render-note-toggle]');
  if (!btn) return;
  btn.addEventListener('click', function() {
    var open = note.classList.toggle('is-expanded');
    btn.textContent = open ? 'Less' : 'More';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
}

/* ── Product description: four-line clamp with read more ──
   The button only appears when the text genuinely overflows the clamp,
   so a two-line description does not get a pointless "Read more". */
function setupDescriptionToggle() {
  var wrap = document.querySelector('[data-sc-product-desc]');
  if (!wrap) return;
  var body = wrap.querySelector('.sc-product-description-body');
  var btn = wrap.querySelector('[data-sc-product-desc-toggle]');
  if (!body || !btn) return;

  function check() {
    if (wrap.classList.contains('is-expanded')) return;
    /* scrollHeight exceeds clientHeight only when the clamp is biting. */
    btn.hidden = body.scrollHeight <= body.clientHeight + 2;
  }
  check();
  /* Fonts landing late can change the height, so re-check once settled. */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
  window.addEventListener('resize', check);

  btn.addEventListener('click', function() {
    var open = wrap.classList.toggle('is-expanded');
    btn.textContent = open ? 'Read less' : 'Read more';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
}

/* ── Publish the site header's real height ──
   The pinned price row sticks directly below the header, and the header is
   itself position:sticky. Its rendered height is NOT --header-height: that
   token is just the nav row, while the sticky element also contains the
   announcement topbar (~36px on desktop, hidden under 768px). Sticking the
   row at the token value parked it behind the header, where the header's
   higher z-index hid it completely. Measuring the element removes the
   guesswork and survives the topbar disappearing at the mobile breakpoint. */
function publishHeaderHeight() {
  var header = document.querySelector('.sc-header');
  if (!header) return;
  function set() {
    document.documentElement.style.setProperty(
      '--sc-header-height-actual', header.offsetHeight + 'px');
  }
  set();
  window.addEventListener('resize', set);
  /* Late-loading fonts change the header's height, so re-measure once. */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(set);
}

SC.bindProductPage = function() {
  var main = document.getElementById('sc-gallery-main');

  /* ── Image lightbox: click hero to open full-screen zoom ── */
  if (main) {
    main.style.cursor = 'zoom-in';
    main.addEventListener('click', function() {
      /* A swipe ends in a click on some browsers. Ignore that one so
         swiping between images does not also open the lightbox. */
      if (main.getAttribute('data-sc-swiping') === '1') return;
      openLightbox(main.src, main.alt);
    });
  }

  publishHeaderHeight();
  SC.bindMobileGallery();
  setupRenderNoteToggle();
  setupDescriptionToggle();

  // Gallery thumbnail picker
  document.querySelectorAll('[data-sc-gallery-pick]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (!main) return;
      main.src = btn.getAttribute('data-sc-gallery-pick');
      main.alt = btn.getAttribute('data-sc-gallery-alt') || '';
      document.querySelectorAll('.sc-product-gallery-thumb').forEach(function(b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  // Help-toggle buttons (legacy, kept in case any pages still use them)
  document.querySelectorAll('[data-sc-help-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var id = btn.getAttribute('data-sc-help-toggle');
      var panel = document.getElementById(id);
      if (!panel) return;
      panel.hidden = !panel.hidden;
    });
  });

  // Initialise the configurator if this page has one
  var configEl = document.querySelector('[data-sc-configurator]');
  if (configEl) {
    SC.configurator.init(configEl, main);
  }
};

/* ============================================================
   CONFIGURATOR STATE MACHINE
   ============================================================
   Owns the selection state. On every change:
     1. validates against rule constraints (re-evaluates which options
        in other groups are now disabled)
     2. updates the summary panel
     3. updates the price (from basePriceBySize for the demo, from
        the Vercel calculator in production)
     4. updates the gallery hero image when fabric or size changes
     5. shareable URL: encodes the selection as a query string so
        customers can save and share their build (e.g. ?config=coco-2.5-seater-sea-salt-knife-loose-self-flat)
   ============================================================ */
SC.configurator = (function() {

  var state = {
    rangeKey: 'coco',
    rules: null,
    selection: {},
    fabricHandle: null,  /* the specific fabric chosen from the sub-selector */
    rootEl: null,
    galleryMain: null
  };

  /* ── Compute arm + back cushion fill (never shown to customer) ── */
  function computeBackgroundFills() {
    var range = state.rangeKey;
    var market = state.market || 'UK';
    var seatFill = state.selection.cushionFill || '';

    /* Arm cushion fill. Per the pricing tool, only Coco has an arm
       cushion fill dimension (UK: All Feather; US: follows the seat). */
    if (range === 'coco') {
      if (market === 'UK') {
        state.selection.armCushionFill = 'all-feather';
      } else {
        state.selection.armCushionFill =
          (seatFill === 'fiber-down-foam') ? 'fiber-down' : 'all-feather-down';
      }
    } else {
      state.selection.armCushionFill = null;
    }

    /* Back cushion fill. Coco and Barton: UK All Feather, US follows the
       seat fill (Fiber & Down unless the seat is All Feather & Down).
       Felix and Isobel: UK All Feather, US Fiber & Down (the tool's only
       options). Henrietta and Sophia: sprung backs, no back fill. */
    if (range === 'coco' || range === 'barton') {
      if (market === 'UK') {
        state.selection.backCushionFill = 'all-feather';
      } else {
        state.selection.backCushionFill =
          (seatFill === 'all-feather-down') ? 'all-feather-down' : 'fiber-down';
      }
    } else if (range === 'felix' || range === 'isobel') {
      state.selection.backCushionFill = (market === 'UK') ? 'all-feather' : 'fiber-down';
    } else {
      state.selection.backCushionFill = null;
    }
  }

  function init(rootEl, galleryMain) {
    state.rangeKey = rootEl.getAttribute('data-sc-range') || 'coco';
    state.rules = (SC.configurationRules || {})[state.rangeKey];
    if (state.rules && SC.pricingApi && SC.pricingApi.applyVisibility) state.rules = SC.pricingApi.applyVisibility(state.rules);
    if (!state.rules) return;
    state.rootEl = rootEl;
    state.galleryMain = galleryMain;

    /* Determine market from the explicit data-sc-market attribute; default UK.
       (No window.Shopify.country inference: US is not a live market.)
       Only known markets are honoured; anything unexpected falls back to UK so
       a stale or malformed value can never surface a half-built market. */
    var SUPPORTED_MARKETS = { UK: 1, US: 1 };
    var market = 'UK';
    var marketEl = document.querySelector('[data-sc-market]');
    var rawAttr = marketEl ? marketEl.getAttribute('data-sc-market') : null;
    if (rawAttr && SUPPORTED_MARKETS[rawAttr]) {
      market = rawAttr;
    }
    state.market = market;

    /* Diagnostic: makes the resolved market and its source unambiguous in the
       console, so a UK-vs-US mismatch can be traced without guesswork. If this
       logs market 'US' on a UK storefront, the data-sc-market attribute on the
       page is 'US' (check the section's "Configurator market" setting), not a
       JS inference. */
    try {
      console.info('[SC configurator] market =', market,
        '| data-sc-market attr =', (rawAttr === null ? '(none)' : '"' + rawAttr + '"'),
        '| window.Shopify.country =', (window.Shopify && window.Shopify.country) || '(unset)');
    } catch (e) {}

    /* Seed defaults: for each group, filter by market, then select the
       isDefault option or the first non-bespoke option.
       Groups with autoHideIfSingle that have only one option after
       market filtering are still seeded (they just don't render). */
    state.rules.groups.forEach(function(group) {
      /* Filter by market */
      var marketOptions = group.options.filter(function(o) {
        if (!o.markets) return true;
        return o.markets.indexOf(market) !== -1;
      });
      if (marketOptions.length === 0) return;

      var preferred = (group.key === 'size' && state.rules.defaultSize) ? state.rules.defaultSize : null;
      var pick = null;

      /* Check for explicit default */
      if (!preferred) {
        pick = marketOptions.find(function(o) { return o.isDefault; });
      }

      if (preferred) {
        pick = marketOptions.find(function(o) { return o.value === preferred; });
      }
      if (!pick) {
        pick = marketOptions.find(function(o) { return !o.bespoke; }) || marketOptions[0];
      }
      if (pick) state.selection[group.key] = pick.value;
    });

    /* Auto-compute arm cushion fill (never shown to customer) */
    computeBackgroundFills();

    /* Default fabric handle: first swatch in the plain row */
    var _lib = (state.rules && state.rules.fabricSource === 'jlp')
      ? ((SC.jlpFabricsByRange && SC.jlpFabricsByRange[state.rangeKey]) || SC.jlpFabricCategories || {})
      : (SC.fabricCategories || {});
    var plainHandles = _lib.plain || [];
    state.fabricHandle = plainHandles[0] || null;

    /* Parse any inbound ?config= query string into state */
    var restoredFromUrl = parseUrlConfig();

    /* A link that names a fabric but not a piping style (a gallery pin, a
       quiz-saved build, an older share URL) must still land with the
       correct contrast/self piping for that fabric — the same rule that
       applies when a customer picks the fabric by hand. Skipped when the
       URL named piping explicitly, so a deliberately shared self-piped
       build is never silently upgraded to contrast. */
    if (restoredFromUrl && !state._pipingRestoredFromUrl) {
      autoDefaultPiping();
    }

    /* Wire click handlers */
    wireClickHandlers();

    /* Initial render */
    revalidate();
    renderSelectionMarks();
    renderSummary();
    renderPrice();
    updateLegPipingPreviews();

    /* If a saved build was restored from the URL, reflect it in the hero
       image and reveal the matching fabric style row so the configurator
       opens exactly as it was configured. */
    if (restoredFromUrl) {
      if (state.selection.fabric) {
        try { updateFabricCategory(state.selection.fabric); } catch (e) {}
      }
      try { updateHeroImage(); } catch (e) {}
    }

    /* Sticky bar visibility: appears once the configurator panel has
       scrolled out of view, disappears once the user reaches the
       customer-rooms / reviews section deeper down the page. */
    setupStickyBar();
  }


  /* IntersectionObserver-driven visibility for the pinned bar.
     We watch two sentinels:
       - The configurator root: when its bottom passes above the viewport
         top, the customer has scrolled past it → show bar
       - The customer-rooms section: when it enters the viewport, the
         customer is deep in the page → hide bar
     The bar lives in the document body, not inside the configurator,
     so it sits above page content as a pinned overlay. */
  function setupStickyBar() {
    var bar = document.querySelector('[data-sc-config-sticky]');
    if (!bar) return;
    if (typeof IntersectionObserver === 'undefined') return;

    var configEl = state.rootEl;
    var endSentinel = document.getElementById('customer-rooms-mount');

    var pastConfigurator = false;
    var beforeEnd = true;

    /* Mobile shows the bar for the whole page: it is the only place the
       live price appears on a small screen, so gating it on scroll
       position would hide the number exactly when someone is choosing
       options. Desktop keeps the scroll gate, because the pinned row at
       the top of the configurator column already carries the price while
       they are building. */
    var mobileQuery = window.matchMedia('(max-width: 768px)');

    function refresh() {
      var shouldShow = mobileQuery.matches ? true : (pastConfigurator && beforeEnd);
      bar.hidden = !shouldShow;
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      bar.classList.toggle('is-visible', shouldShow);
      document.body.classList.toggle('sc-has-sticky-bar', shouldShow);
      /* Real height, not a guess: transforms (used for the slide-in/out)
         don't affect offsetHeight, so this is safe to read regardless of
         the bar's current visibility state. Anything that needs to clear
         the bar — currently Nadia's launcher and mobile bar — reads this
         instead of assuming a fixed pixel value that would silently go
         stale if the bar's own padding or font size ever changes. */
      document.documentElement.style.setProperty(
        '--sc-sticky-bar-height', bar.offsetHeight + 'px');
    }

    /* Hand off from the static price row at the top of the configurator:
       once that row has scrolled out of view, the bar takes over, so
       there is always exactly one price on screen and never two.

       This deliberately observes the price row rather than the whole
       configurator. Observing the configurator only fired once its
       BOTTOM cleared the viewport — that is, after every option had been
       chosen — which left desktop with no visible price for the entire
       time someone was actually building their sofa. A short element
       also crosses the 0 threshold cleanly, whereas a very tall one
       never reports the intermediate scroll positions we need. */
    var startEl = state.rootEl.querySelector('[data-sc-config-pinned]') || configEl;
    var configObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        pastConfigurator = entry.boundingClientRect.bottom < 0;
      });
      refresh();
    }, { rootMargin: '0px 0px 0px 0px', threshold: [0, 1] });
    configObs.observe(startEl);

    /* Watch end sentinel: beforeEnd = true while customer-rooms hasn't
       yet entered the viewport. Once it does, hide the bar. */
    if (endSentinel) {
      var endObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          beforeEnd = !entry.isIntersecting && entry.boundingClientRect.top > 0;
        });
        refresh();
      }, { rootMargin: '0px 0px 0px 0px' });
      endObs.observe(endSentinel);
    }

    /* Crossing the breakpoint (rotation, or a desktop window dragged
       narrow) flips which rule applies, so recompute. addListener is the
       pre-Safari-14 spelling, kept as a fallback. */
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', refresh);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(refresh);
    }

    /* Paint the initial state rather than waiting for the first scroll:
       on mobile the bar should be there from the start. */
    refresh();
  }

  function wireClickHandlers() {
    /* Expand toggle for extra config options (mobile) */
    var expandBtn = state.rootEl.querySelector('[data-sc-config-expand]');
    var extraWrap = state.rootEl.querySelector('[data-sc-config-extra]');
    if (expandBtn && extraWrap) {
      expandBtn.addEventListener('click', function() {
        var isExpanded = extraWrap.classList.toggle('is-expanded');
        expandBtn.classList.toggle('is-expanded', isExpanded);
        expandBtn.querySelector('span').textContent = isExpanded ? 'Fewer options' : 'More options';
      });
    }

    /* Pill clicks for any option in any group */
    state.rootEl.querySelectorAll('[data-sc-config-group]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.disabled || btn.classList.contains('is-disabled')) return;
        var group = btn.getAttribute('data-sc-config-group');
        var value = btn.getAttribute('data-sc-config-value');
        var isBespoke = btn.getAttribute('data-sc-bespoke') === 'true';
        if (isBespoke) {
          handleBespokePick(group, value, btn.getAttribute('data-sc-config-label'));
          return;
        }
        state.selection[group] = value;

        /* Picking a standard (non-bespoke) option clears the bespoke note,
           so the workshop-conversation message doesn't linger after the user
           switches back from a box-pleat / ruffle / COM option. */
        var bespokeNote = state.rootEl.querySelector('[data-sc-config-summary-note]');
        if (bespokeNote) bespokeNote.hidden = true;

        /* Fabric group: also drives sub-selector category swap */
        if (group === 'fabric') {
          updateFabricCategory(value);
        }

        /* When cushion or cover changes, auto-default piping */
        if (group === 'cushion' || group === 'cover') {
          autoDefaultPiping();
        }

        /* When cushion fill changes, recompute arm/back fills */
        if (group === 'cushionFill') {
          computeBackgroundFills();
        }

        revalidate();
        renderSelectionMarks();
        renderSummary();
        renderPrice();
        /* Only refresh imagery for groups that change the sofa's exterior.
           The hero render SKU is built from size/fabric/cushion/cover/piping
           (see updateHeroImage); cushionFill, frame and backCushion are
           internal and do not alter the exterior, so they must not trigger an
           image lookup or CDN fetch. Leg style/finish drive the small leg
           preview only. */
        var HERO_GROUPS = { size: 1, fabric: 1, cushion: 1, cover: 1, piping: 1 };
        var LEG_GROUPS = { legStyle: 1, legFinish: 1, piping: 1, fabric: 1 };
        if (HERO_GROUPS[group]) updateHeroImage();
        if (LEG_GROUPS[group]) updateLegPipingPreviews();
        updateUrl();
      });
    });

    /* Swatch clicks inside the fabric sub-selector. Handles both the
       curated row swatches and the larger ones in the View all expanded
       panel. After a pick from the expanded panel, close it. */
    state.rootEl.querySelectorAll('[data-sc-fabric-handle]').forEach(function(sw) {
      sw.addEventListener('click', function() {
        var row = sw.closest('[data-sc-fabric-cat]');
        if (!row) return;
        var handle = sw.getAttribute('data-sc-fabric-handle');
        var name = sw.getAttribute('data-sc-fabric-name');
        /* Mark every swatch in this category as deselected, then mark
           both the curated and the expanded-panel match for this handle. */
        row.querySelectorAll('[data-sc-fabric-handle]').forEach(function(b) { b.classList.remove('is-selected'); });
        row.querySelectorAll('[data-sc-fabric-handle="' + handle + '"]').forEach(function(b) { b.classList.add('is-selected'); });
        state.fabricHandle = handle;

        /* Auto-default piping based on fabric + cushion combination */
        autoDefaultPiping();

        var nameLabel = row.querySelector('[data-sc-fabric-cat-name]');
        if (nameLabel) nameLabel.textContent = name;
        renderSummary();
        renderPrice();
        updateHeroImage();
        updateLegPipingPreviews();
        updateUrl();
        /* Picking from the expanded panel keeps it open so the user can
           keep comparing fabrics. They close it via the × or View all toggle. */
      });
    });

    /* View all: open the expanded panel for this category. */
    state.rootEl.querySelectorAll('[data-sc-fabric-viewall]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var cat = btn.getAttribute('data-sc-fabric-viewall');
        var row = state.rootEl.querySelector('[data-sc-fabric-cat="' + cat + '"]');
        if (!row) return;
        var expanded = row.querySelector('[data-sc-fabric-expanded]');
        if (expanded) {
          expanded.hidden = false;
          document.body.classList.add('sc-swatch-overlay-open');
        }
      });
    });
    state.rootEl.querySelectorAll('[data-sc-fabric-viewall-close]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var cat = btn.getAttribute('data-sc-fabric-viewall-close');
        var row = state.rootEl.querySelector('[data-sc-fabric-cat="' + cat + '"]');
        if (!row) return;
        var expanded = row.querySelector('[data-sc-fabric-expanded]');
        if (expanded) {
          expanded.hidden = true;
          document.body.classList.remove('sc-swatch-overlay-open');
        }
      });
    });

    /* Action buttons: Save & share, Add to basket */
    state.rootEl.querySelectorAll('[data-sc-config-action]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var action = btn.getAttribute('data-sc-config-action');
        if (action === 'save') handleSave();
        else if (action === 'quote') handleQuote();
      });
    });

    /* Sticky bar action buttons: same handlers as the inline ones */
    document.querySelectorAll('[data-sc-config-sticky-action]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var action = btn.getAttribute('data-sc-config-sticky-action');
        if (action === 'save') handleSave();
        else if (action === 'quote') handleQuote();
      });
    });
  }

  /* Save & share: copy the current URL (already kept in sync) to clipboard,
     show a confirmation strip. */
  function handleSave() {
    var confirm = state.rootEl.querySelector('[data-sc-config-save-confirm]');

    /* Build the config object from current state */
    var sel = getSelection();
    var calc = computePrice();
    var fabricLabel = fabricDisplayName(sel.fabric);
    var rangeName = state.rules.rangeName || 'Sofa';
    var sizeOpt = state.rules.groups.find(function(g) { return g.key === 'size'; })
      .options.find(function(o) { return o.value === sel.size; });
    var heroImg = document.getElementById('sc-gallery-main');

    var buildConfig = {
      range: state.rangeKey,
      rangeName: rangeName,
      size: sel.size,
      fabric: state.fabricHandle || sel.fabric || '',
      fabricName: fabricLabel,
      cushion: sel.cushion || '',
      cover: sel.cover || '',
      piping: sel.piping || '',
      cushionFill: sel.cushionFill || '',
      legStyle: sel.legStyle || '',
      legFinish: sel.legFinish || '',
      frame: sel.frame || '',
      price: calc.total || 0,
      sku: '',
      imageUrl: heroImg ? heroImg.src : '',
      /* The product page this build was configured on, so opening it later
         from anywhere returns to the right sofa. */
      pageUrl: window.location.origin + window.location.pathname
    };

    /* Build the SKU if the resolver is available */
    if (SC.imageResolver && SC.imageResolver.buildSku) {
      buildConfig.sku = SC.imageResolver.buildSku({
        range: state.rangeKey,
        size: sel.size,
        fabric: state.fabricHandle || '',
        cushion: sel.cushion || '',
        cover: sel.cover || '',
        piping: sel.piping || ''
      });
    }

    /* Generate share URL */
    updateUrl();
    var shareUrl = window.location.href;
    var copied = false;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(shareUrl);
        copied = true;
      }
    } catch (e) { copied = false; }

    /* Route through SC.saves */
    if (window.SC && SC.saves) {
      SC.saves.requireSignIn(function() {
        SC.saves.saveBuild(buildConfig);
        flashStickySaveButton('Saved ✓');
        if (confirm) renderInlineSaveConfirm(confirm, copied, true, buildConfig);
      });
    } else {
      /* Fallback: just copy URL */
      flashStickySaveButton(copied ? 'Link copied ✓' : 'Saved ✓');
      if (confirm) renderInlineSaveConfirm(confirm, copied, false, buildConfig);
    }
  }

  function flashStickySaveButton(message) {
    var stickyBtn = document.querySelector('[data-sc-config-sticky-action="save"]');
    if (!stickyBtn) return;
    var original = stickyBtn.textContent;
    stickyBtn.textContent = message;
    stickyBtn.disabled = true;
    setTimeout(function() {
      stickyBtn.textContent = original;
      stickyBtn.disabled = false;
    }, 1800);
  }

  function renderInlineSaveConfirm(confirmEl, copied, savedToAccount, buildConfig) {
    confirmEl.hidden = false;
    var msg = '';
    if (savedToAccount && copied) {
      msg = '<strong>Saved to your account.</strong> Link copied to clipboard. ' +
            '<a href="#" data-sc-config-view-builds>View saved builds &rsaquo;</a>';
    } else if (savedToAccount) {
      msg = '<strong>Saved to your account.</strong> ' +
            '<a href="#" data-sc-config-view-builds>View saved builds &rsaquo;</a>';
    } else if (copied) {
      msg = '<strong>Link copied.</strong> Paste it wherever you need. ' +
            'Or <a href="#" data-sc-config-save-signin>sign in to save it properly</a>.';
    } else {
      msg = '<strong>Saved.</strong> Bookmark this page or copy the URL: ' +
            '<span class="sc-config-save-url">' + window.location.href + '</span>';
    }
    confirmEl.innerHTML = msg;

    /* "View saved builds": open the synced builds overlay */
    var viewLink = confirmEl.querySelector('[data-sc-config-view-builds]');
    if (viewLink) {
      viewLink.addEventListener('click', function(e) {
        e.preventDefault();
        if (window.SC && SC.saves && SC.saves.openBuildsOverlay) SC.saves.openBuildsOverlay();
      });
    }

    /* "Sign in to save it properly": route through the synced saves system,
       then persist the build that's already been assembled this click. */
    var signInLink = confirmEl.querySelector('[data-sc-config-save-signin]');
    if (signInLink) {
      signInLink.addEventListener('click', function(e) {
        e.preventDefault();
        if (window.SC && SC.saves) {
          SC.saves.requireSignIn(function() {
            if (buildConfig) SC.saves.saveBuild(buildConfig);
            renderInlineSaveConfirm(confirmEl, true, true, buildConfig);
          });
        }
      });
    }
  }

  /* Add to basket: in production this posts the configuration to
     the Vercel pricing calculator and opens a quote review panel.
     For the demo the same panel surfaces below the summary, showing
     the full build, terms, and a final commit action. */
  /* Display name for a fabric handle. Prefers the curated SC.fabrics
     name, then falls back to a title-cased handle so labels, quote
     modals and draft-order payloads never show a raw handle or go
     blank. (SC.fabrics currently names 20 of 88 fabrics; the gap and
     the naming plan are in FABRIC-AUDIT-2026-07-02.md.) */
  function fabricDisplayName(handle) {
    if (!handle) return '';
    if (SC.fabrics && SC.fabrics[handle] && SC.fabrics[handle].name) {
      return SC.fabrics[handle].name;
    }
    return String(handle).split('-').map(function(w) {
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }

  function handleQuote() {
    /* If a modal is already open, focus it rather than opening another */
    var existing = document.querySelector('.sc-config-quote-modal');
    if (existing) {
      existing.querySelector('[data-sc-quote-add]').focus();
      return;
    }
    var calc = computePrice();
    var sel = getSelection();
    var fabricName = fabricDisplayName(sel.fabric);
    var sizeOpt = state.rules.groups.find(function(g) { return g.key === 'size'; }).options
      .find(function(o) { return o.value === sel.size; });

    /* Build the line list dynamically. Iterate through configurable
       groups (skip size which goes in the heading, skip fabric which is
       its own line), then append fixed values. */
    var lines = [
      { label: state.rules.rangeName + ' ' + (sizeOpt ? sizeOpt.label : ''), value: '' },
      { label: 'Fabric', value: fabricName }
    ];
    state.rules.groups.forEach(function(group) {
      if (group.key === 'size' || group.key === 'fabric') return;
      var s = state.selection[group.key];
      var o = group.options.find(function(opt) { return opt.value === s; });
      if (o) lines.push({ label: group.label, value: o.label });
    });
    if (state.rules.fixed) {
      Object.keys(state.rules.fixed).forEach(function(key) {
        var f = state.rules.fixed[key];
        lines.push({ label: f.label, value: f.display });
      });
    }

    var linesHtml = lines.map(function(l) {
      return '<li><span>' + l.label + '</span><span>' + l.value + '</span></li>';
    }).join('');

    /* Modal overlay: scrim + centred panel, appended to body so it sits
       above all page content. Always centre-screen, never confused with
       any other on-page element. */
    var overlay = document.createElement('div');
    overlay.className = 'sc-config-quote-modal';
    overlay.setAttribute('data-sc-config-quote-panel', '');
    overlay.innerHTML = '' +
      '<div class="sc-config-quote-modal-scrim"></div>' +
      '<div class="sc-config-quote-modal-panel" role="dialog" aria-modal="true" aria-labelledby="sc-config-quote-title">' +
        '<button type="button" class="sc-config-quote-close" data-sc-quote-close aria-label="Close">&times;</button>' +
        '<div class="sc-config-quote-head">' +
          '<div class="sc-eyebrow">Your ' + state.rules.rangeName + ', priced</div>' +
          '<h3 id="sc-config-quote-title">Ready to commit?</h3>' +
        '</div>' +
        '<ul class="sc-config-quote-lines">' + linesHtml + '</ul>' +
        '<div class="sc-config-quote-totals">' +
          '<div class="sc-config-quote-total-row">' +
            '<span>Total</span><span class="sc-config-quote-total">' + formatPrice(calc.total) + '</span>' +
          '</div>' +
          '<div class="sc-config-quote-terms">' +
            'Lead time: around 8 weeks from order. UK delivery by two-person team, included.' +
          '</div>' +
        '</div>' +
        '<div class="sc-config-quote-actions">' +
          '<button type="button" class="sc-btn sc-btn-primary" data-sc-quote-add>Add to basket</button>' +
          '<button type="button" class="sc-btn sc-btn-secondary" data-sc-quote-talk>Talk this through with Nadia</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    document.body.classList.add('sc-modal-open');
    requestAnimationFrame(function() { overlay.classList.add('is-visible'); });

    function closeModal() {
      overlay.classList.remove('is-visible');
      document.body.classList.remove('sc-modal-open');
      document.removeEventListener('keydown', escListener);
      setTimeout(function() {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 220);
    }
    function escListener(e) { if (e.key === 'Escape') closeModal(); }
    document.addEventListener('keydown', escListener);

    overlay.querySelector('[data-sc-quote-close]').addEventListener('click', closeModal);
    overlay.querySelector('.sc-config-quote-modal-scrim').addEventListener('click', closeModal);
    overlay.querySelector('[data-sc-quote-add]').addEventListener('click', function() {
      var btn = overlay.querySelector('[data-sc-quote-add]');
      var sel = getSelection();
      var calc = computePrice();
      var sizeOpt = state.rules.groups.find(function(g) { return g.key === 'size'; })
        .options.find(function(o) { return o.value === sel.size; });

      /* Build the human-readable config spec lines. Mirrors the quote
         modal list so the drawer/cart displays match what the customer
         just reviewed. */
      var configSummary = [];
      state.rules.groups.forEach(function(group) {
        if (group.key === 'size' || group.key === 'fabric') return;
        var s = state.selection[group.key];
        var o = group.options.find(function(opt) { return opt.value === s; });
        if (!o) return;
        var value = o.label;
        if (group.key === 'piping' && String(s).indexOf('contrast') === 0) {
          var contrastHandle = (SC.contrastPairings || {})[state.fabricHandle];
          if (contrastHandle) value += ' (' + fabricDisplayName(contrastHandle) + ')';
        }
        configSummary.push({ label: group.label, value: value });
      });
      if (state.rules.fixed) {
        Object.keys(state.rules.fixed).forEach(function(key) {
          var f = state.rules.fixed[key];
          configSummary.push({ label: f.label, value: f.display });
        });
      }

      var heroImg = document.getElementById('sc-gallery-main');

      /* Build SKU if resolver is available */
      var sku = '';
      if (SC.imageResolver && SC.imageResolver.buildSku) {
        sku = SC.imageResolver.buildSku({
          range: state.rangeKey, size: sel.size,
          fabric: sel.fabric || '', cushion: sel.cushion || '',
          cover: sel.cover || '', piping: sel.piping || ''
        });
      }

      /* Store in the configured-sofas basket (localStorage). This is
         separate from Shopify's cart because Shopify line items can't
         carry custom prices. The drawer merges both sources, and
         checkout routes through the draft-order endpoint so the order
         is created at the correct price. */
      var entry = {
        id: 'sofa_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8),
        rangeName: state.rules.rangeName,
        rangeKey: state.rangeKey,
        size: sel.size,
        sizeLabel: sizeOpt ? sizeOpt.label : sel.size,
        fabric: sel.fabric || '',
        fabricName: fabricDisplayName(sel.fabric),
        cushion: sel.cushion || '',
        cover: sel.cover || '',
        piping: sel.piping || '',
        cushionFill: sel.cushionFill || '',
        legStyle: sel.legStyle || '',
        legFinish: sel.legFinish || '',
        frame: sel.frame || '',
        price: calc.total,
        sku: sku,
        image: heroImg ? heroImg.src : '',
        shareUrl: window.location.href,
        configSummary: configSummary,
        addedAt: new Date().toISOString()
      };

      if (SC.cart && SC.cart._addConfiguredSofa) {
        SC.cart._addConfiguredSofa(entry);
      }

      btn.textContent = 'Added \u2713';
      btn.disabled = true;
      setTimeout(function() {
        closeModal();
        if (SC.cart && SC.cart.openDrawer) SC.cart.openDrawer();
      }, 400);
    });
    overlay.querySelector('[data-sc-quote-talk]').addEventListener('click', function() {
      openInModalChat();
    });

    /* Transform the modal's lower half (totals + actions) into a Nadia
       chat. The build summary header stays at the top so context is
       visible. The chat is primed with an opener that references the
       current configuration, then uses the product-page Nadia rules
       (from sc-nadia.js) to generate replies. */
    function openInModalChat() {
      var sel = getSelection();
      var calc = computePrice();
      var sizeOpt = state.rules.groups.find(function(g){return g.key==='size';})
        .options.find(function(o){return o.value === sel.size;});
      var fabricName = fabricDisplayName(sel.fabric);
      var sizeLabel = sizeOpt ? sizeOpt.label : sel.size;
      var contextLine = state.rules.rangeName + ' ' + sizeLabel +
        (fabricName ? ' in ' + fabricName : '') +
        ' at ' + formatPrice(calc.total);

      /* Resize the modal panel slightly wider for the chat */
      var panelEl = overlay.querySelector('.sc-config-quote-modal-panel');
      if (panelEl) panelEl.classList.add('is-chat');

      /* Replace the totals + actions block with the chat UI. Build
         summary header at the top stays visible. */
      var totals = overlay.querySelector('.sc-config-quote-totals');
      var actions = overlay.querySelector('.sc-config-quote-actions');
      if (actions && actions.parentNode) actions.parentNode.removeChild(actions);
      if (totals && totals.parentNode) totals.parentNode.removeChild(totals);

      var chatWrap = document.createElement('div');
      chatWrap.className = 'sc-config-quote-chat';
      chatWrap.innerHTML = '' +
        '<div class="sc-config-quote-chat-meta">' +
          '<div class="sc-config-quote-chat-avatar">N</div>' +
          '<div>' +
            '<div class="sc-config-quote-chat-name">Nadia</div>' +
            '<div class="sc-config-quote-chat-sub">Talking about your ' + contextLine + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="sc-config-quote-chat-scroll" data-sc-quote-chat-scroll></div>' +
        '<div class="sc-config-quote-chat-input-row">' +
          '<input class="sc-config-quote-chat-input" type="text" ' +
            'placeholder="Type your message" data-sc-quote-chat-input autocomplete="off" />' +
          '<button class="sc-config-quote-chat-send" type="button" ' +
            'data-sc-quote-chat-send aria-label="Send">&rarr;</button>' +
        '</div>';
      panelEl.appendChild(chatWrap);

      var scroll = chatWrap.querySelector('[data-sc-quote-chat-scroll]');
      var input = chatWrap.querySelector('[data-sc-quote-chat-input]');
      var sendBtn = chatWrap.querySelector('[data-sc-quote-chat-send]');

      /* Opener: reference the build context explicitly */
      var opener = 'You are looking at the ' + contextLine + '. ' +
        'Want me to talk you through whether it suits your room, ' +
        'compare it to something else, or help you choose between fabrics?';
      appendBubble('nadia', opener);

      function appendBubble(from, text) {
        var bubble = document.createElement('div');
        bubble.className = 'sc-config-quote-chat-bubble sc-config-quote-chat-bubble-' + from;
        bubble.textContent = text;
        scroll.appendChild(bubble);
        scroll.scrollTop = scroll.scrollHeight;
      }
      function appendTyping() {
        var t = document.createElement('div');
        t.className = 'sc-config-quote-chat-bubble sc-config-quote-chat-bubble-nadia sc-config-quote-chat-typing';
        t.innerHTML = '<span></span><span></span><span></span>';
        scroll.appendChild(t);
        scroll.scrollTop = scroll.scrollHeight;
        return t;
      }

      function send() {
        var val = input.value.trim();
        if (!val) return;
        appendBubble('customer', val);
        input.value = '';
        /* Use the product-page Nadia script for replies. If sc-nadia.js
           hasn't loaded yet, fall back to a generic reply. */
        var reply;
        if (window.SC && SC.Nadia && SC.Nadia.matchReply) {
          /* Temporarily point Nadia's script to product mode for matching */
          var prevScript = SC.Nadia.script;
          /* SC.Nadia keeps the home script if init() chose it. We re-resolve
             to product script to get the configurator-relevant rules. */
          if (SC.Nadia._scripts && SC.Nadia._scripts.product) {
            SC.Nadia.script = SC.Nadia._scripts.product;
          }
          reply = SC.Nadia.matchReply(val);
          SC.Nadia.script = prevScript;
        } else {
          reply = 'Tell me a bit more about what you are looking for.';
        }
        var typing = appendTyping();
        var delay = Math.min(700 + (reply.length * 6), 1600);
        setTimeout(function() {
          if (typing.parentNode) typing.parentNode.removeChild(typing);
          appendBubble('nadia', reply);
        }, delay);
      }
      sendBtn.addEventListener('click', send);
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); send(); }
      });
      setTimeout(function() { input.focus(); }, 100);
    }
  }

  /* The core rule engine: walks every option in every group and decides
     whether it should be enabled given the current state.selection.
     An option is disabled if its `requires` declares a value for another
     group that doesn't match the current selection.

     Example: piping option 'self-round' has requires.cushion = ['box'].
     If state.selection.cushion === 'knife', this option is disabled.

     After validation, if the customer's currently-selected option in any
     group has become invalid (because they changed an upstream choice),
     we fall back to the first valid option in that group. */
  function revalidate() {
    if (!state.rules) return;
    var changed = false;

    state.rules.groups.forEach(function(group) {
      var firstValid = null;
      group.options.forEach(function(opt) {
        var valid = isOptionValid(opt);
        if (valid && !firstValid && !opt.bespoke) firstValid = opt.value;
      });

      /* If the current selection in this group is now invalid, fall back.
         Resolve to the current market's copy of the value (a value can appear
         once per market), so validity is judged against the right option. */
      var currentValue = state.selection[group.key];
      var currentOpt = group.options.find(function(o) {
        if (o.value !== currentValue) return false;
        if (o.markets && state.market && o.markets.indexOf(state.market) === -1) return false;
        return true;
      });
      if (currentOpt && !isOptionValid(currentOpt) && firstValid) {
        state.selection[group.key] = firstValid;
        changed = true;
      }
    });

    /* If we forced a fallback, run again so transitive constraints settle */
    if (changed) revalidate();
  }

  function isOptionValid(opt) {
    /* Market check: if option has a markets array, it must include the current market */
    if (opt.markets && state.market) {
      if (opt.markets.indexOf(state.market) === -1) return false;
    }
    /* Contrast piping is only offered on body fabrics with a curated
       pairing (SC.contrastPairings in sc-data.js). No pairing, no option. */
    if (opt.requiresContrastPairing) {
      var pairings = SC.contrastPairings || {};
      if (!state.fabricHandle || !pairings[state.fabricHandle]) return false;
    }
    if (!opt.requires) return true;
    var keys = Object.keys(opt.requires);
    for (var i = 0; i < keys.length; i++) {
      var groupKey = keys[i];
      var allowedValues = opt.requires[groupKey];
      var current = state.selection[groupKey];
      if (allowedValues.indexOf(current) === -1) return false;
    }
    return true;
  }

  /* Visually mark which option is selected and which are disabled */
  function renderSelectionMarks() {
    state.rules.groups.forEach(function(group) {
      var selected = state.selection[group.key];
      group.options.forEach(function(opt) {
        /* Some groups list the same value once per market (e.g. a fill offered
           in both UK and US). Only the current market's copy is rendered, and
           both copies share one data-sc-config-value, so the DOM lookup returns
           the same single button. Skip options outside the current market here,
           otherwise a wrong-market duplicate would overwrite the rendered
           button's validity and wrongly disable a valid option. */
        if (opt.markets && state.market && opt.markets.indexOf(state.market) === -1) return;
        var btn = state.rootEl.querySelector('[data-sc-config-group="' + group.key + '"][data-sc-config-value="' + opt.value + '"]');
        if (!btn) return;
        var valid = isOptionValid(opt);
        btn.classList.toggle('is-selected', opt.value === selected);
        btn.classList.toggle('is-disabled', !valid);
        btn.disabled = !valid;
        if (!valid) {
          btn.title = whyDisabled(opt);
        } else {
          btn.removeAttribute('title');
        }
      });

      /* Inline current-value label next to the group title. Restrict to the
         current market's options so a duplicate value resolves to the right
         label. */
      var labelEl = state.rootEl.querySelector('[data-sc-config-current="' + group.key + '"]');
      if (labelEl) {
        var opt = group.options.find(function(o) {
          if (o.value !== selected) return false;
          if (o.markets && state.market && o.markets.indexOf(state.market) === -1) return false;
          return true;
        });
        labelEl.textContent = opt ? opt.label : '';
      }
    });
  }

  function whyDisabled(opt) {
    if (!opt.requires) return '';
    var parts = [];
    Object.keys(opt.requires).forEach(function(groupKey) {
      var values = opt.requires[groupKey];
      var labels = values.map(function(v) {
        var g = state.rules.groups.find(function(g) { return g.key === groupKey; });
        if (!g) return v;
        var o = g.options.find(function(o) { return o.value === v; });
        return o ? o.label : v;
      });
      parts.push('Requires ' + groupKey + ': ' + labels.join(' or '));
    });
    return parts.join('. ');
  }

  function updateFabricCategory(cat) {
    state.rootEl.querySelectorAll('[data-sc-fabric-cat]').forEach(function(row) {
      row.hidden = (row.getAttribute('data-sc-fabric-cat') !== cat);
    });
    /* Switching fabric STYLE only reveals that style's swatches. It must NOT
       change the chosen fabric or the rendered image; the current selection
       persists until the user actually clicks a swatch. If the currently
       selected fabric happens to live in the now-visible row, keep its
       swatch highlighted; otherwise leave none highlighted in this row so it
       is clear no new fabric has been picked yet. */
    var visibleRow = state.rootEl.querySelector('[data-sc-fabric-cat="' + cat + '"]');
    if (visibleRow) {
      visibleRow.querySelectorAll('[data-sc-fabric-handle]').forEach(function(s) {
        s.classList.toggle('is-selected', s.getAttribute('data-sc-fabric-handle') === state.fabricHandle);
      });
    }
  }

  /* Renders the running summary panel: every selected option as a line,
     plus the running price. This is also the shape that gets POSTed to
     the Vercel calculator on Configure & Price submit. */
  function renderSummary() {
    var listEl = state.rootEl.querySelector('[data-sc-config-summary-list]');
    if (!listEl) return;
    var lines = [];
    state.rules.groups.forEach(function(group) {
      var sel = state.selection[group.key];
      var opt = group.options.find(function(o) { return o.value === sel; });
      if (!opt) return;

      /* Skip groups that are hidden from the customer */
      if (group.autoHideIfSingle) {
        var visibleOptions = group.options.filter(function(o) {
          return isOptionValid(o);
        });
        if (visibleOptions.length <= 1) return;
      }

      /* Skip background-only fills */
      if (group.key === 'armCushionFill' || group.key === 'backCushionFill') return;
      var label = opt.label;
      var valHtml = '';
      /* For fabric, show the specific handle name plus a small swatch */
      if (group.key === 'fabric' && state.fabricHandle && SC.fabrics[state.fabricHandle]) {
        label = SC.fabrics[state.fabricHandle].name;
        var swatchImg = (SC.images && SC.images.fabricSwatches && SC.images.fabricSwatches[state.fabricHandle])
          || (SC.fabricImages && SC.fabricImages[state.fabricHandle])
          || null;
        var swatchStyle = swatchImg
          ? 'background-image: url(' + swatchImg + '); background-size: cover; background-position: center;'
          : 'background: linear-gradient(135deg, ' + (SC.fabrics[state.fabricHandle].swatchColour || '#ccc') + ', ' + (SC.fabrics[state.fabricHandle].swatchAccent || '#999') + ');';
        valHtml = '<span class="sc-config-summary-swatch" style="' + swatchStyle + '"></span>' + label;
      } else {
        valHtml = label;
      }
      lines.push('<li><span class="sc-config-summary-key">' + group.label + '</span>' +
        '<span class="sc-config-summary-val">' + valHtml + '</span></li>');
    });

    /* Append any fixed (non-configurable) values for this range, so the
       customer sees the full build at a glance. e.g. Henrietta's "Seat
       cushion: Box edge" or Sophia's "Piping: Soft edge". */
    if (state.rules.fixed) {
      Object.keys(state.rules.fixed).forEach(function(key) {
        var f = state.rules.fixed[key];
        lines.push('<li class="sc-config-summary-fixed">' +
          '<span class="sc-config-summary-key">' + f.label + '</span>' +
          '<span class="sc-config-summary-val">' + f.display + '</span></li>');
      });
    }

    listEl.innerHTML = lines.join('');
  }

  /* Return the current price from the Vercel API. All cost calculation
     now happens server-side; this is just a state accessor. */
  function computePrice() {
    return { total: state.apiPrice || null, breakdown: [] };
  }

  function sizeLabel(sizeValue) {
    var g = state.rules.groups.find(function(g) { return g.key === 'size'; });
    if (!g) return sizeValue;
    var o = g.options.find(function(o) { return o.value === sizeValue; });
    return o ? o.label : sizeValue;
  }

  function formatPrice(amount) {
    if (amount == null) return '';
    var sym = (state.market === 'US') ? '$' : '\u00a3';
    var abs = Math.abs(amount);
    var formatted = sym + abs.toLocaleString();
    return amount < 0 ? '\u2212' + formatted : formatted;
  }

  function renderPrice() {
    /* querySelectorAll, not querySelector: there are now two price nodes
       (the pinned row at the top of the column and the summary panel at
       the bottom). Updating only the first would leave the other showing
       a stale number. */
    var priceEls = state.rootEl.querySelectorAll('[data-sc-config-price]');
    if (!priceEls.length) return;
    var btnPriceEls = state.rootEl.querySelectorAll('[data-sc-config-btn-price]');
    function setPriceText(t) {
      Array.prototype.forEach.call(priceEls, function (el) { el.textContent = t; });
    }
    function setBtnPriceText(t) {
      Array.prototype.forEach.call(btnPriceEls, function (el) { el.textContent = t; });
    }
    function setPriceAttr(k, v) {
      Array.prototype.forEach.call(priceEls, function (el) { el.setAttribute(k, v); });
    }
    function removePriceAttr(k) {
      Array.prototype.forEach.call(priceEls, function (el) { el.removeAttribute(k); });
    }

    /* IMPORTANT: we do NOT show the local computePrice() estimate as the visible
       price. The local estimate and the authoritative price (Vercel, or the
       inline mirror fallback) differ, so writing the estimate first and then
       overwriting it makes a second, different number flash up. Instead we keep
       whatever real price is already on screen (or the initial "From £…"
       placeholder on first load) and only change the number when the
       authoritative response arrives. The local computePrice() is still used
       elsewhere (summary breakdown, quote/basket amounts). */

    if (!(SC.pricingApi && SC.pricingApi.getPrice)) {
      /* No pricing client at all: fall back to the local estimate so a price
         still shows. (Not expected in production.) */
      var calc = computePrice();
      if (calc.total != null) {
        setPriceText(formatPrice(calc.total));
        setBtnPriceText(formatPrice(calc.total));
        renderStickyBar(calc.total);
      }
      return;
    }

    /* Mark the price as refreshing (subtle), so a slow response reads as
       "updating" rather than frozen. Never shows a different number. */
    setPriceAttr('data-sc-price-updating', '1');

    var sel = effectiveSelection();
    sel.fabricHandle = state.fabricHandle;
    var country = state.market || 'UK';
    var payload = SC.pricingApi.buildPayload(sel, state.rangeKey, country || 'UK');
    var token = (renderPrice._token = (renderPrice._token || 0) + 1);
    SC.pricingApi.getPrice(payload).then(function (res) {
      if (token !== renderPrice._token) return;   /* a newer change supersedes */
      removePriceAttr('data-sc-price-updating');
      if (!res || res.price == null || res.available === false) {
        state.apiPrice = null;
        state.apiAvailable = false;
        setPriceText('Price on request');
        setBtnPriceText('Price on request');
        renderStickyBar(null);
        if (res && res._noData) {
          console.warn('[SC pricing] No price for this configuration.', payload);
        }
        setPriceAttr('data-sc-price-source', 'none');
        renderSummary();
        return;
      }
      /* res._mock is set only by the inline mirror; its ABSENCE means the price
         came from the Vercel endpoint. */
      var source = res._mock ? 'inline-mock' : 'vercel';
      setPriceAttr('data-sc-price-source', source);
      if (res._mock) {
        console.warn('[SC pricing] Using INLINE MOCK (Vercel endpoint not reached). Price:', res.price, payload);
      } else {
        console.info('[SC pricing] Live price from Vercel:', res.price);
      }
      /* Store as the single source of truth for all price consumers
         (summary, quote modal, draft order, save-build). */
      state.apiPrice = res.price;
      state.apiAvailable = (res.available !== false);
      setPriceText(formatPrice(res.price));
      setBtnPriceText(formatPrice(res.price));
      renderStickyBar(res.price);
      renderSummary(); /* re-render summary with updated total */
    });
  }

  /* Update the pinned sticky bar's text. Called whenever the price or
     selection changes. The bar's visibility is managed separately by an
     IntersectionObserver. */
  function renderStickyBar(total) {
    var bar = document.querySelector('[data-sc-config-sticky]');
    if (!bar) return;
    var sizeOpt = state.rules.groups.find(function(g) { return g.key === 'size'; }).options
      .find(function(o) { return o.value === state.selection.size; });
    var titleEl = bar.querySelector('[data-sc-config-sticky-title]');
    if (titleEl && sizeOpt) {
      titleEl.textContent = state.rules.rangeName + ' ' + sizeOpt.label;
    }
    /* Compact meta line: fabric, plus the next two configurable groups
       (typically cushion/cover or backCushion/cover depending on range). */
    var metaEl = bar.querySelector('[data-sc-config-sticky-meta]');
    if (metaEl) {
      var fabricName = (state.fabricHandle && SC.fabrics[state.fabricHandle])
        ? SC.fabrics[state.fabricHandle].name : '';
      var parts = [];
      if (fabricName) parts.push(fabricName);
      /* Walk groups looking for any configurable choice that's not size or fabric.
         Stop after we have two meta parts (fabric is already one — keep total to three). */
      state.rules.groups.forEach(function(group) {
        if (parts.length >= 3) return;
        if (group.key === 'size' || group.key === 'fabric') return;
        var sel = state.selection[group.key];
        var opt = group.options.find(function(o) { return o.value === sel; });
        if (!opt) return;
        var label = opt.label.toLowerCase().replace(/, .+$/, '');
        if (group.key === 'cover') label = label.replace('loose', 'loose cover');
        parts.push(label);
      });
      metaEl.textContent = parts.join(', ');
    }
    var priceEl = bar.querySelector('[data-sc-config-sticky-price]');
    if (priceEl) priceEl.textContent = total != null ? formatPrice(total) : 'Price on request';
    /* Disable the sticky Add to basket button when no price is available */
    var stickyBtn = bar.querySelector('[data-sc-config-sticky-quote]');
    if (stickyBtn) stickyBtn.disabled = (total == null);
  }

  /* ── Auto-default piping based on fabric + cushion ── */
  function autoDefaultPiping() {
    if (!state.fabricHandle) return;
    var isBoxEdge = (state.selection.cushion || 'knife') === 'box';

    /* Contrast piping is available only when the selected body fabric
       has a curated pairing in SC.contrastPairings. No mill-code
       inference: the map is the single source of truth. */
    var pairings = SC.contrastPairings || {};
    var isContrast = !!pairings[state.fabricHandle];

    var newPiping;
    if (isBoxEdge) {
      newPiping = isContrast ? 'contrast-round' : 'self-round';
    } else {
      newPiping = isContrast ? 'contrast-flat' : 'self-flat';
    }

    var pipingGroup = state.rules.groups.find(function(g) { return g.key === 'piping'; });
    if (pipingGroup) {
      var opt = pipingGroup.options.find(function(o) { return o.value === newPiping; });
      if (opt && isOptionValid(opt)) {
        state.selection.piping = newPiping;
      }
    }
    revalidate();
    renderSelectionMarks();
  }

  /* Resolve the current fabric code (e.g. 'O14') via the image resolver,
     so the preview filenames can be built the same way as the main SKU. */
  function currentFabricCode() {
    if (!SC.imageResolver) return '';
    var name = (SC.fabrics && SC.fabrics[state.fabricHandle])
      ? SC.fabrics[state.fabricHandle].name
      : (state.fabricHandle || '');
    if (SC.imageResolver._resolveFabricCode) {
      return SC.imageResolver._resolveFabricCode(name) ||
             SC.imageResolver.config.defaultFabricCode || '';
    }
    return SC.imageResolver.config.defaultFabricCode || '';
  }

  /* Show/hide a small "image not available" note inside a preview box.
     Used as the final fallback when neither the real nor the placeholder
     detail shot is on the CDN yet. */
  function setPreviewNote(box, show) {
    if (!box) return;
    var note = box.querySelector('[data-sc-preview-note]');
    if (show) {
      if (!note) {
        note = document.createElement('span');
        note.setAttribute('data-sc-preview-note', '');
        note.textContent = 'Image not available just yet';
        note.style.cssText = 'position:absolute;inset:0;align-items:center;justify-content:center;text-align:center;padding:8px;box-sizing:border-box;font-size:11px;line-height:1.3;color:var(--ink-soft,#8a8378);background:var(--paper-warm,#f3efe7);border:1px solid var(--rule,#e4ddd0);border-radius:4px;';
        box.appendChild(note);
      }
      /* Toggle display directly: an inline display value overrides the
         [hidden] attribute, so we must not rely on note.hidden here. */
      note.style.display = 'flex';
    } else if (note) {
      note.style.display = 'none';
    }
  }

  /* Swap the help text under the legs/piping options to describe the
     currently selected option. Falls back to the group's default help
     when nothing is selected or no blurb exists for that option. */
  function updateOptionBlurbs() {
    if (!state.rootEl) return;
    var blurbs = (window.SC && window.SC.optionBlurbs) || null;
    if (!blurbs) return;
    state.rootEl.querySelectorAll('[data-sc-config-help]').forEach(function(el) {
      var key = el.getAttribute('data-sc-config-help');
      var groupName = key === 'legStyle' ? 'legs' : (key === 'piping' ? 'piping' : null);
      if (!groupName) return;
      var map = blurbs[groupName];
      if (!map) return;
      if (el.getAttribute('data-default-help') === null) {
        el.setAttribute('data-default-help', el.textContent || '');
      }
      var sel = groupName === 'legs' ? (state.selection.legStyle || '') : (state.selection.piping || '');
      var blurb = sel && map[sel];
      el.textContent = blurb ? blurb : (el.getAttribute('data-default-help') || '');
    });
  }

  /* Swap the small leg/piping preview images to match the current fabric +
     selected leg style / piping. Falls back to a Snow Drop placeholder, then
     to a short "not available" note, so a square never simply disappears. */
  function updateLegPipingPreviews() {
    if (!state.rootEl) return;
    updateOptionBlurbs();
    if (!SC.legPipingPreview) return;
    var fabricCode = currentFabricCode();

    state.rootEl.querySelectorAll('[data-sc-config-preview]').forEach(function(box) {
      var group = box.getAttribute('data-sc-config-preview');
      var img = box.querySelector('[data-sc-config-preview-img]');
      if (!img) return;

      var previewOpts = {
        fabricCode: fabricCode,
        piping: state.selection.piping || '',
        legStyle: state.selection.legStyle || '',
        legFinish: state.selection.legFinish || ''
      };
      var realUrl = SC.legPipingPreview.url(group, previewOpts);
      var phUrl = SC.legPipingPreview.placeholderUrl(group, previewOpts);

      /* Nothing selected for this group yet: hide the square. */
      if (!realUrl && !phUrl) { box.hidden = true; img.removeAttribute('src'); setPreviewNote(box, false); return; }

      /* Label for accessibility. */
      var label = group === 'legs'
        ? (state.selection.legStyle || '') + ' leg'
        : (state.selection.piping || '') + ' piping';
      img.alt = label.replace(/-/g, ' ');

      /* Fallback chain: real fabric -> Snow Drop placeholder -> "not available"
         note. The stage attribute stops onerror from looping. */
      img.setAttribute('data-sc-preview-stage', realUrl ? 'real' : 'placeholder');
      img.onerror = function() {
        var stage = img.getAttribute('data-sc-preview-stage');
        if (stage === 'real' && phUrl && phUrl !== realUrl) {
          img.setAttribute('data-sc-preview-stage', 'placeholder');
          img.src = phUrl;
        } else {
          img.setAttribute('data-sc-preview-stage', 'failed');
          img.style.visibility = 'hidden';
          setPreviewNote(box, true);
          box.hidden = false;
        }
      };
      img.onload = function() {
        img.style.visibility = '';
        setPreviewNote(box, false);
        box.hidden = false;
      };
      setPreviewNote(box, false);
      img.style.visibility = '';
      box.hidden = false;
      img.src = realUrl || phUrl;
    });
  }

  function updateHeroImage() {
    if (!state.galleryMain) return;

    /* Use the image resolver if available (R2 CDN or legacy fallback) */
    if (SC.imageResolver && SC.imageResolver.config.cdnBase) {
      var config = {
        range: state.rangeKey,
        size: state.selection.size || '2.5-seater',
        fabric: state.fabricHandle || '',
        fabricCode: null,
        cushion: state.selection.cushion || '',
        cover: state.selection.cover || '',
        piping: state.selection.piping || '',
        view: 'front'
      };

      SC.imageResolver.getImage(config, function(url, matchType, matchedSku) {
        /* Diagnostic (dev stores only): confirms which candidate resolved.
           This was the missing evidence for the Felix/Isobel banner bug. */
        if (window.SC_DEBUG_RESOLVER) {
          console.warn('[SC resolver]', matchType, matchedSku || '(no sku)', url);
        }

        var isRealImage = url && url !== SC.imageResolver.config.placeholder;
        if (isRealImage) {
          state.galleryMain.src = url;
          var name = SC.fabrics && SC.fabrics[state.fabricHandle] ? SC.fabrics[state.fabricHandle].name : state.fabricHandle || '';
          state.galleryMain.alt = state.rules.rangeName + ' ' + (state.selection.size || '') + ' in ' + name;
          document.querySelectorAll('.sc-product-gallery-thumb').forEach(function(b) { b.classList.remove('is-active'); });

          /* Update thumbnails with available views for this config */
          updateThumbnails(config);
        }

        /* Show or hide the fallback banner — ALWAYS, including when no render
           resolved at all ('legacy'). Previously this sat inside the guard
           above, so a total miss kept the old image AND stayed silent: the
           exact Felix/Isobel symptom. On a total miss we now keep the current
           image (better than a grey placeholder) and show the honest
           "get in touch for a visual" banner the resolver intended. */
        updateFallbackBanner(matchType);
      });
      return;
    }

    /* Legacy fallback: use sc-images.js byFabric lookup */
    var productKey = (SC.images && SC.images.productKeyForRange)
      ? SC.images.productKeyForRange(state.rangeKey)
      : 'coco_2_5';
    var rangeProduct = (SC.images && SC.images.product && SC.images.product[productKey]) || null;
    var byFab = (rangeProduct && rangeProduct.byFabric) || {};
    var newSrc = byFab[state.fabricHandle];
    if (!newSrc) return;
    state.galleryMain.src = newSrc;
    var name = SC.fabrics[state.fabricHandle] ? SC.fabrics[state.fabricHandle].name : '';
    state.galleryMain.alt = state.rules.rangeName + ' ' + (state.selection.size || '') + ' in ' + name;
    document.querySelectorAll('.sc-product-gallery-thumb').forEach(function(b) { b.classList.remove('is-active'); });
    renderImageCaption();
  }

  /* ── Fallback banner: shown when the image isn't an exact match ── */
  function updateFallbackBanner(matchType) {
    var gallery = state.galleryMain ? state.galleryMain.closest('.sc-product-gallery') : null;
    if (!gallery) return;

    /* Remove existing banner */
    var existing = gallery.querySelector('.sc-image-fallback-banner');
    if (existing) existing.remove();

    if (matchType === 'exact') return; /* Perfect match, no banner needed */

    /* Two classes of banner. A near-match ("shown with default piping")
       is a small caveat. A missing-render ("we have no imagery for this
       fabric") is the one customers most need to notice, and the one
       worth offering a way out of, so it gets the stronger treatment and
       the CTA. */
    var message = '';
    var isMissingImagery = false;
    if (matchType === 'fabric-cushion-default-piping') {
      message = 'Shown with default piping for this fabric and cushion style.';
    } else if (matchType === 'fabric-default-style') {
      message = 'Shown in the default style for this fabric. Your configuration may look slightly different.';
    } else if (matchType === 'default-fabric-selected-cushion') {
      message = 'We do not have imagery for this fabric yet. Sofa shown in Capelo Snow Drop with your selected cushion style.';
      isMissingImagery = true;
    } else if (matchType === 'default-fabric-selected-style') {
      message = 'We do not have imagery for this fabric yet. Sofa shown in Capelo Snow Drop with your selected style options.';
      isMissingImagery = true;
    } else if (matchType === 'full-default') {
      message = 'Imagery is not yet available for this configuration. Shown in Capelo Snow Drop.';
      isMissingImagery = true;
    } else if (matchType === 'legacy') {
      message = 'Imagery is not yet available for this configuration.';
      isMissingImagery = true;
    }

    if (!message) return;

    var cms = (SC._sectionSettings) || {};
    var ctaLabel = cms.renderCtaLabel || '';
    var ctaUrl = cms.renderCtaUrl || '/pages/contact';

    var banner = document.createElement('div');
    banner.className = 'sc-image-fallback-banner' +
      (isMissingImagery ? ' is-missing-imagery' : '');
    var html = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="flex-shrink:0"><circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.25"/><path d="M8 4.5v4" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/><circle cx="8" cy="11.5" r="0.75" fill="currentColor"/></svg>' +
      '<div class="sc-image-fallback-body"><span>' + message + '</span>';
    if (isMissingImagery && ctaLabel) {
      html += '<a class="sc-image-fallback-cta" href="' + ctaUrl + '">' +
        ctaLabel + '<span aria-hidden="true">&nbsp;&rsaquo;</span></a>';
    }
    html += '</div>';
    banner.innerHTML = html;
    gallery.appendChild(banner);
  }

  /* ── Thumbnails: show available views for the current configuration ── */
  function updateThumbnails(config) {
    if (!SC.imageResolver || !SC.imageResolver.getAvailableViews) return;
    var thumbStrip = state.galleryMain ? state.galleryMain.closest('.sc-product-gallery') : null;
    if (!thumbStrip) return;
    var thumbRow = thumbStrip.querySelector('.sc-product-gallery-thumbs');
    if (!thumbRow) return;

    /* Capture the Liquid-rendered lifestyle thumbs once, so render
       views never permanently wipe them: they are re-appended after
       the views on every rebuild. */
    if (!state.lifestyleThumbEls) {
      state.lifestyleThumbEls = Array.prototype.slice.call(
        thumbRow.querySelectorAll('[data-sc-gallery-pick]')
      ).map(function(el) { return el.cloneNode(true); });
    }
    SC.imageResolver.getAvailableViews(config, function(views) {
      if (views.length === 0) return; /* Keep existing thumbnails */

      thumbRow.innerHTML = '';
      views.forEach(function(v, i) {
        var viewLabel = { front: 'Front', side: 'Side', rear: 'Rear', detail: 'Detail' }[v.view] || v.view;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sc-product-gallery-thumb' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', viewLabel + ' view');
        btn.title = viewLabel;
        btn.innerHTML = '<img src="' + v.url + '" alt="' + viewLabel + ' view" loading="lazy" />';
        btn.addEventListener('click', function() {
          state.galleryMain.src = v.url;
          thumbRow.querySelectorAll('.sc-product-gallery-thumb').forEach(function(t) { t.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
        thumbRow.appendChild(btn);
      });

      /* Append Shopify product images after the CDN render views */
      var productKey = (SC.images && SC.images.productKeyForRange)
        ? SC.images.productKeyForRange(state.rangeKey)
        : state.rangeKey + '_2_5';
      var rangeProduct = (SC.images && SC.images.product && SC.images.product[productKey]) || {};
      var shopifyImgs = rangeProduct.shopifyGallery || [];
      shopifyImgs.forEach(function(img) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sc-product-gallery-thumb';
        btn.innerHTML = '<img src="' + img.src + '" alt="' + img.alt + '" loading="lazy" />';
        btn.addEventListener('click', function() {
          state.galleryMain.src = img.src;
          state.galleryMain.alt = img.alt;
          thumbRow.querySelectorAll('.sc-product-gallery-thumb').forEach(function(t) { t.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
        thumbRow.appendChild(btn);
      });
      /* Lifestyle imagery follows the renders */
      (state.lifestyleThumbEls || []).forEach(function(orig) {
        var el = orig.cloneNode(true);
        el.classList.remove('is-active');
        el.addEventListener('click', function() {
          state.galleryMain.src = el.getAttribute('data-sc-gallery-pick');
          thumbRow.querySelectorAll('.sc-product-gallery-thumb').forEach(function(t) { t.classList.remove('is-active'); });
          el.classList.add('is-active');
        });
        thumbRow.appendChild(el);
      });
    });
  }

  function renderImageCaption() {
    var capId = 'sc-gallery-caption';
    var existing = document.getElementById(capId);
    var imagerySize = '2.5-seater';
    var currentSize = state.selection.size;
    var caption = '';
    if (currentSize !== imagerySize) {
      var sizeLabel = state.rules.groups.find(function(g) { return g.key === 'size'; })
        .options.find(function(o) { return o.value === currentSize; }).label;
      caption = 'Shown: 2.5-seater. Your ' + sizeLabel + ' will share the same fabric and finish.';
    }
    if (!existing) {
      var gallery = state.galleryMain && state.galleryMain.closest('.sc-product-gallery');
      if (gallery) {
        var node = document.createElement('div');
        node.id = capId;
        node.className = 'sc-gallery-caption';
        gallery.appendChild(node);
        existing = node;
      }
    }
    if (existing) {
      existing.textContent = caption;
      existing.hidden = !caption;
    }
  }

  function handleBespokePick(group, value, label) {
    var noteEl = state.rootEl.querySelector('[data-sc-config-summary-note]');
    if (!noteEl) return;
    noteEl.hidden = false;
    noteEl.innerHTML = '<strong>' + label + '</strong> is made bespoke. ' +
      'Email <a href="mailto:sofas@sophieconran.com">sofas@sophieconran.com</a> and we\'ll quote you within a working day.';
  }

  /* Shareable URL: encodes the current state as ?config=size:fabric:cushion:cover:piping:backCushion:frame
     For ranges that don't have all groups (e.g. Henrietta has no cushion or cover),
     the slot is empty and parseUrlConfig ignores empty parts. */
  function updateUrl() {
    if (!window.history || !window.history.replaceState) return;
    var parts = [
      state.selection.size || '',
      state.fabricHandle || '',
      state.selection.cushion || '',
      state.selection.cover || '',
      state.selection.piping || '',
      state.selection.backCushion || '',
      state.selection.frame || ''
    ];
    var qs = parts.join(':');
    var url = new URL(window.location.href);
    url.searchParams.set('config', qs);
    window.history.replaceState({}, '', url.toString());
  }

  function parseUrlConfig() {
    if (!window.location) return false;
    var url = new URL(window.location.href);
    var didRestore = false;
    /* Distinct from didRestore: whether the URL itself named a piping
       value, versus the piping key simply being absent (as from a gallery
       pin or a quiz-saved build, which know only range/size/fabric). Only
       in the second case should autoDefaultPiping() run after restore —
       an explicit piping in the URL must never be silently overridden. */
    state._pipingRestoredFromUrl = false;

    var qs = url.searchParams.get('config');
    if (qs) {
      /* Saved builds (SC.saves.buildShareUrl) encode the config as base64 of
         "range=..&size=..&fabric=..&cushion=..&cover=..&piping=..&cushionFill=
         ..&legStyle=..&legFinish=..&frame=..". Decode that first. */
      var applied = false;
      try {
        var decoded = atob(qs);
        if (decoded.indexOf('=') !== -1) {
          decoded.split('&').forEach(function(pair) {
            var kv = pair.split('=');
            if (kv.length !== 2) return;
            var k = decodeURIComponent(kv[0]);
            var v = decodeURIComponent(kv[1]);
            if (k === 'range') { /* range drives which rules load; handled by rangeKey resolution */ state.selection._range = v; }
            else if (k === 'fabric') state.fabricHandle = v;
            else if (k === 'size') state.selection.size = v;
            else if (k === 'cushion') state.selection.cushion = v;
            else if (k === 'cover') state.selection.cover = v;
            else if (k === 'piping') { state.selection.piping = v; state._pipingRestoredFromUrl = true; }
            else if (k === 'cushionFill') state.selection.cushionFill = v;
            else if (k === 'legStyle') state.selection.legStyle = v;
            else if (k === 'legFinish') state.selection.legFinish = v;
            else if (k === 'frame') state.selection.frame = v;
            else if (k === 'backCushion') state.selection.backCushion = v;
          });
          applied = true;
          didRestore = true;
        }
      } catch (e) { /* not base64 — fall through to the legacy colon format */ }

      /* Legacy Format 1: ?config=size:fabric:cushion:cover:piping:back:frame */
      if (!applied) {
        var parts = qs.split(':');
        if (parts[0]) state.selection.size = parts[0];
        if (parts[1]) state.fabricHandle = parts[1];
        if (parts[2]) state.selection.cushion = parts[2];
        if (parts[3]) state.selection.cover = parts[3];
        if (parts[4]) { state.selection.piping = parts[4]; state._pipingRestoredFromUrl = true; }
        if (parts[5]) state.selection.backCushion = parts[5];
        if (parts[6]) state.selection.frame = parts[6];
        if (parts[0] || parts[1]) didRestore = true;
      }
    }

    /* Format 2: individual params ?size=2.5-seater&fabric=cool-coconut&... */
    var paramSize = url.searchParams.get('size');
    var paramFabric = url.searchParams.get('fabric');
    var paramCushion = url.searchParams.get('cushion');
    var paramCover = url.searchParams.get('cover');
    var paramPiping = url.searchParams.get('piping');
    var paramCushionFill = url.searchParams.get('cushionFill');
    var paramLegStyle = url.searchParams.get('legStyle');
    var paramLegFinish = url.searchParams.get('legFinish');
    var paramFrame = url.searchParams.get('frame');

    if (paramSize) { state.selection.size = paramSize; didRestore = true; }
    if (paramFabric) { state.fabricHandle = paramFabric; didRestore = true; }
    if (paramCushion) state.selection.cushion = paramCushion;
    if (paramCover) state.selection.cover = paramCover;
    if (paramPiping) { state.selection.piping = paramPiping; state._pipingRestoredFromUrl = true; }
    if (paramCushionFill) state.selection.cushionFill = paramCushionFill;
    if (paramLegStyle) state.selection.legStyle = paramLegStyle;
    if (paramLegFinish) state.selection.legFinish = paramLegFinish;
    if (paramFrame) state.selection.frame = paramFrame;

    /* Make fabric category match the chosen handle */
    if (state.fabricHandle) {
      var _lib2 = (state.rules && state.rules.fabricSource === 'jlp')
        ? ((SC.jlpFabricsByRange && SC.jlpFabricsByRange[state.rangeKey]) || SC.jlpFabricCategories || {})
        : (SC.fabricCategories || {});
      Object.keys(_lib2).forEach(function(cat) {
        if (_lib2[cat].indexOf(state.fabricHandle) > -1) {
          state.selection.fabric = cat;
        }
      });
    }
    return didRestore;
  }

  /* Public API: get current configuration as a structured object.
     This is the payload that posts to the Vercel calculator. */
  /* Effective configuration = the user's selections overlaid with the
     range's fixed (non-choosable) attributes from rules.fixed. Ranges
     like Felix and Isobel define cushion/backCushion as fixed rather
     than as selectable groups, so any consumer reading state.selection
     alone gets an incomplete configuration: the pricing API received
     cushion: null for those ranges and could not price them. Pricing,
     SKUs, draft orders and saved builds must all read from here. (The
     image resolver has its own MODEL_DEFAULTS safety net for the same
     gap; display code reads rules.fixed directly for labels.) */
  function effectiveSelection() {
    var out = {};
    Object.keys(state.selection).forEach(function(k) { out[k] = state.selection[k]; });
    if (state.rules && state.rules.fixed) {
      Object.keys(state.rules.fixed).forEach(function(k) {
        if (out[k] == null) out[k] = state.rules.fixed[k].value;
      });
    }
    return out;
  }

  function getSelection() {
    var eff = effectiveSelection();
    return {
      range: state.rangeKey,
      size: eff.size,
      fabric: state.fabricHandle,
      fabricCategory: eff.fabric,
      cushion: eff.cushion,
      backCushion: eff.backCushion,
      cover: eff.cover,
      piping: eff.piping,
      pipingFabric: (eff.piping && String(eff.piping).indexOf('contrast') === 0 &&
        state.fabricHandle && (SC.contrastPairings || {})[state.fabricHandle]) || null,
      cushionFill: eff.cushionFill,
      legStyle: eff.legStyle,
      legFinish: eff.legFinish,
      frame: eff.frame
    };
  }

  return {
    init: init,
    getSelection: getSelection,
    getCurrentPrice: function() {
      try {
        var calc = computePrice();
        return calc && calc.total != null ? calc.total : null;
      } catch (e) { return null; }
    },
    getCurrentImage: function() {
      if (!state.galleryMain) return null;
      return {
        src: state.galleryMain.src || null,
        alt: state.galleryMain.alt || ''
      };
    }
  };
})();

/* ============================================================
   IN STOCK NOW PAGE
   Distinct landing for time-poor buyers. Filter row + card grid.
   ============================================================ */




/* Page binder for the in-stock-now page */
SC.bindStockPage = function() {
  var items = Array.prototype.slice.call(document.querySelectorAll('[data-sc-stock-item]'));
  var emptyMsg = document.querySelector('.sc-stock-empty');
  var countLabel = document.querySelector('[data-sc-filter-count]');
  var clearBtn = document.querySelector('[data-sc-filter-clear]');

  function isFamily(item) {
    var f = SC.fabrics[item.fabric];
    return !!(f && f.family === true);
  }
  function isSleeper(item) {
    return /sofa\s*bed|sleeper/i.test(item.rangeName);
  }
  function isStriped(item) {
    var f = SC.fabrics[item.fabric];
    return !!(f && f.print === 'stripe');
  }
  function isVelvet(item) {
    var f = SC.fabrics[item.fabric];
    return !!(f && f.print === 'velvet');
  }
  function isPlainLinen(item) {
    var f = SC.fabrics[item.fabric];
    if (!f) return false;
    return !f.print && f.composition && /cotton-linen|linen|plain/i.test(f.composition);
  }

  function applyFilter(key) {
    var visible = 0;
    items.forEach(function(node) {
      var i = parseInt(node.getAttribute('data-sc-stock-i'), 10);
      var item = SC.stockNow[i];
      var show = true;
      if (key === 'lead-3-4') show = item.leadWeeks >= 3 && item.leadWeeks <= 4;
      else if (key === 'lead-5-6') show = item.leadWeeks >= 5 && item.leadWeeks <= 6;
      else if (key === 'family') show = isFamily(item);
      else if (key === 'sleeper') show = isSleeper(item);
      else if (key === 'plain') show = isPlainLinen(item);
      else if (key === 'striped') show = isStriped(item);
      else if (key === 'velvet') show = isVelvet(item);
      // 'all' or anything else: show everything
      node.hidden = !show;
      if (show) visible++;
    });
    if (emptyMsg) emptyMsg.hidden = visible !== 0;
    if (countLabel) countLabel.textContent = visible + ' showing';
    if (clearBtn) clearBtn.hidden = (key === 'all');
  }

  document.querySelectorAll('[data-sc-filter]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('[data-sc-filter]').forEach(function(b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      applyFilter(btn.getAttribute('data-sc-filter'));
    });
  });
  if (clearBtn) {
    clearBtn.addEventListener('click', function() {
      document.querySelectorAll('[data-sc-filter]').forEach(function(b) { b.classList.remove('is-selected'); });
      var allBtn = document.querySelector('[data-sc-filter="all"]');
      if (allBtn) allBtn.classList.add('is-selected');
      applyFilter('all');
    });
  }
  // Initial state: show count
  applyFilter('all');
};

/* ============================================================
   JOHN LEWIS PAGE
   Sophie Conran for John Lewis. Cocobella as the headline range,
   Felix as the second route, Coco vs Cocobella comparison table
   as the centerpiece.
   ============================================================ */



/* Cocobella fabric grid: tile per fabric using hex swatches from data */

/* Coco vs Cocobella comparison table */

/* Key features strip on dark navy background */

/* ============================================================
   PORTMEIRION PAGE
   Sophie Conran for Portmeirion sold direct via drop-ship from
   Portmeirion. UK→UK, US→US, no cross-border. Largest non-furniture
   revenue line. The 20-year story is the editorial frame, real
   shopping is the function.
   ============================================================ */

/* Wide editorial hero with banner-style image and overlay content */
SC.components.portmeirionHero = function(opts) {
  opts = opts || {};
  var eyebrow = opts.eyebrow || 'Sophie Conran for Portmeirion · since 2006';
  var heading = opts.heading || 'Twenty years of china, designed for the table you actually <em>sit at</em>.';
  var lede = opts.lede || 'The longest-running collaboration in the brand. Plates and bowls and mugs that have been on half a million British tables for two decades. Made in partnership with Portmeirion.';
  var primaryLabel = opts.primaryLabel || 'Shop the bestsellers';
  var primaryUrl = opts.primaryUrl || 'portmeirion-bestsellers.html';
  var secondaryLabel = opts.secondaryLabel || 'Read the story';
  var secondaryUrl = opts.secondaryUrl || '#story';
  var actions = '';
  if (primaryLabel) {
    actions += '<a class="sc-btn sc-btn-primary" href="' + primaryUrl + '">' + primaryLabel + '</a>';
  }
  if (secondaryLabel) {
    actions += '<a class="sc-btn sc-btn-secondary" href="' + secondaryUrl + '">' + secondaryLabel + '</a>';
  }
  return '' +
    '<section class="sc-pm-hero">' +
      '<div class="sc-pm-hero-image">' +
        '<img src="' + (opts.image || 'assets/img/portmeirion-hero.jpg') + '" alt="' + (opts.alt || 'Sophie Conran for Portmeirion on a long table at Christmas') + '" />' +
      '</div>' +
      '<div class="sc-pm-hero-content">' +
        '<div class="sc-container">' +
          '<div class="sc-eyebrow">' + eyebrow + '</div>' +
          '<h1 class="sc-display-1">' + heading + '</h1>' +
          '<p class="sc-lede">' + lede + '</p>' +
          (actions ? '<div class="sc-pm-hero-actions">' + actions + '</div>' : '') +
        '</div>' +
      '</div>' +
    '</section>';
};

/* Six-tile collection grid */

/* Featured products row: real prices, real add-to-cart feel */

/* The 20-year story: editorial in Sophie's voice */

/* ============================================================
   PORTMEIRION INTRO — "How can we help?"
   ============================================================
   A customer-centric welcome panel that recognises three different
   visitors to this page: gift-buyers, first-time collection-starters,
   and people adding to a collection they already own. Plus an honest
   "I'd just like to browse" path for the people who don't want help.

   The panel sits between the story and the collections grid. It is
   stateful — clicking any of the four doors expands a focused panel
   underneath it with the relevant flow:

   1) BROWSE  — quietly scrolls down to the collections grid.
   2) GIFT    — three short questions (recipient, occasion, budget)
                and a recommendation slot at the end. Recommendation
                logic is in JS, results render as bestseller cards.
   3) START   — "how many people do you want to set the table for?"
                Then we present the starter set (the actual #1
                bestseller, the White Porcelain Twelve Piece Dining
                Set), plus a suggestion to add mugs and pasta bowls.
   4) ADD     — "see what's new" or "look up a previous order"
                (the previous-order path is a soft demo — opens the
                account modal if the user is signed in, otherwise
                offers to find the order by email).

   All flows render inline; no page navigation. Each flow has a
   "back" affordance to return to the four-door state. The whole
   thing is one component so it's easy to drop in and out.
*/
SC.components.portmeirionIntro = function() {
  return '' +
    '<section class="sc-section sc-pm-intro-section" id="how-can-we-help">' +
      '<div class="sc-container-wide">' +

        /* Headline + lede. Warm, in Sophie's voice, acknowledges
           that visitors to a 20-year collection arrive with very
           different intentions. */
        '<div class="sc-pm-intro-head">' +
          '<div class="sc-eyebrow">Welcome</div>' +
          '<h2 class="sc-display-2">Come on in. <em>I\'m glad you\'re here.</em></h2>' +
          '<p class="sc-lede">Some people land here looking for a gift. Some are setting their first proper table. Some have been collecting these pieces for years and want to know what\'s new. All of you are very welcome.</p>' +
        '</div>' +

        /* The four doors. Each is a button that toggles its
           matching panel. Browse is the quiet one on the far right. */
        '<div class="sc-pm-doors" data-pm-doors>' +

          /* Door 1: GIFT */
          '<button class="sc-pm-door" type="button" data-pm-door="gift" aria-expanded="false" aria-controls="pm-flow-gift">' +
            '<div class="sc-pm-door-icon">' +
              /* Ribbon-on-a-box icon */
              '<svg width="44" height="44" viewBox="0 0 44 44" aria-hidden="true">' +
                '<rect x="6" y="14" width="32" height="24" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
                '<line x1="6" y1="22" x2="38" y2="22" stroke="currentColor" stroke-width="1.4"/>' +
                '<line x1="22" y1="14" x2="22" y2="38" stroke="currentColor" stroke-width="1.4"/>' +
                '<path d="M14 14 C 14 8, 22 8, 22 14 C 22 8, 30 8, 30 14" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
              '</svg>' +
            '</div>' +
            '<div class="sc-pm-door-body">' +
              '<div class="sc-pm-door-eyebrow">For someone else</div>' +
              '<div class="sc-pm-door-title">Find a gift</div>' +
              '<div class="sc-pm-door-meta">Three short questions. We\'ll show you the pieces people love receiving.</div>' +
            '</div>' +
            '<div class="sc-pm-door-arrow" aria-hidden="true">&rsaquo;</div>' +
          '</button>' +

          /* Door 2: START */
          '<button class="sc-pm-door" type="button" data-pm-door="start" aria-expanded="false" aria-controls="pm-flow-start">' +
            '<div class="sc-pm-door-icon">' +
              /* Stacked plates icon */
              '<svg width="44" height="44" viewBox="0 0 44 44" aria-hidden="true">' +
                '<ellipse cx="22" cy="32" rx="16" ry="3.5" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
                '<ellipse cx="22" cy="24" rx="14" ry="3" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
                '<ellipse cx="22" cy="17" rx="12" ry="2.5" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
                '<ellipse cx="22" cy="11" rx="10" ry="2.2" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
              '</svg>' +
            '</div>' +
            '<div class="sc-pm-door-body">' +
              '<div class="sc-pm-door-eyebrow">First time</div>' +
              '<div class="sc-pm-door-title">Start a collection</div>' +
              '<div class="sc-pm-door-meta">Tell us how many you\'re setting the table for. We\'ll suggest the starter pieces.</div>' +
            '</div>' +
            '<div class="sc-pm-door-arrow" aria-hidden="true">&rsaquo;</div>' +
          '</button>' +

          /* Door 3: ADD */
          '<button class="sc-pm-door" type="button" data-pm-door="add" aria-expanded="false" aria-controls="pm-flow-add">' +
            '<div class="sc-pm-door-icon">' +
              /* Plus on a plate icon */
              '<svg width="44" height="44" viewBox="0 0 44 44" aria-hidden="true">' +
                '<circle cx="22" cy="22" r="14" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
                '<circle cx="22" cy="22" r="9" fill="none" stroke="currentColor" stroke-width="1"/>' +
                '<line x1="22" y1="18" x2="22" y2="26" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
                '<line x1="18" y1="22" x2="26" y2="22" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
              '</svg>' +
            '</div>' +
            '<div class="sc-pm-door-body">' +
              '<div class="sc-pm-door-eyebrow">Already collecting</div>' +
              '<div class="sc-pm-door-title">Add to my collection</div>' +
              '<div class="sc-pm-door-meta">See what\'s new since you last visited, or look up a previous order.</div>' +
            '</div>' +
            '<div class="sc-pm-door-arrow" aria-hidden="true">&rsaquo;</div>' +
          '</button>' +

          /* Door 4: BROWSE — quieter, the "no thanks" door */
          '<button class="sc-pm-door sc-pm-door-quiet" type="button" data-pm-door="browse" aria-expanded="false" aria-controls="pm-flow-browse">' +
            '<div class="sc-pm-door-icon">' +
              /* Eye icon */
              '<svg width="44" height="44" viewBox="0 0 44 44" aria-hidden="true">' +
                '<path d="M6 22 C 12 14, 32 14, 38 22 C 32 30, 12 30, 6 22 Z" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
                '<circle cx="22" cy="22" r="5" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
              '</svg>' +
            '</div>' +
            '<div class="sc-pm-door-body">' +
              '<div class="sc-pm-door-eyebrow">No help needed</div>' +
              '<div class="sc-pm-door-title">Just browsing</div>' +
              '<div class="sc-pm-door-meta">Take me to the bestsellers and let me have a look around.</div>' +
            '</div>' +
            '<div class="sc-pm-door-arrow" aria-hidden="true">&rsaquo;</div>' +
          '</button>' +

        '</div>' +

        /* The flow panels. All hidden by default; one is revealed when
           its door is clicked. Each has its own back button. */

        /* === GIFT FLOW === */
        '<div class="sc-pm-flow" id="pm-flow-gift" data-pm-flow="gift" hidden>' +
          '<div class="sc-pm-flow-inner">' +
            '<div class="sc-pm-flow-head">' +
              '<button class="sc-pm-flow-back" type="button" data-pm-flow-close aria-label="Back to the four options">&lsaquo; Back</button>' +
              '<div class="sc-eyebrow">Find a gift</div>' +
              '<h3 class="sc-pm-flow-title">A few questions, and we\'ll <em>narrow it down</em>.</h3>' +
            '</div>' +

            '<div class="sc-pm-quiz" data-pm-quiz="gift">' +

              /* Q1: Who is it for? */
              '<div class="sc-pm-q">' +
                '<div class="sc-pm-q-label"><span class="sc-pm-q-num">1</span>Who is it for?</div>' +
                '<div class="sc-pm-q-options">' +
                  '<label class="sc-pm-chip"><input type="radio" name="gift-recipient" value="couple" checked /><span>A couple setting up home</span></label>' +
                  '<label class="sc-pm-chip"><input type="radio" name="gift-recipient" value="host" /><span>Someone who loves to host</span></label>' +
                  '<label class="sc-pm-chip"><input type="radio" name="gift-recipient" value="mum" /><span>A parent or grandparent</span></label>' +
                  '<label class="sc-pm-chip"><input type="radio" name="gift-recipient" value="friend" /><span>A friend, just because</span></label>' +
                '</div>' +
              '</div>' +

              /* Q2: Occasion */
              '<div class="sc-pm-q">' +
                '<div class="sc-pm-q-label"><span class="sc-pm-q-num">2</span>What\'s the occasion?</div>' +
                '<div class="sc-pm-q-options">' +
                  '<label class="sc-pm-chip"><input type="radio" name="gift-occasion" value="wedding" checked /><span>Wedding or engagement</span></label>' +
                  '<label class="sc-pm-chip"><input type="radio" name="gift-occasion" value="birthday" /><span>Birthday</span></label>' +
                  '<label class="sc-pm-chip"><input type="radio" name="gift-occasion" value="housewarming" /><span>Housewarming</span></label>' +
                  '<label class="sc-pm-chip"><input type="radio" name="gift-occasion" value="christmas" /><span>Christmas or holidays</span></label>' +
                  '<label class="sc-pm-chip"><input type="radio" name="gift-occasion" value="thankyou" /><span>A thank-you</span></label>' +
                '</div>' +
              '</div>' +

              /* Q3: Budget */
              '<div class="sc-pm-q">' +
                '<div class="sc-pm-q-label"><span class="sc-pm-q-num">3</span>Roughly what budget?</div>' +
                '<div class="sc-pm-q-options">' +
                  '<label class="sc-pm-chip"><input type="radio" name="gift-budget" value="under30" /><span>Under £30</span></label>' +
                  '<label class="sc-pm-chip"><input type="radio" name="gift-budget" value="30to60" checked /><span>£30 to £60</span></label>' +
                  '<label class="sc-pm-chip"><input type="radio" name="gift-budget" value="60to100" /><span>£60 to £100</span></label>' +
                  '<label class="sc-pm-chip"><input type="radio" name="gift-budget" value="over100" /><span>Over £100</span></label>' +
                '</div>' +
              '</div>' +

              /* Results slot, filled by JS in SC.portmeirionIntro.bind */
              '<div class="sc-pm-quiz-results" data-pm-quiz-results>' +
                '<div class="sc-pm-quiz-results-head">' +
                  '<div class="sc-eyebrow">Suggested for you</div>' +
                  '<h4 class="sc-pm-quiz-results-title" data-pm-quiz-title>Three pieces we think they\'ll love</h4>' +
                  '<p class="sc-pm-quiz-results-note" data-pm-quiz-note>Pick any of the three options above to refine the result.</p>' +
                '</div>' +
                '<div class="sc-pm-quiz-cards" data-pm-quiz-cards></div>' +
              '</div>' +

            '</div>' +
          '</div>' +
        '</div>' +

        /* === START FLOW === */
        '<div class="sc-pm-flow" id="pm-flow-start" data-pm-flow="start" hidden>' +
          '<div class="sc-pm-flow-inner">' +
            '<div class="sc-pm-flow-head">' +
              '<button class="sc-pm-flow-back" type="button" data-pm-flow-close aria-label="Back to the four options">&lsaquo; Back</button>' +
              '<div class="sc-eyebrow">Start a collection</div>' +
              '<h3 class="sc-pm-flow-title">Most people start with the same set. <em>It\'s the right way in.</em></h3>' +
              '<p class="sc-pm-flow-lede">In twenty years, this is the piece most often bought as a first set: the White Porcelain Twelve Piece Dining Set. Dinner plates, side plates and cereal bowls, four of each. It\'s the foundation. Everything else builds onto it.</p>' +
            '</div>' +

            /* Seat counter — pleasant numeric stepper */
            '<div class="sc-pm-seats">' +
              '<div class="sc-pm-seats-label">How many do you set the table for?</div>' +
              '<div class="sc-pm-seats-control" data-pm-seats>' +
                '<button class="sc-pm-seats-btn" type="button" data-pm-seats-dec aria-label="Fewer">&minus;</button>' +
                '<div class="sc-pm-seats-value">' +
                  '<span data-pm-seats-num>4</span>' +
                  '<span class="sc-pm-seats-suffix"> people</span>' +
                '</div>' +
                '<button class="sc-pm-seats-btn" type="button" data-pm-seats-inc aria-label="More">+</button>' +
              '</div>' +
              '<div class="sc-pm-seats-note" data-pm-seats-note>The standard set serves four. We\'ll suggest doubling up if you set the table for more.</div>' +
            '</div>' +

            /* Suggestion stack — starter set up top, then companions */
            '<div class="sc-pm-starter">' +
              '<div class="sc-pm-starter-head">' +
                '<div class="sc-pm-starter-rank">01</div>' +
                '<div>' +
                  '<div class="sc-pm-starter-eyebrow">The starter set</div>' +
                  '<div class="sc-pm-starter-title">Start here</div>' +
                '</div>' +
              '</div>' +
              '<div class="sc-pm-starter-card" data-pm-starter-card></div>' +
            '</div>' +

            '<div class="sc-pm-companions">' +
              '<div class="sc-pm-companions-head">' +
                '<div class="sc-eyebrow">Then, when you\'re ready</div>' +
                '<h4>The pieces people add next.</h4>' +
                '<p>These are the three most-bought companions to the starter set, in order. There\'s no rush — add them over months or years. The range hasn\'t changed in twenty years, and it won\'t.</p>' +
              '</div>' +
              '<div class="sc-pm-companions-grid" data-pm-companions-grid></div>' +
            '</div>' +

          '</div>' +
        '</div>' +

        /* === ADD FLOW === */
        '<div class="sc-pm-flow" id="pm-flow-add" data-pm-flow="add" hidden>' +
          '<div class="sc-pm-flow-inner">' +
            '<div class="sc-pm-flow-head">' +
              '<button class="sc-pm-flow-back" type="button" data-pm-flow-close aria-label="Back to the four options">&lsaquo; Back</button>' +
              '<div class="sc-eyebrow">Add to my collection</div>' +
              '<h3 class="sc-pm-flow-title">Welcome back. <em>Here\'s what\'s changed.</em></h3>' +
            '</div>' +

            /* Two side-by-side panels: what's new + lookup */
            '<div class="sc-pm-add-split">' +

              /* Left: what's new */
              '<div class="sc-pm-add-panel">' +
                '<div class="sc-pm-add-panel-head">' +
                  '<div class="sc-eyebrow">New this year</div>' +
                  '<h4>Lavandula joined the collection.</h4>' +
                  '<p>The newest range, with painted lavender sprigs across plates, bowls and a footed cake stand. It sits beautifully alongside White Porcelain on the same table.</p>' +
                '</div>' +
                '<div class="sc-pm-add-new" data-pm-add-new></div>' +
              '</div>' +

              /* Right: previous order lookup */
              '<div class="sc-pm-add-panel sc-pm-add-panel-cream">' +
                '<div class="sc-pm-add-panel-head">' +
                  '<div class="sc-eyebrow">Look up a previous order</div>' +
                  '<h4>We\'ll pull up what you bought before.</h4>' +
                  '<p>Useful for adding to a set you started a while back, or just remembering which colourway you went for.</p>' +
                '</div>' +
                '<div class="sc-pm-lookup">' +
                  '<label class="sc-pm-lookup-field">' +
                    '<span>Your email address</span>' +
                    '<input type="email" placeholder="you@example.com" data-pm-lookup-email autocomplete="email" />' +
                  '</label>' +
                  '<button class="sc-btn sc-btn-primary sc-pm-lookup-btn" type="button" data-pm-lookup-go>Find my orders</button>' +
                  '<div class="sc-pm-lookup-or">or</div>' +
                  '<a class="sc-btn sc-btn-secondary sc-pm-lookup-signin" href="account.html">Sign in to your account</a>' +
                '</div>' +
                '<div class="sc-pm-lookup-result" data-pm-lookup-result hidden></div>' +
              '</div>' +

            '</div>' +
          '</div>' +
        '</div>' +

        /* === BROWSE FLOW === */
        '<div class="sc-pm-flow" id="pm-flow-browse" data-pm-flow="browse" hidden>' +
          '<div class="sc-pm-flow-inner sc-pm-flow-browse-inner">' +
            '<div class="sc-pm-flow-head">' +
              '<button class="sc-pm-flow-back" type="button" data-pm-flow-close aria-label="Back to the four options">&lsaquo; Back</button>' +
              '<div class="sc-eyebrow">Browse the collection</div>' +
              '<h3 class="sc-pm-flow-title">Of course. <em>Take your time.</em></h3>' +
              '<p class="sc-pm-flow-lede">The six collections are just below. The full bestseller list is on the next page. We\'re here if you change your mind.</p>' +
              '<div class="sc-pm-browse-actions">' +
                '<a class="sc-btn sc-btn-primary" href="#collections">See the six collections</a>' +
                '<a class="sc-btn sc-btn-secondary" href="portmeirion-bestsellers.html">Skip to the bestsellers</a>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +

      '</div>' +
    '</section>';
};

/* The intro's behaviour. Wires the four doors, the quiz, the seat
   stepper, and the previous-order lookup. Called from portmeirion.html
   after the markup is mounted. */
SC.components.portmeirionIntroBind = function() {
  var root = document.getElementById('how-can-we-help');
  if (!root) return;

  var doorsWrap = root.querySelector('[data-pm-doors]');
  var doors = root.querySelectorAll('[data-pm-door]');
  var flows = root.querySelectorAll('[data-pm-flow]');

  /* Hide all flows, deactivate all doors */
  function reset() {
    flows.forEach(function(f) {
      f.hidden = true;
      f.classList.remove('is-open');
    });
    doors.forEach(function(d) {
      d.setAttribute('aria-expanded', 'false');
      d.classList.remove('is-active');
    });
    doorsWrap.classList.remove('is-anyflow-open');
  }

  /* Open a specific flow by key */
  function openFlow(key) {
    reset();
    var flow = root.querySelector('[data-pm-flow="' + key + '"]');
    var door = root.querySelector('[data-pm-door="' + key + '"]');
    if (!flow || !door) return;
    flow.hidden = false;
    /* Defer the class flip so the CSS transition runs.
       requestAnimationFrame is the right tool, but fall back to
       a microtask if for some reason it isn't there. */
    var defer = (typeof requestAnimationFrame === 'function') ? requestAnimationFrame : function(fn) { setTimeout(fn, 0); };
    defer(function() {
      flow.classList.add('is-open');
    });
    door.setAttribute('aria-expanded', 'true');
    door.classList.add('is-active');
    doorsWrap.classList.add('is-anyflow-open');

    /* Per-flow setup */
    if (key === 'gift')  { renderGiftSuggestions(); }
    if (key === 'start') { renderStarter(); renderCompanions(); }
    if (key === 'add')   { renderAddNew(); }

    /* Scroll the flow panel into view, but gently */
    setTimeout(function() {
      var rect = flow.getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > window.innerHeight) {
        flow.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 80);
  }

  /* Wire door clicks */
  doors.forEach(function(door) {
    door.addEventListener('click', function() {
      var key = door.getAttribute('data-pm-door');
      /* If the door is already active, close it (toggle off) */
      if (door.classList.contains('is-active')) {
        reset();
        return;
      }
      openFlow(key);
    });
  });

  /* Wire flow back buttons */
  root.querySelectorAll('[data-pm-flow-close]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      reset();
      /* Return focus to the doors */
      doorsWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---- GIFT FLOW: live recommendations as the chips change ---- */
  function getRadioValue(name) {
    var checked = root.querySelector('input[name="' + name + '"]:checked');
    return checked ? checked.value : null;
  }
  function renderGiftSuggestions() {
    var recipient = getRadioValue('gift-recipient');
    var occasion  = getRadioValue('gift-occasion');
    var budget    = getRadioValue('gift-budget');

    /* Budget ranges, in £ */
    var budgetMin = 0, budgetMax = 9999;
    if (budget === 'under30')  { budgetMin = 0;   budgetMax = 30; }
    if (budget === '30to60')   { budgetMin = 30;  budgetMax = 60; }
    if (budget === '60to100')  { budgetMin = 60;  budgetMax = 100; }
    if (budget === 'over100')  { budgetMin = 100; budgetMax = 9999; }

    /* Score every bestseller against the answers. Anything in
       budget gets a base score. Then we nudge based on recipient
       and occasion preferences. Higher = better fit. */
    var pool = (SC.portmeirionBestsellers || []).slice();
    var scored = pool.map(function(p) {
      var score = 0;
      var inBudget = (p.priceFrom >= budgetMin && p.priceFrom <= budgetMax);
      if (!inBudget) score -= 50;
      else score += 10;

      /* Recipient preferences:
         - couple: dining sets, dinner plates, pasta bowls (substantial pieces)
         - host: cake stands, statement bowls, serving pieces
         - mum: tea cups, cake stand, candles, textiles (gentle, sentimental)
         - friend: candles, diffusers, smaller textile pieces, mugs */
      if (recipient === 'couple') {
        if (p.collection === 'white' && /Dining Set|Dinner|Pasta/.test(p.range)) score += 25;
        if (/12 Piece|Twelve Piece/i.test(p.range)) score += 20;
        if (p.collection === 'candles') score -= 10;
      }
      if (recipient === 'host') {
        if (/Cake Stand|Statement Bowl|Roasting|Serving|Three Bowls|Casserole/i.test(p.range)) score += 25;
        if (/Pasta Bowls/i.test(p.range)) score += 10;
      }
      if (recipient === 'mum') {
        if (/Tea Cup|Cake Stand|Floret|Lavandula|Candle/i.test(p.range)) score += 25;
        if (p.collection === 'lavandula') score += 8;
        if (p.collection === 'candles') score += 12;
      }
      if (recipient === 'friend') {
        if (p.collection === 'candles') score += 25;
        if (/Mug|Diffuser|Napkins|Placemat/i.test(p.range)) score += 15;
        if (p.priceFrom < 30) score += 8;
      }

      /* Occasion preferences:
         - wedding: bigger sets, classic white, cake stand
         - birthday: anything in budget, mugs are nice
         - housewarming: starter pieces, mixing bowls, statement pieces
         - christmas: mistletoe textiles, candles, the cake stand
         - thankyou: smaller, lovely things — mugs, candles, napkins */
      if (occasion === 'wedding') {
        if (p.collection === 'white') score += 12;
        if (/12 Piece|Twelve Piece|Cake Stand|Tea Cup/i.test(p.range)) score += 12;
      }
      if (occasion === 'birthday') {
        if (/Mug|Cake Stand|Floret|Lavandula/i.test(p.range)) score += 10;
      }
      if (occasion === 'housewarming') {
        if (/Mixing Bowl|Statement|Roasting|Dinner Plates|Pasta/i.test(p.range)) score += 15;
      }
      if (occasion === 'christmas') {
        if (/Mistletoe|Amor|Candle|Cake Stand/i.test(p.range)) score += 20;
        if (p.collection === 'candles') score += 10;
      }
      if (occasion === 'thankyou') {
        if (p.priceFrom < 35) score += 10;
        if (/Mug|Candle|Napkin|Placemat/i.test(p.range)) score += 15;
      }

      return { p: p, score: score };
    });

    /* Sort by score, take top three that are in budget */
    scored.sort(function(a, b) { return b.score - a.score; });
    var top = scored.filter(function(s){ return s.score > 0; }).slice(0, 3);

    /* Fallback: if nothing scored above zero (very tight budget),
       just take the top three under the budget cap. */
    if (top.length < 3) {
      var fallback = pool.filter(function(p){ return p.priceFrom <= budgetMax; })
                         .sort(function(a, b){ return b.priceFrom - a.priceFrom; })
                         .slice(0, 3);
      top = fallback.map(function(p){ return { p: p, score: 0 }; });
    }

    /* Register these pins with the favourites system so the save
       heart resolves them from the overlay. */
    if (SC.gallery && SC.gallery.registerPins) {
      SC.gallery.registerPins(top.map(function(s){ return s.p; }));
    }

    var cards = top.map(function(s){ return SC.components.portmeirionBestsellerCard(s.p); }).join('');
    var cardsHost = root.querySelector('[data-pm-quiz-cards]');
    if (cardsHost) cardsHost.innerHTML = cards;

    /* Update the results title and note based on the answers */
    var titleHost = root.querySelector('[data-pm-quiz-title]');
    var noteHost  = root.querySelector('[data-pm-quiz-note]');
    var titles = {
      'couple-wedding':       'For a couple, on a wedding',
      'couple-housewarming':  'For a couple\'s new home',
      'couple-thankyou':      'A thank-you for a couple',
      'couple-christmas':     'For a couple, at Christmas',
      'couple-birthday':      'For a couple, on a birthday',
      'host-christmas':       'For the host, at Christmas',
      'host-birthday':        'For a host\'s birthday',
      'host-thankyou':        'A thank-you for the host',
      'host-housewarming':    'For the host, on a new home',
      'host-wedding':         'For the host, on a wedding',
      'mum-birthday':         'For a parent\'s birthday',
      'mum-christmas':        'For a parent, at Christmas',
      'mum-thankyou':         'A thank-you for a parent',
      'mum-housewarming':     'For a parent, on a new home',
      'mum-wedding':          'For a parent, on a wedding',
      'friend-thankyou':      'A thank-you for a friend',
      'friend-birthday':      'A friend\'s birthday',
      'friend-christmas':     'For a friend, at Christmas',
      'friend-housewarming':  'For a friend\'s new home',
      'friend-wedding':       'For a friend, on a wedding'
    };
    var key = (recipient || '') + '-' + (occasion || '');
    if (titleHost) titleHost.textContent = titles[key] || 'Three pieces we think they\'ll love';

    if (noteHost && top[0]) {
      noteHost.textContent = 'Three pieces in the ' + (budget === 'under30' ? 'under-£30' :
                              budget === '30to60' ? '£30–£60' :
                              budget === '60to100' ? '£60–£100' : 'over-£100') +
                              ' bracket, ordered by how often this pairing is bought as a gift.';
    }

    /* Rebind the save heart and bag listeners on the new cards.
       The site-wide listener handles save, but the bag button needs
       the page's data registry to be aware of these items —
       portmeirion.html already registers all bestsellers globally
       at boot, so the bag handler will resolve them. */
  }

  /* Hook the quiz chips to live-update */
  root.querySelectorAll('input[name^="gift-"]').forEach(function(input) {
    input.addEventListener('change', renderGiftSuggestions);
  });

  /* ---- START FLOW: seat counter + starter + companions ---- */
  var seats = 4;
  function clampSeats(n) { return Math.max(2, Math.min(12, n)); }
  function renderSeatsNum() {
    var num = root.querySelector('[data-pm-seats-num]');
    var suffix = root.querySelector('.sc-pm-seats-suffix');
    if (num) num.textContent = seats;
    if (suffix) suffix.textContent = seats === 1 ? ' person' : ' people';
    /* Note copy updates based on count */
    var note = root.querySelector('[data-pm-seats-note]');
    if (note) {
      if (seats <= 4) {
        note.textContent = 'One starter set, the standard twelve-piece for four.';
      } else if (seats <= 8) {
        note.textContent = 'Two starter sets gets you to eight place settings. Mix and match the side plates and bowls for flexibility.';
      } else {
        note.textContent = 'Three starter sets covers up to twelve. You\'ll want a Large Statement Bowl and a Cake Stand too — the table starts to need anchor pieces at that size.';
      }
    }
  }
  function renderStarter() {
    /* The starter set is always the White Porcelain 12 Piece Dining Set */
    var starter = (SC.portmeirionBestsellers || []).filter(function(p){ return p.id === 'pm-white-12pc'; })[0];
    if (!starter) return;
    if (SC.gallery && SC.gallery.registerPins) SC.gallery.registerPins([starter]);
    var slot = root.querySelector('[data-pm-starter-card]');
    if (!slot) return;
    /* If they're setting for more than 4, suggest multiple sets */
    var multiplier = seats <= 4 ? 1 : (seats <= 8 ? 2 : 3);
    var html = SC.components.portmeirionBestsellerCard(starter);
    if (multiplier > 1) {
      html += '<div class="sc-pm-starter-multi">' +
        '<div class="sc-pm-starter-multi-num">×' + multiplier + '</div>' +
        '<div class="sc-pm-starter-multi-text">' +
          '<strong>Buy ' + multiplier + ' sets for ' + seats + ' people.</strong>' +
          '<span>That\'s ' + (multiplier * 4) + ' of each piece, which gives you a touch of headroom for the times you set a slightly bigger table.</span>' +
        '</div>' +
      '</div>';
    }
    slot.innerHTML = html;
    renderSeatsNum();
  }
  function renderCompanions() {
    /* The three most-bought companions to the starter set, in order:
       Mugs, Pasta Bowls, Tea Cup & Saucer. From the real bestseller order. */
    var ids = ['pm-white-mugs', 'pm-white-pasta', 'pm-white-tea'];
    var picks = ids.map(function(id) {
      return (SC.portmeirionBestsellers || []).filter(function(p){ return p.id === id; })[0];
    }).filter(Boolean);
    if (SC.gallery && SC.gallery.registerPins) SC.gallery.registerPins(picks);
    var slot = root.querySelector('[data-pm-companions-grid]');
    if (!slot) return;
    slot.innerHTML = picks.map(function(p, i) {
      var rank = '0' + (i + 2); /* starter is 01, companions 02, 03, 04 */
      return '<div class="sc-pm-companion">' +
        '<div class="sc-pm-companion-rank">' + rank + '</div>' +
        SC.components.portmeirionBestsellerCard(p) +
      '</div>';
    }).join('');
  }
  var seatsDec = root.querySelector('[data-pm-seats-dec]');
  var seatsInc = root.querySelector('[data-pm-seats-inc]');
  if (seatsDec) seatsDec.addEventListener('click', function() {
    seats = clampSeats(seats - 1);
    renderStarter();
  });
  if (seatsInc) seatsInc.addEventListener('click', function() {
    seats = clampSeats(seats + 1);
    renderStarter();
  });

  /* ---- ADD FLOW: what's new + previous order lookup ---- */
  function renderAddNew() {
    /* The four newest pieces — we use the Lavandula range as our
       "new this year" stock. Real Shopify launch dates would drive
       this in production. */
    var newish = (SC.portmeirionBestsellers || []).filter(function(p){
      return p.collection === 'lavandula' &&
             /Pasta Bowls|Footed Cake Stand|Dinner Plates|Mugs/.test(p.range);
    }).slice(0, 4);
    if (SC.gallery && SC.gallery.registerPins) SC.gallery.registerPins(newish);
    var slot = root.querySelector('[data-pm-add-new]');
    if (!slot) return;
    slot.innerHTML = newish.map(function(p) {
      return SC.components.portmeirionBestsellerCard(p);
    }).join('');
  }

  /* Previous order lookup is a soft demo. In production it sends
     a magic-link email; here we just show a friendly placeholder. */
  var lookupBtn = root.querySelector('[data-pm-lookup-go]');
  var lookupEmail = root.querySelector('[data-pm-lookup-email]');
  var lookupResult = root.querySelector('[data-pm-lookup-result]');
  if (lookupBtn) {
    lookupBtn.addEventListener('click', function() {
      var email = (lookupEmail && lookupEmail.value || '').trim();
      if (!email || email.indexOf('@') === -1) {
        if (lookupResult) {
          lookupResult.hidden = false;
          lookupResult.innerHTML = '<div class="sc-pm-lookup-msg sc-pm-lookup-msg-warn">' +
            '<strong>Just need a valid email.</strong> ' +
            'Pop in the address you used when you last ordered and we\'ll find the right orders.' +
          '</div>';
        }
        return;
      }
      if (lookupResult) {
        lookupResult.hidden = false;
        lookupResult.innerHTML = '<div class="sc-pm-lookup-msg">' +
          '<strong>Sent.</strong> ' +
          'If we have orders against <em>' + email + '</em>, we\'ve emailed you a secure link to view them. ' +
          'It\'ll arrive in a minute or two. Check spam if it doesn\'t show — Portmeirion order emails sometimes do.' +
        '</div>';
      }
    });
  }
};

/* How it is made: 4-card grid (kept from brief) */

/* Shipping note: drop-ship from Portmeirion, UK→UK, US→US */

/* ============================================================
   PORTMEIRION BESTSELLERS
   The pieces that actually sell. Real Shopify analytics, real
   product imagery, real prices. Card pattern matches the gallery
   pins so the favourite-heart wiring carries over without any
   extra plumbing — the cards declare data-sc-pin-save and the
   site-wide listener in sc-gallery.js does the rest.
   ============================================================ */

/* The single-card renderer. Mirrors SC.gallery.card so the styling
   and save-heart behaviour stay identical, but reaches into the
   bestsellers image map rather than the gallery items map.

   The image+caption block is wrapped in an <a> pointing at the
   product detail page (product-{handle}.html — these pages are
   not built yet, but every card carries the URL so the linkage
   is in place the moment we build them). The save heart and
   add-to-basket button stop propagation so a click on either
   does not also navigate. */
SC.components.portmeirionBestsellerCard = function(p) {
  var imgs = (SC.images && SC.images.portmeirionBestsellers) || {};
  var entry = imgs[p.image] || {};
  var imgUrl = entry.url || '';
  var imgAlt = entry.alt || p.range;
  var isFav = (SC.gallery && SC.gallery.favourites) ? SC.gallery.favourites.has(p.id) : false;
  /* Price label. For tableware we always show "From £" prefix
     since most lines are sets and per-piece equivalents vary. */
  var price = p.priceFrom;
  var priceText;
  if (price % 1 === 0) priceText = 'From £' + price.toLocaleString('en-GB');
  else priceText = 'From £' + price.toFixed(2);
  /* Lead label. Drop-ship from Portmeirion = Ready to ship. */
  var leadText = p.weeks && p.weeks > 0 ? 'Ready in ' + p.weeks + ' weeks' : 'Ready to ship';
  /* PDP URL. Pages don't exist yet — placeholder route, but every
     card is link-wired so the moment a PDP is built it picks up. */
  var pdpHref = 'product-' + p.handle + '.html';
  return '' +
    '<article class="sc-pin sc-pin-pm" data-pin-id="' + p.id + '" data-pm-collection="' + p.collection + '">' +
      '<a class="sc-pin-link" href="' + pdpHref + '" aria-label="View ' + p.range + '">' +
        '<div class="sc-pin-image-wrap">' +
          '<img class="sc-pin-image" src="' + imgUrl + '" alt="' + imgAlt + '" loading="lazy" />' +
          '<button class="sc-pin-save' + (isFav ? ' is-saved' : '') + '" type="button" ' +
                  'aria-label="' + (isFav ? 'Remove from saved' : 'Save to favourites') + '" ' +
                  'aria-pressed="' + (isFav ? 'true' : 'false') + '" ' +
                  'data-sc-pin-save="' + p.id + '">' +
            '<svg class="sc-pin-heart" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">' +
              '<path d="M12 21s-7.5-4.5-9.5-9.5C1 7 4 4 7.5 4c2 0 3.5 1 4.5 2.5C13 5 14.5 4 16.5 4 20 4 23 7 21.5 11.5 19.5 16.5 12 21 12 21z" ' +
                'fill="' + (isFav ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
        '<div class="sc-pin-caption">' +
          '<h3 class="sc-pin-name">' + p.range + '</h3>' +
          '<div class="sc-pin-fabric">' +
            '<span class="sc-pin-swatch" style="background:' + p.swatch + ';"></span>' +
            '<span class="sc-pin-fabric-name">' + p.fabric + '</span>' +
          '</div>' +
          '<div class="sc-pin-divider"></div>' +
          '<div class="sc-pin-foot">' +
            '<div class="sc-pin-price-wrap">' +
              '<div class="sc-pin-price">' + priceText + '</div>' +
            '</div>' +
            '<div class="sc-pin-foot-right">' +
              '<div class="sc-pin-lead">' + leadText + '</div>' +
              /* Pin bag button. Persistent state: if the customer has
                 already added this product to the basket, the button
                 mounts in the "is-in-cart" look (terracotta fill, paper
                 icon, count badge if quantity > 1). The click handler
                 toggles the class and increments. The mount-time check
                 means that navigating away from the page and back keeps
                 the indicator correct, because state lives in
                 localStorage via SC.cart. */
              (function() {
                var qty = (SC.cart && SC.cart.getQuantityOf) ? SC.cart.getQuantityOf(p.id) : 0;
                var inCart = qty > 0;
                var ariaLabel = inCart
                  ? ('Add another ' + p.range + ' to basket (currently ' + qty + ' in basket)')
                  : ('Add ' + p.range + ' to basket');
                return '<button class="sc-pin-bag' + (inCart ? ' is-in-cart' : '') + '" type="button" ' +
                        'aria-label="' + ariaLabel + '" ' +
                        'data-sc-pin-bag="' + p.id + '">' +
                  '<svg class="sc-pin-bag-icon" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">' +
                    '<path d="M5 8h14l-1.2 11.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8L5 8z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
                    '<path d="M9 8V6a3 3 0 0 1 6 0v2" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
                  '</svg>' +
                  '<svg class="sc-pin-bag-tick" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">' +
                    '<path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>' +
                  '</svg>' +
                  '<span class="sc-pin-bag-count" data-sc-pin-bag-count>' + (qty > 1 ? qty : '') + '</span>' +
                '</button>';
              })() +
            '</div>' +
          '</div>' +
        '</div>' +
      '</a>' +
    '</article>';
};

/* The full bestsellers page section: hero band + filter chips + the
   masonry-style grid. Pulls product list from SC.portmeirionBestsellers.
   Filter chips are local to this page; the click handler is wired
   in the page script (portmeirion-bestsellers.html). */

/* Filter chip strip. Mirrors gallery filters but kept page-local so
   the gallery click handler in sc-gallery.js does not collide. */

/* Render the grid for the given filter key. Used on initial paint
   and on every filter chip click. */

/* Register the Portmeirion bestsellers as known pins so the
   favourites overlay can render them even on pages that never
   painted the bestseller grid (e.g. the user saves a piece on
   the bestsellers page, then opens the header heart from any
   other page). Builds a gallery-card-shaped object with the
   image URL resolved and an `alt` field added.

   Idempotent: calling twice is harmless. Should be called once
   per page that uses portmeirion bestsellers, ideally at boot
   alongside SC.page.boot. */

/* A compact preview strip for the main Portmeirion landing page —
   eight cards across, with a "see all bestsellers" link. This sits
   alongside the existing portmeirionFeatured 4-card editorial row
   rather than replacing it. */

/* ============================================================
   BED LINEN PAGE
   The Scalloped collection. Eight colours. UK only.
   Stocked and shipped by SCGT direct from the UK warehouse.
   ============================================================ */

SC.components.bedLinenHero = function(opts) {
  opts = opts || {};
  return '' +
    '<section class="sc-bl-hero">' +
      '<div class="sc-bl-hero-image">' +
        '<img src="' + (opts.image || 'assets/img/bed-linen-hero.jpg') + '" alt="' + (opts.alt || 'Blue Scalloped bed linen on a made bed') + '" />' +
      '</div>' +
      '<div class="sc-bl-hero-content">' +
        '<div class="sc-container">' +
          '<div class="sc-eyebrow">The Scalloped Collection</div>' +
          '<h1 class="sc-display-1">Bed linen with a hand-finished <em>scalloped edge</em>.</h1>' +
          '<p class="sc-lede">Eight colours, ranging from £73.50. 100% cotton. Sent from our UK warehouse, usually next working day. UK delivery only at the moment, with the US to follow.</p>' +
          '<div class="sc-bl-hero-actions">' +
            '<a class="sc-btn sc-btn-primary" href="bed-linen-scalloped.html">Shop the collection</a>' +
            '<a class="sc-btn sc-btn-secondary" href="#colours">See all eight colours</a>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</section>';
};

/* Eight-colour grid using real product photography per colour, with the swatch colour
   as the background so the tile reads correctly even before the image has loaded
   or if a particular colour photo is unavailable. */

/* "What you get" practical info */
SC.components.bedLinenWhatYouGet = function() {
  var items = [
    { title: '100% cotton',           body: 'Long-staple cotton with a soft hand and a tight enough weave to last fifteen years of weekly washes. Gets better the more you sleep on it.' },
    { title: 'Hand-finished scallop', body: 'The edge detail is sewn by hand, not stamped. You will see small variations between covers, which is the point.' },
    { title: 'Machine washable',      body: 'Wash at 40 degrees with similar colours. Tumble dry on low or line dry. No special detergent needed.' },
    { title: 'Made for British beds', body: 'Sized for UK Single, Double, King, Super King and Emperor. Pillowcases are housewife and Oxford depending on the set.' }
  ];
  var html = items.map(function(c) {
    return '<div class="sc-pm-make">' +
      '<div class="sc-pm-make-title">' + c.title + '</div>' +
      '<p>' + c.body + '</p>' +
    '</div>';
  }).join('');
  return '' +
    '<section class="sc-section" id="what-you-get">' +
      '<div class="sc-container">' +
        '<div class="sc-section-head">' +
          '<div class="sc-eyebrow">What you get</div>' +
          '<h2 class="sc-display-2">The four things that matter.</h2>' +
        '</div>' +
        '<div class="sc-pm-makers">' + html + '</div>' +
      '</div>' +
    '</section>';
};

/* Featured products row, mirroring Portmeirion shape */
/* ============================================================
   SCALLOPED COLLECTION — PRODUCT DISPLAY PAGE
   ============================================================
   The new shoppable PDP for the eight-colour Scalloped range.
   One page, one collection, eight colours, four product types.

   Layout (desktop):
   ┌──────────────────────────────────────────────────────────────┐
   │ COLOUR-LED LEDE — colour pills + selected colour name        │
   ├─────────────────────────────────┬────────────────────────────┤
   │ STICKY EDITORIAL GALLERY        │  STACKED BUY-MODULES       │
   │  - large hero, swappable        │  - Duvet Cover             │
   │  - thumb strip                  │    [size pills] qty  +£    │
   │                                 │  - Oxford Pillowcase       │
   │                                 │    qty  £                  │
   │                                 │  - Square Pillowcase       │
   │                                 │    qty  £                  │
   │                                 │  - Super King Pillowcase   │
   │                                 │    qty  £                  │
   │                                 │  [ COMPLETE THE BED — £xxx]│
   └─────────────────────────────────┴────────────────────────────┘
       EDITORIAL: fabric · care · made · UK delivery
       PAIRS WELL WITH: Coco sofa, Portmeirion bedside ware
       REVIEWS

   On mobile the layout collapses to a single column: colour-pills,
   hero image, buy-modules stacked, editorial below.
   ============================================================ */


/* ----------- Single buy-module renderer -----------
   Used by scallopedPDP. Pulled out so the binder can re-render
   a single module when colour changes. */
SC.components.scallopedBuyModule = function(p, colourHandle) {
  var matrix = p.matrix[colourHandle] || {};
  var firstSizeKey = p.sizesOrder[0];
  var firstSize = matrix[firstSizeKey] || {};
  var hasSizeChoice = p.sizesOrder.length > 1;

  /* Size pills (only for duvet covers; pillowcases are single-size) */
  var sizePills = '';
  if (hasSizeChoice) {
    sizePills = '<div class="sc-sp-sizes">' +
      p.sizesOrder.map(function(sizeKey, i) {
        var s = p.sizes[sizeKey];
        var m = matrix[sizeKey] || {};
        var disabled = !m.inStock || m.price == null;
        var active = i === 0 && !disabled;
        return '<button type="button" ' +
          'class="sc-sp-size' + (active ? ' is-active' : '') + (disabled ? ' is-disabled' : '') + '" ' +
          'data-sc-sp-size="' + sizeKey + '" ' +
          (disabled ? 'disabled' : '') +
          '>' +
          '<span class="sc-sp-size-label">' + s.label + '</span>' +
          '<span class="sc-sp-size-dim">' + s.dimensions + '</span>' +
          (m.price ? '<span class="sc-sp-size-price">' + SC.fmt.gbp(m.price) + '</span>' : '<span class="sc-sp-size-price">—</span>') +
        '</button>';
      }).join('') +
    '</div>';
  }

  /* For single-size products, the dimensions go inline with the title */
  var singleSizeDim = '';
  if (!hasSizeChoice) {
    singleSizeDim = '<span class="sc-sp-module-dim">' + p.sizes[firstSizeKey].dimensions + '</span>';
  }

  /* In-stock badge */
  var stockBadge = firstSize.inStock ?
    '<span class="sc-sp-instock">In stock</span>' :
    '<span class="sc-sp-oos">Coming soon</span>';

  /* Add-to-bed row: qty stepper + price + button */
  var addRow = '' +
    '<div class="sc-sp-add-row">' +
      '<div class="sc-sp-qty" data-sc-sp-qty-wrap>' +
        '<button type="button" class="sc-sp-qty-btn" data-sc-sp-qty-dec aria-label="Decrease quantity">−</button>' +
        '<input class="sc-sp-qty-input" type="text" inputmode="numeric" pattern="[0-9]*" value="' + p.defaultQty + '" data-sc-sp-qty-input readonly />' +
        '<button type="button" class="sc-sp-qty-btn" data-sc-sp-qty-inc aria-label="Increase quantity">+</button>' +
      '</div>' +
      '<div class="sc-sp-module-price" data-sc-sp-module-price>' +
        (firstSize.price ? SC.fmt.gbp(firstSize.price * p.defaultQty) : '—') +
      '</div>' +
      '<button type="button" class="sc-sp-add-btn" data-sc-sp-add' +
        (firstSize.inStock ? '' : ' disabled') + '>Add to bed</button>' +
    '</div>';

  return '' +
    '<div class="sc-sp-module" data-sc-sp-product="' + p.key + '" data-sc-sp-selected-size="' + firstSizeKey + '" data-sc-sp-qty="' + p.defaultQty + '">' +
      '<div class="sc-sp-module-head">' +
        '<div class="sc-sp-module-eyebrow">' + p.eyebrow + ' ' + stockBadge + '</div>' +
        '<div class="sc-sp-module-title">' + p.name + singleSizeDim + '</div>' +
        '<p class="sc-sp-module-lede">' + p.lede + '</p>' +
      '</div>' +
      sizePills +
      addRow +
    '</div>';
};

/* ----------- Editorial slabs below the buy area -----------
   Four cards: what you get / fabric / care / delivery. Reuses
   the SCGT house pattern from the Portmeirion page. */

/* ----------- Sophie quote slab -----------
   A pull quote in Sophie's voice between editorial and reviews.
   Sets the emotional tone — bedrooms as places to read, talk, rest. */

/* ----------- Editorial photography strip -----------
   Full-bleed lifestyle shots in Bedfolk style with caption copy in
   Sophie's voice. Sits between Sophie's note and the four-slab
   editorial. Three images interleaved with quiet copy on cream.
   Image height is fixed but width fills the viewport (no inner
   container), which is what gives the strip its editorial feel.

   Sources: shot 1 is a local file decoded from the Drive folder
   (assets/img/editorial/scallop-pillows-stack.jpg). Shots 2 and 3
   come from the Shopify CDN, same library used on the bed-linen
   landing and PDP gallery, so they are already approved imagery.
   When we have more web-optimised Drive images extracted, we can
   swap them in here without touching layout. */

/* Complete-bed bundles row.
   Sits between the colour pills and the buy modules. Each bundle shows
   the composition (1 duvet + N pillowcases), the per-colour total price
   computed from the live SKU matrix, and a one-tap "Add this bundle"
   button. The bundle resolves to real SKUs using the active colour and
   pushes each line as a separate SC.cart item — same as if the customer
   had clicked Add on each module in turn. No discount applied; this is a
   convenience, not a promotion.

   The whole row re-renders when the colour changes so that prices and
   stock states match the chosen colour. */
SC.components.scallopedBundles = function(colourHandle) {
  var col = SC.scallopedCollection;
  var bundles = SC.scallopedBundles;
  if (!col || !bundles) return '';

  /* For a given bundle, look up every line's price + SKU + stock from the
     products matrix for the requested colour. Returns {total, lines[],
     anyMissing, anyOOS}. */
  function resolveBundle(bundle, handle) {
    var total = 0;
    var anyMissing = false;
    var anyOOS = false;
    var lines = bundle.items.map(function(line) {
      var product = col.products.find(function(p) { return p.key === line.productKey; });
      if (!product) { anyMissing = true; return null; }
      /* Each product matrix is keyed by size, then colour. For products
         with a single size (Oxford/Square/SuperKing pillowcases), the
         size key is null in the bundle definition, so use the only key
         the matrix has. */
      var sizeKey = line.size || product.sizesOrder[0];
      /* Matrix is keyed by colour first, then size. */
      var colourMatrix = product.matrix[handle];
      if (!colourMatrix) { anyMissing = true; return null; }
      var entry = colourMatrix[sizeKey];
      if (!entry) { anyMissing = true; return null; }
      if (!entry.inStock) anyOOS = true;
      var linePrice = entry.price * line.qty;
      total += linePrice;
      return {
        productKey: line.productKey,
        productName: product.name,
        sizeKey: sizeKey,
        sizeLabel: line.sizeLabel,
        qty: line.qty,
        unitPrice: entry.price,
        linePrice: linePrice,
        sku: entry.sku,
        inStock: entry.inStock
      };
    });
    return { total: total, lines: lines, anyMissing: anyMissing, anyOOS: anyOOS };
  }

  /* Format £ with no decimals when whole, else 2 decimals. */
  function gbp(n) {
    if (n == null) return '';
    return n % 1 === 0 ? '£' + n : '£' + n.toFixed(2);
  }

  var cards = bundles.map(function(bundle) {
    var resolved = resolveBundle(bundle, colourHandle);
    var disabled = resolved.anyMissing || resolved.anyOOS;

    /* Build the contents line — e.g. "1 Duvet · 2 Oxfords" — for at-a-
       glance scanning. Pillowcase names are pluralised crudely (add 's')
       which is fine for the three product names in play. */
    var contents = resolved.lines.map(function(l) {
      if (!l) return '';
      var name = l.productName;
      var label = l.qty > 1 ? (name + 's') : name;
      return l.qty + ' ' + label;
    }).filter(Boolean).join(' · ');

    var btnLabel = resolved.anyOOS ? 'Out of stock in this colour' :
                   resolved.anyMissing ? 'Unavailable' : 'Add this bundle';

    return '' +
      '<div class="sc-sp-bundle' + (disabled ? ' is-disabled' : '') + '">' +
        '<div class="sc-sp-bundle-head">' +
          '<div class="sc-eyebrow">' + bundle.label + '</div>' +
          '<div class="sc-sp-bundle-name">' + bundle.name + '</div>' +
        '</div>' +
        '<div class="sc-sp-bundle-contents">' + contents + '</div>' +
        '<div class="sc-sp-bundle-blurb">' + bundle.blurb + '</div>' +
        '<div class="sc-sp-bundle-foot">' +
          '<div class="sc-sp-bundle-price">' + gbp(resolved.total) + '</div>' +
          '<button type="button" class="sc-btn sc-btn-secondary sc-sp-bundle-add" ' +
            'data-sc-bundle-add="' + bundle.key + '" ' +
            (disabled ? 'disabled' : '') + '>' +
            btnLabel +
          '</button>' +
        '</div>' +
      '</div>';
  }).join('');

  return '' +
    '<div class="sc-sp-bundles" id="sc-sp-bundles">' +
      '<div class="sc-sp-bundles-head">' +
        '<div class="sc-eyebrow">Complete the bed</div>' +
        '<h2 class="sc-sp-bundles-title">Buy a set in one go</h2>' +
        '<p class="sc-sp-bundles-lede">Three ready-made bundles for the size of bed you sleep in. Same price as buying the pieces individually, just one tap.</p>' +
      '</div>' +
      '<div class="sc-sp-bundles-grid">' + cards + '</div>' +
    '</div>';
};

/* ============================================================
   SCALLOPED PDP BINDER
   ============================================================
   Wires up:
     - Colour pill clicks → swap hero, thumbs, copy, all module prices,
       size/stock states, update URL ?colour=
     - Thumb clicks → swap hero image
     - Size pill clicks → re-price the module, update selected size data
     - Qty +/- → re-price the module
     - "Add to bed" button → push the line into a session "bed builder"
       (separate from cart) that drives the Complete-the-bed summary
     - "Complete the bed" → push all selected modules to SC.cart
   ============================================================ */
SC.bindScallopedPDP = function() {
  var col = SC.scallopedCollection;
  if (!col) return;
  var section = document.querySelector('.sc-sp');
  if (!section) return;

  /* In-page "bed builder" — items chosen via per-module Add buttons.
     Stored on the section element itself, cleared on colour change. */
  var bed = []; /* { productKey, sku, name, sizeLabel, qty, unitPrice, colourHandle, colourName } */

  function currentColour() {
    var h = section.getAttribute('data-sc-scalloped-handle');
    return col.colours.find(function(c) { return c.handle === h; }) || col.colours[0];
  }

  /* Recompute and render the bed summary */
  function renderSummary() {
    var items = document.getElementById('sc-sp-summary-items');
    var amount = document.getElementById('sc-sp-summary-amount');
    var btn = document.getElementById('sc-sp-add-bed');
    if (!items || !amount || !btn) return;
    if (bed.length === 0) {
      items.textContent = 'Nothing added yet.';
      amount.textContent = '£0';
      btn.disabled = true;
      btn.textContent = 'Add to basket';
      return;
    }
    var total = 0;
    var lines = bed.map(function(b) {
      total += b.unitPrice * b.qty;
      var qtyTxt = b.qty > 1 ? (b.qty + ' × ') : '';
      return qtyTxt + b.name + ' (' + b.sizeLabel + ')';
    });
    items.innerHTML = lines.join('<br>');
    amount.textContent = SC.fmt.gbp(total);
    btn.disabled = false;
    btn.textContent = 'Add ' + bed.length + ' item' + (bed.length > 1 ? 's' : '') + ' to basket';
  }

  /* Swap the entire colour — gallery, thumbs, copy, module prices, URL */
  function swapColour(handle) {
    var c = col.colours.find(function(x) { return x.handle === handle; });
    if (!c) return;
    section.setAttribute('data-sc-scalloped-handle', c.handle);

    /* Colour pills active state */
    section.querySelectorAll('[data-sc-sp-colour]').forEach(function(p) {
      p.classList.toggle('is-active', p.getAttribute('data-sc-sp-colour') === c.handle);
    });

    /* Update header colour name + copy + title */
    var nameEl = document.getElementById('sc-sp-colour-name');
    var copyEl = document.getElementById('sc-sp-colour-copy');
    var titleEl = document.getElementById('sc-sp-colour-title');
    var openEl = document.getElementById('sc-sp-opening');
    if (nameEl) nameEl.textContent = c.name;
    if (copyEl) copyEl.textContent = c.copy;
    if (titleEl) titleEl.textContent = c.name;

    /* Per-colour SEO + opening line — swap document.title, the meta
       description and the small italic opening line so each colour PDP
       reads, both in-page and in search/social, as its own page. */
    var seo = (SC.scallopedColourSEO && SC.scallopedColourSEO[c.handle]) || {};
    if (openEl && seo.opening) openEl.innerHTML = '<em>' + seo.opening + '</em>';
    if (seo.title) document.title = seo.title;
    if (seo.meta) {
      var metaEl = document.querySelector('meta[name="description"]');
      if (metaEl) metaEl.setAttribute('content', seo.meta);
    }

    /* Update hero image + thumbs */
    var hero = document.getElementById('sc-sp-hero');
    if (hero) {
      hero.src = c.heroImage;
      hero.alt = c.heroAlt;
    }
    var thumbsEl = document.getElementById('sc-sp-thumbs');
    if (thumbsEl) {
      thumbsEl.innerHTML = c.gallery.map(function(g, i) {
        return '<button class="sc-sp-thumb' + (i === 0 ? ' is-active' : '') + '" type="button" ' +
          'data-sc-sp-pick="' + g.src + '" data-sc-sp-alt="' + g.alt + '">' +
          '<img src="' + g.src + '" alt="' + g.alt + '" loading="lazy" />' +
        '</button>';
      }).join('');
    }

    /* Re-render every buy-module for the new colour */
    var modulesWrap = section.querySelector('.sc-sp-modules');
    if (modulesWrap) {
      modulesWrap.innerHTML = col.products.map(function(p) {
        return SC.components.scallopedBuyModule(p, c.handle);
      }).join('');
    }

    /* Re-render the bundles row for the new colour so prices and stock
       match. The bundles component renders the whole row, so we replace
       it wholesale. */
    var bundlesWrap = document.getElementById('sc-sp-bundles');
    if (bundlesWrap && SC.components.scallopedBundles) {
      var newRow = SC.components.scallopedBundles(c.handle);
      bundlesWrap.outerHTML = newRow;
    }

    /* Clear the bed-builder when colour changes — mixing colours in
       one summary would be confusing. The user is committing to a colour. */
    bed = [];
    renderSummary();

    /* Update the URL without reloading */
    if (window.history && window.history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('colour', c.handle);
      window.history.replaceState({}, '', u.toString());
    }

    /* Update accent colour CSS variable on the section so the whole
       page tints subtly to match the chosen colour */
    section.style.setProperty('--sp-accent', c.swatch);
    var ringTone = (c.textOn === 'dark') ? c.swatch : c.swatch;
    section.style.setProperty('--sp-accent-tone', ringTone);
  }

  /* Update a single module's price and selected size state */
  function updateModulePrice(moduleEl) {
    var productKey = moduleEl.getAttribute('data-sc-sp-product');
    var sizeKey = moduleEl.getAttribute('data-sc-sp-selected-size');
    var qty = parseInt(moduleEl.getAttribute('data-sc-sp-qty'), 10) || 1;
    var product = col.products.find(function(p) { return p.key === productKey; });
    if (!product) return;
    var c = currentColour();
    var matrix = product.matrix[c.handle] || {};
    var entry = matrix[sizeKey];
    var priceEl = moduleEl.querySelector('[data-sc-sp-module-price]');
    var addBtn = moduleEl.querySelector('[data-sc-sp-add]');
    if (entry && entry.price && entry.inStock) {
      if (priceEl) priceEl.textContent = SC.fmt.gbp(entry.price * qty);
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to bed';
      }
    } else {
      if (priceEl) priceEl.textContent = '—';
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Coming soon';
      }
    }
  }

  /* ============= EVENT WIRE-UP ============= */
  /* All events use delegation on the section, so dynamically re-rendered
     modules continue to respond after a colour swap. */
  section.addEventListener('click', function(e) {
    /* Colour pill */
    var colourBtn = e.target.closest('[data-sc-sp-colour]');
    if (colourBtn) {
      swapColour(colourBtn.getAttribute('data-sc-sp-colour'));
      return;
    }
    /* Thumb */
    var thumb = e.target.closest('[data-sc-sp-pick]');
    if (thumb) {
      var hero = document.getElementById('sc-sp-hero');
      if (hero) {
        hero.src = thumb.getAttribute('data-sc-sp-pick');
        hero.alt = thumb.getAttribute('data-sc-sp-alt') || '';
      }
      section.querySelectorAll('.sc-sp-thumb').forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }
    /* Size pill */
    var sizeBtn = e.target.closest('[data-sc-sp-size]');
    if (sizeBtn && !sizeBtn.disabled) {
      var mod = sizeBtn.closest('.sc-sp-module');
      mod.querySelectorAll('[data-sc-sp-size]').forEach(function(s) { s.classList.remove('is-active'); });
      sizeBtn.classList.add('is-active');
      mod.setAttribute('data-sc-sp-selected-size', sizeBtn.getAttribute('data-sc-sp-size'));
      updateModulePrice(mod);
      return;
    }
    /* Qty controls */
    var qtyInc = e.target.closest('[data-sc-sp-qty-inc]');
    var qtyDec = e.target.closest('[data-sc-sp-qty-dec]');
    if (qtyInc || qtyDec) {
      var modQ = (qtyInc || qtyDec).closest('.sc-sp-module');
      var input = modQ.querySelector('[data-sc-sp-qty-input]');
      var current = parseInt(modQ.getAttribute('data-sc-sp-qty'), 10) || 1;
      var next = qtyInc ? current + 1 : Math.max(1, current - 1);
      modQ.setAttribute('data-sc-sp-qty', next);
      input.value = next;
      updateModulePrice(modQ);
      return;
    }
    /* Bundle: add the full set in one tap. Goes straight to the cart;
       skips the bed-builder summary because the bundle IS the choice. */
    var bundleBtn = e.target.closest('[data-sc-bundle-add]');
    if (bundleBtn && !bundleBtn.disabled) {
      var bundleKey = bundleBtn.getAttribute('data-sc-bundle-add');
      var bundle = (SC.scallopedBundles || []).find(function(b) { return b.key === bundleKey; });
      if (!bundle) return;
      var c = currentColour();
      var pushed = 0;
      bundle.items.forEach(function(line) {
        var product = col.products.find(function(p) { return p.key === line.productKey; });
        if (!product) return;
        var sizeKey = line.size || product.sizesOrder[0];
        var entry = (product.matrix[c.handle] || {})[sizeKey];
        if (!entry || !entry.inStock) return;
        SC.cart.addItem({
          productHandle: 'scalloped-' + c.handle + '-' + line.productKey,
          rangeName: c.name + ' Scalloped ' + product.name,
          rangeKey: 'scalloped',
          size: line.sizeLabel,
          config: { sku: entry.sku, colour: c.name, bundle: bundle.key },
          configSummary: [
            { label: 'Colour', value: c.name },
            { label: 'Size',   value: line.sizeLabel },
            { label: 'Qty',    value: String(line.qty) },
            { label: 'Part of', value: bundle.name + ' bundle' }
          ],
          price: entry.price * line.qty,
          image: c.heroImage
        });
        pushed += 1;
      });
      /* Visual confirmation */
      if (pushed > 0) {
        bundleBtn.textContent = '✓ Added';
        bundleBtn.classList.add('is-confirmed');
        setTimeout(function() {
          bundleBtn.textContent = 'Add this bundle';
          bundleBtn.classList.remove('is-confirmed');
        }, 1400);
        if (SC.cart && SC.cart.openDrawer) SC.cart.openDrawer();
      }
      return;
    }
    /* Add to bed (per module) */
    var addBtn = e.target.closest('[data-sc-sp-add]');
    if (addBtn && !addBtn.disabled) {
      var modA = addBtn.closest('.sc-sp-module');
      var productKey = modA.getAttribute('data-sc-sp-product');
      var sizeKey = modA.getAttribute('data-sc-sp-selected-size');
      var qty = parseInt(modA.getAttribute('data-sc-sp-qty'), 10) || 1;
      var product = col.products.find(function(p) { return p.key === productKey; });
      if (!product) return;
      var c = currentColour();
      var entry = (product.matrix[c.handle] || {})[sizeKey];
      if (!entry) return;
      bed.push({
        productKey: productKey,
        sku: entry.sku,
        name: c.name + ' Scalloped ' + product.name,
        sizeLabel: product.sizes[sizeKey].label,
        qty: qty,
        unitPrice: entry.price,
        colourHandle: c.handle,
        colourName: c.name
      });
      renderSummary();
      /* Visual confirmation */
      addBtn.textContent = '✓ Added';
      addBtn.classList.add('is-confirmed');
      setTimeout(function() {
        addBtn.textContent = 'Add another';
        addBtn.classList.remove('is-confirmed');
      }, 1400);
      return;
    }
    /* Complete the bed → push to SC.cart */
    var bedBtn = e.target.closest('#sc-sp-add-bed');
    if (bedBtn && !bedBtn.disabled) {
      bed.forEach(function(b) {
        SC.cart.addItem({
          productHandle: 'scalloped-' + b.colourHandle + '-' + b.productKey,
          rangeName: b.name,
          rangeKey: 'scalloped',
          size: b.sizeLabel,
          config: { sku: b.sku, colour: b.colourName },
          configSummary: [
            { label: 'Colour', value: b.colourName },
            { label: 'Size',   value: b.sizeLabel },
            { label: 'Qty',    value: String(b.qty) }
          ],
          price: b.unitPrice * b.qty,
          image: currentColour().heroImage
        });
      });
      bed = [];
      renderSummary();
      if (SC.cart && SC.cart.openDrawer) SC.cart.openDrawer();
    }
  });
};
/* ============================================================
   PAGE-LEVEL HELPERS
   Wires everything together for a given page.
   ============================================================ */
SC.page = SC.page || {};
SC.page.boot = function(opts) {
  opts = opts || {};
  // Top of page: skip if Liquid header section is already rendered
  var topSlot = document.getElementById('sc-top');
  if (topSlot && topSlot.style.display !== 'none' && !topSlot.innerHTML.trim()) {
    topSlot.innerHTML =
      SC.components.topbar() +
      (opts.trade ? SC.components.headerTrade() : SC.components.header({ current: opts.current }));
  }
  // Footer: skip if Liquid footer section is already rendered
  var footerSlot = document.getElementById('sc-bottom');
  if (footerSlot) {
    // Only render Nadia and demo banner (footer is now a Liquid section)
    var hasLiquidFooter = document.querySelector('.sc-footer');
    if (hasLiquidFooter) {
      footerSlot.innerHTML =
        SC.components.nadiaWidget();
    } else {
      footerSlot.innerHTML =
        SC.components.footer() +
        SC.components.nadiaWidget();
    }
  }
  // Carousel arrows: scroll the matching carousel left/right by ~one card width
  document.addEventListener('click', function(e) {
    var prev = e.target.closest('[data-sc-carousel-prev]');
    var next = e.target.closest('[data-sc-carousel-next]');
    if (!prev && !next) return;
    var key = (prev || next).getAttribute(prev ? 'data-sc-carousel-prev' : 'data-sc-carousel-next');
    var carousel = document.querySelector('[data-sc-carousel="' + key + '"]');
    if (!carousel) return;
    var firstCard = carousel.firstElementChild;
    var step = firstCard ? firstCard.getBoundingClientRect().width + 20 : 300;
    carousel.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
  });

  /* Site-wide add-to-basket from a Portmeirion bestseller card.
     Idempotent: the guard flag stops double-binding when boot runs
     more than once (e.g. dev hot-reload). The listener also stops
     propagation so the card's parent <a> doesn't navigate to the
     PDP at the same moment the basket pops out. */
  if (!SC._bagBound) {
    SC._bagBound = true;
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-sc-pin-bag]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute('data-sc-pin-bag');
      /* Resolve the product. Look in the Portmeirion list first;
         when bed linen and JL tiles wire up the same way they can
         register their own resolver here. */
      var product = null;
      if (SC.portmeirionBestsellers) {
        product = SC.portmeirionBestsellers.find(function(p) { return p.id === id; });
      }
      if (!product || !SC.cart) return;
      /* Resolve the image URL via the same map the card uses */
      var imgs = (SC.images && SC.images.portmeirionBestsellers) || {};
      var entry = imgs[product.image] || {};
      SC.cart.addItem({
        productHandle: product.handle,
        rangeName:     product.range,
        rangeKey:      product.id,
        size:          '',
        config:        { collection: product.collection },
        configSummary: [product.fabric],
        price:         product.priceFrom,
        image:         entry.url || null
      });
      /* Visual feedback. Two layers:
         (1) The button now lives in its "is-in-cart" state, with the
             terracotta fill, the tick icon, and a count badge if there
             are more than one of this product in the basket. This is
             persistent — the customer can see at a glance which pieces
             they've already added without opening the drawer.
         (2) A short pop animation on the button at the moment of add
             to confirm the click registered. */
      btn.classList.add('is-popped');
      setTimeout(function() { btn.classList.remove('is-popped'); }, 320);
      /* Re-sync all bag buttons on the page (this button included).
         The sc:cart-changed event fires from sc-cart.js writeItems(). */
      if (SC.cart.openDrawer) SC.cart.openDrawer();
    });
  }

  /* Cart-change listener. Whenever the cart writes (add, remove,
     quantity change from anywhere — drawer, cart page, another tab),
     we walk every pin-bag button on the page and refresh its state.
     Idempotency-guarded so the listener is only attached once per page. */
  if (!SC._bagSyncBound) {
    SC._bagSyncBound = true;
    var syncAllBagButtons = function() {
      if (!SC.cart || !SC.cart.getQuantityOf) return;
      document.querySelectorAll('[data-sc-pin-bag]').forEach(function(btn) {
        var id = btn.getAttribute('data-sc-pin-bag');
        var qty = SC.cart.getQuantityOf(id);
        var inCart = qty > 0;
        btn.classList.toggle('is-in-cart', inCart);
        var countSpan = btn.querySelector('[data-sc-pin-bag-count]');
        if (countSpan) countSpan.textContent = qty > 1 ? qty : '';
        /* Refresh aria-label so screen readers hear the current state */
        var rangeMatch = btn.getAttribute('aria-label') || '';
        var rangeName = (rangeMatch.match(/Add (?:another )?(.*?) to basket/) || [])[1] || '';
        if (rangeName) {
          btn.setAttribute('aria-label',
            inCart
              ? 'Add another ' + rangeName + ' to basket (currently ' + qty + ' in basket)'
              : 'Add ' + rangeName + ' to basket'
          );
        }
      });
    };
    document.addEventListener('sc:cart-changed', syncAllBagButtons);
    /* Also sync on page show (e.g. coming back via the browser back
       button), since the cart might have changed in another tab. */
    window.addEventListener('pageshow', syncAllBagButtons);
  }

  /* Wire site-wide favourites bindings if sc-gallery.js is loaded.
     Turns the header heart into the favourites entry point on every page
     and shows the count badge. */
  if (SC.gallery && SC.gallery.bindSiteWide) {
    SC.gallery.bindSiteWide();
  }
};

/* ============================================================
   Account page component. Renders the list of saved builds plus
   sign-in / sign-out controls. Reads from SC.account API.
   ============================================================ */

/* Wire up the account page: signin triggers, signout, delete, copy. */

function formatBuildDate(iso) {
  try {
    var d = new Date(iso);
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  } catch (e) { return ''; }
}
function escapeHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function escapeAttr(s) { return escapeHtml(s); }

/* ============================================================
   Cart page component: full review-and-checkout page for the bag.
   Mounts into cart.html via SC.components.bindCartPage('cart-mount').
   ============================================================ */
SC.components.cartPage = function() {
  if (!(window.SC && SC.cart)) {
    return '<section class="sc-section"><div class="sc-container"><p>Cart module not loaded.</p></div></section>';
  }
  var items = SC.cart.getItems();
  var subtotal = SC.cart.getSubtotal();
  var count = SC.cart.getCount();

  /* Empty state */
  if (!items.length) {
    return '' +
      '<section class="sc-section sc-cart-page">' +
        '<div class="sc-container">' +
          '<div class="sc-account-empty">' +
            '<strong>Your basket is empty.</strong>' +
            'Configure a sofa and click <em>Add to basket</em> to start a build.' +
            '<div style="margin-top:20px;">' +
              '<a class="sc-btn sc-btn-primary" href="product-coco-2-5.html">Start with Coco</a>' +
              '<a class="sc-btn sc-btn-text" href="index.html#collection" style="margin-left:14px;">See all six ranges</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</section>';
  }

  var itemsHtml = items.map(SC.cart._renderItem).join('');
  return '' +
    '<section class="sc-section sc-cart-page">' +
      '<div class="sc-container">' +
        '<div class="sc-cart-page-head">' +
          '<div>' +
            '<div class="sc-eyebrow">Your basket</div>' +
            '<h1>' + count + ' item' + (count === 1 ? '' : 's') + ' to review.</h1>' +
          '</div>' +
        '</div>' +
        '<div class="sc-cart-page-grid">' +
          '<div class="sc-cart-page-items">' + itemsHtml + '</div>' +
          '<aside class="sc-cart-page-summary">' +
            '<h2 class="sc-cart-page-summary-title">Order summary</h2>' +
            '<div class="sc-cart-page-summary-row">' +
              '<span>Subtotal</span>' +
              '<span>£' + subtotal.toLocaleString('en-GB') + '</span>' +
            '</div>' +
            '<div class="sc-cart-page-summary-row">' +
              '<span>UK delivery</span>' +
              '<span>Included</span>' +
            '</div>' +
            '<div class="sc-cart-page-summary-row sc-cart-page-summary-total">' +
              '<span>Total</span>' +
              '<span>£' + subtotal.toLocaleString('en-GB') + '</span>' +
            '</div>' +
            '<p class="sc-cart-page-summary-meta">' +
              'Lead time: around 8 weeks from order, often sooner with a stock base. ' +
              'Two-person delivery team included.' +
            '</p>' +
            '<button class="sc-btn sc-btn-primary sc-cart-page-checkout" type="button" data-sc-cart-checkout>Proceed to checkout</button>' +
            '<a class="sc-btn sc-btn-text sc-cart-page-continue" href="index.html#collection">Continue browsing</a>' +
          '</aside>' +
        '</div>' +
      '</div>' +
    '</section>';
};

SC.components.bindCartPage = function(mountId) {
  var root = document.getElementById(mountId);
  if (!root) return;

  function rerender() {
    root.innerHTML = SC.components.cartPage();
    wire();
  }

  function wire() {
    /* Remove buttons */
    root.querySelectorAll('[data-sc-cart-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var id = btn.getAttribute('data-sc-cart-remove');
        SC.cart.removeItem(id);
        rerender();
      });
    });
    /* Quantity inputs */
    root.querySelectorAll('[data-sc-cart-qty]').forEach(function(input) {
      input.addEventListener('change', function() {
        var id = input.getAttribute('data-sc-cart-qty');
        var qty = parseInt(input.value, 10) || 0;
        SC.cart.updateQuantity(id, qty);
        rerender();
      });
    });
    /* Checkout: in this test version, show a placeholder note explaining
       where Shopify would take over. */
    var checkoutBtn = root.querySelector('[data-sc-cart-checkout]');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function() {
        var note = document.createElement('div');
        note.className = 'sc-cart-checkout-note';
        note.innerHTML = '<strong>This is where Shopify checkout would take over.</strong> ' +
          'In the live site this button posts the basket to /cart and redirects to the secure checkout. ' +
          'For this test version, the cart is held in your browser only.';
        checkoutBtn.parentNode.insertBefore(note, checkoutBtn);
        checkoutBtn.disabled = true;
        checkoutBtn.textContent = 'Demo only';
      });
    }
  }

  rerender();
};
